import {LOCALES} from './locales';

export const messages = {
    [LOCALES.ENGLISH]: {
        home: 'Home',
        user_content: 'User specific information will be shown here',
        users: 'Users',
        user: 'User',
        patients: 'Patients',
        first_name: 'First name',
        surname: 'Middle name',
        last_name: 'Last name',
        phone: 'Phone',
        phone_label: 'Phone (+359)',
        phone_label_two: 'Phone',
        dashboard: 'Dashboard',
        logout: 'Sign out',
        logoutConfirm: 'Are you sure you want to sign out?',
        settings: 'Settings',
        register: 'Register',
        components: 'Components',
        name: 'Name',
        lastAppointment: 'Last appointment',
        nextAppointment: 'Next appointment',
        search: 'Search',
        sortBy: 'Sort by',
        filterBy: 'Filter by',
        order: 'Order',
        ascending: 'Ascending',
        descending: 'Descending',
        filter: 'Filter',
        resetFilter: 'Reset filter',
        diagnose: 'Condition',
        registeredOn: 'Registered on',
        email: 'Email',
        town: 'Town',
        country: 'Country',
        account_status: 'Account status',
        addressOne: 'Address 1',
        addressTwo: 'Address 2',
        notes: 'Notes',
        birth_date: 'Birth Date',
        gender: 'Gender',
        source: 'Source',
        source_name: 'Source name',
        last_hour: 'Last appointment',
        next_hour: 'Next appointment',
        doctors: 'Dentists',
        personal_information: 'Personal information',
        registration: 'Registration',
        contact: 'Contact details',
        cancel: 'Cancel',
        save: 'Save',
        copied: 'Copied',
        payments: 'Payments',
        paid: 'Paid',
        obligations: 'Obligations',
        address: 'Address',
        edit: 'Edit',
        required_field: 'The field is required.',
        clinic_name_min_length: 'Clinic name must be at least 2 characters.',
        invalid_tooth_position: 'Invalid tooth position.',
        invalid_email: 'Invalid email.',
        gender_male: 'Male',
        gender_female: 'Female',
        main_information: 'Main information',
        medical_history: 'Diagnosis & Treatment',
        medicalHistoryLabel: 'Diagnosis & Treatment',
        treatment: 'Treatment',
        treatments: 'Treatments',
        finances: 'Finances',
        upcoming_feature: 'Upcoming feature',
        photos: 'Photos',
        back: 'Back',
        add: 'Add',
        add_patient: 'Add patient',
        unsaved_changes: 'There are unsaved changes. Are you sure you want to continue without saving?',
        confirm: 'Confirm',
        invalid_phone_number: 'Invalid phone number.',
        invalid_phone_e164: 'Phone must be in E.164 format (e.g. +359888123456)',
        invalid_field: 'Invalid field.',
        years_old: 'years old',
        year_old: 'year old',
        levs: 'EUR',
        success_message: 'Your changes were successfully saved.',
        not_available: 'N/A',
        nzis_confirm: 'Confirm and send data to NHIS',
        unexpected_error: 'An error occurred.',
        complete_bot_verification: 'Please complete bot verification.',
        registration_completed: 'Registration was successfully completed.',
        x_ray_photos: 'X-Ray photos',
        patient_photos: 'Patient photos',
        choose_image_category: 'Choose image category',
        category: 'Category',
        choose: 'Select ',
        drag_or_choose: 'Select or drag photos',
        delete_text: 'Delete',
        move_text: 'Move',
        confirmation_text: 'Are you sure you want to do the following action?',
        delete_patient: 'Delete patient',
        medical_staff: 'Staff',
        egn: 'PIN',
        add_medical_staff: 'Add staff member',
        update_medical_staff: 'Edit staff member',
        registration_error: 'Registration failed',
        specialisation: 'Specialization',
        uin: 'UIN',
        work_time: 'Work time',
        dentist: 'Dentist',
        all_loaded: 'All data loaded.',
        loading: 'Loading...',
        no_data: 'No data',
        upload_avatar: 'Upload profile picture',
        organizations: 'Organizations',
        email_queue: 'Email Queue',
        add_organization: 'Add organization',
        naming: 'Name',
        parent_organization: 'Parent organization',
        organization_conflict: 'Organization already exists',
        organization_details: 'Organization details',
        edit_organization: 'Edit organization',
        create_organization: 'Create organization',
        assistant: 'Assistant',
        duplicate_email: 'Email is already taken',
        letters_only_field: 'The field can contain letters only.',
        letters_and_numbers_only: 'The field can contain letters and numbers only.',
        digits_only_field: 'The field can contain digits only.',
        discount_too_large: 'Discount cannot exceed 100%',
        patient: 'Patient',
        company: 'Company',
        social_network: 'Social Network',
        calendar: 'Calendar',
        clinic: 'Clinic',
        all_clinics: 'All clinics',
        select_clinic: 'Select clinic',
        clinic_required: 'Please select a clinic.',
        googleCredentials: 'Google Credentials',
        googleCalendar: 'Google Calendar',
        googleCalendarDescription: 'Connect your Google Calendar to sync appointments. Dentobook is the single source of truth - appointments created here will be pushed to Google Calendar. Changes in Google Calendar will not sync back.',
        connectGoogleCalendar: 'Connect Google Calendar',
        connected: 'Connected',
        notConnected: 'Not Connected',
        googleAccount: 'Google Account',
        lastSync: 'Last Sync',
        syncError: 'Sync Error',
        syncNow: 'Sync Now',
        disconnect: 'Disconnect',
        howToConnect: 'How to Connect',
        googleCalendarConnectInstructions: 'Click the button below to connect your Google Calendar account',
        googleCalendarStep1: 'Click "Connect Google Calendar"',
        googleCalendarStep2: 'Sign in with your Google account',
        googleCalendarStep3: 'Grant permissions to sync your calendar',
        confirmDisconnectGoogleCalendar: 'Are you sure you want to disconnect Google Calendar? This will stop syncing appointments.',
        googleCalendarConnectedSuccess: 'Google Calendar Connected Successfully!',
        checkActivityLogForDetails: 'Check your Activity Log for details',
        connectedAccount: 'Connected account',
        closingWindow: 'Closing this window...',
        youCanCloseThisTab: 'You can close this tab now.',
        googleCalendarConnectionFailed: 'Google Calendar Connection Failed',
        pleaseCloseAndTryAgain: 'Please close this window and try again.',
        youCanCloseThisTabAndTryAgain: 'You can close this tab and try again from the settings page.',
        googleCalendarDisconnected: 'Google Calendar disconnected successfully',
        syncCompleted: 'Sync Completed',
        initialSyncCompleted: 'Initial Import Completed',
        eventsSynced: 'events synced',
        eventsImported: 'events imported',
        eventsSkipped: 'events skipped',
        eventsFailed: 'events failed',
        general: 'General',
        appointments: 'Appointments',
        choose_appointment: 'Choose appointment',
        milkTeeth: 'Deciduous teeth ',
        permTeeth: 'Permanent',
        description: 'Description',
        date: 'Date',
        fromDate: 'From date',
        position: 'Position',
        condition: 'Condition',
        nzis_condition: 'NHIS naming',
        nzis_treatment_label: 'NHIS treatment',
        nzis_condition_label: 'NHIS condition',
        add_condition: 'Add condition',
        add_condition_title: 'Add condition',
        quick_status: 'Quick status',
        quick_status_more: 'More options',
        quick_status_clear: 'Clear status',
        quick_status_not_configured: 'Status is not configured',
        quick_status_save_failed: 'Could not save the tooth status. Please try again.',
        add_appointment: 'Add appointment',
        edit_appointment: 'Edit appointment',
        tooth_status: 'Tooth status',
        tooth_status_quick_help: 'Tip: while hovering a tooth, press a letter shortcut (C, P, G, R, O, E, K, X, F) to apply a status instantly, click the quick buttons in the palette above the tooth, or click the tooth itself to open the full editor for notes and details.',
        treatment_plan: 'Treatment',
        procedure: 'Procedure',
        dental_doctor: 'Dentist',
        sum: 'Price',
        status: 'Status',
        treatment_label: 'Treatment',
        overall_price: 'Price',
        price: 'Price',
        discount: 'Discount (%)',
        discounts: 'Discount',
        discount_label: 'Discount',
        overall_laboratory_price: 'Laboratory expense ',
        procedures: 'Procedures',
        laboratory_price: 'Laboratory expense ',
        currency: 'Currency',
        vat_excluded: 'All amounts exclude VAT',
        add_procedure: 'Add procedure',
        add_plan_title: 'Add treatment',
        all_fields_required: 'Please fill in all required fields.',
        fill_all_required_fields: 'Please fill in all required fields.',
        treatment_of: 'Тreatment of',
        in_progress: 'In Progress',
        canceled: 'Canceled',
        done: 'Done',
        offered: 'Offered',
        qr_code_generator: 'QR code generator',
        manual_input: 'Manual input',
        qr_code_generator_description: 'Select this option if you want the patient to enter their information',
        manual_input_description: 'Select this option if you want to manually enter all patient information',
        general_medical_history: 'General medical history',
        general_illness_suffering: 'Are you suffering from any general illness?',
        medications_taking: ' Are you taking any medications? ',
        medications: 'Medications',
        allergy_having: 'Do you have any allergies? (food, medications, etc.)',
        allergies: 'Allergies',
        pregnancy_planning: 'To the ladies: Are you planning a pregnancy?',
        yes_ans: 'Yes',
        no_ans: 'No',
        pregnant_ans: 'I am pregnant',
        nursing_question: 'To the ladies: Are you currently breastfeeding?',
        anamensis_title: 'Oral history and oral hygiene habits',
        anesthetic_question: ' Have you had a local anesthetic for dental treatment?',
        higiene_question: 'Do you have your tartar and plaque cleaned regularly by your dentist?',
        social_anamnezis: 'Social history',
        dentist_visit_question: 'How often do you visit the dentist?',
        dentist_last_visit_question: 'When was the last dental visit?',
        fear_question: 'Do you experience fear of dental treatment?',
        fear_ans: 'Sometimes (depends on the procedure)',
        dentist_visit_ans1: 'At least twice a year',
        dentist_visit_ans2: 'Once a year with prevention purpose',
        dentist_visit_ans3: 'Less than once a year',
        dentist_visit_ans4: 'Only when I have a problem',
        illnesses: 'Diseases',
        medical_history_info: 'Illnesses, allergies, and medications are managed at the organization level. You can modify, add, and delete them. If you delete all of them, you will be able to add your own when creating a patient.',
        create_button_text: 'Create',
        reason: 'Reason',
        total: 'Total',
        procedure_calculated_in_treatment: 'The procedure is calculated in the treatment',
        procedure_not_calculated_in_treatment: 'The procedure is charged extra',
        totalTwo: 'Total',
        treatmentPriceTooLow: 'The price of the treatment cannot be lower than the sum of the procedures',
        anesthetic_question2: 'Have you ever had a local anesthetic for dental treatment?',
        is_health_insured_question: 'Does the patient have additional health insurance?',
        last_visit_patient_quesiton: 'When was the patient\'s last dental visit?',
        frequency_quesiton: 'How often does the patient visit the dentist?',
        is_patient_afraid_question: 'Does the patient experience fear of dental treatment?',
        smoker_question: 'Is the patient a smoker?',
        yes: 'Yes',
        no: 'No',
        sometimes: 'Sometimes',
        twice_a_year: 'Twice a year',
        once_a_year: 'Once a year',
        rarely: 'Rarely',
        only_when_necessary: 'Only when necessary',
        insurance_question: 'Do you have additional health insurance?',
        insurer: 'Insurer',
        smoker_question2: 'Are you a smoker?',
        activity_log: 'Activity log',
        action: 'Action',
        today: 'Today',
        details: 'Details',
        role: 'Role',
        PLATFORM_ADMINISTRATOR: 'Platform Admin',
        CLINIC_ADMIN: 'Organization Administrator',
        MEDICAL_DOCTOR: 'Doctor',
        DENTAL_TECHNICIAN: 'Dental Technician',
        MEDICAL_ASSISTANT: 'Assistant',
        RECEPTIONIST: 'Receptionist',
        PATIENT: 'Patient',
        company_data: 'Company data',
        logo: 'Logo',
        uic: 'UIC',
        vat: 'VAT number',
        rzi_practice_code: 'RHI practice code',
        accountable_person: 'Аccountable person',
        conditions: 'Conditions',
        action_LOGIN: 'Login',
        action_LOGOUT: 'Logout',
        action_GOOGLE_CALENDAR_CONNECTED: 'Connected Google Calendar',
        action_GOOGLE_CALENDAR_DISCONNECTED: 'Disconnected Google Calendar',
        action_GOOGLE_CALENDAR_SYNCED: 'Synced Google Calendar',
        action_CREATE_PATIENT: 'Created patient',
        action_UPDATE_PATIENT: 'Updated patient',
        action_DELETE_PATIENT: 'Deleted patient',
        action_CREATE_PATIENT_PHOTO: 'Created patient photo',
        action_UPDATE_PATIENT_PHOTO: 'Updated patient photo',
        action_DELETE_PATIENT_PHOTO: 'Deleted patient photo',
        action_CREATE_PATIENT_MEDICAL_HISTORY: 'Created patient medical history',
        action_UPDATE_PATIENT_MEDICAL_HISTORY: 'Updated patient medical history',
        action_DELETE_PATIENT_MEDICAL_HISTORY: 'Deleted patient medical history',
        action_CREATE_USER: 'Created user',
        action_UPDATE_USER: 'Updated user',
        action_DELETE_USER: 'Deleted user',
        action_CREATE_ORGANIZATION: 'Created organization',
        action_UPDATE_ORGANIZATION: 'Updated organization',
        action_DELETE_ORGANIZATION: 'Deleted organization',
        action_CREATE_CALENDAR_EVENT: 'Created calendar event',
        action_UPDATE_CALENDAR_EVENT: 'Updated calendar event',
        action_DELETE_CALENDAR_EVENT: 'Deleted calendar event',
        action_CREATE_MEDICAL_STAFF: 'Created medical staff',
        action_UPDATE_MEDICAL_STAFF: 'Updated medical staff',
        action_DELETE_MEDICAL_STAFF: 'Deleted medical staff',
        action_CREATE_DENTAL_OFFICE: 'Created dental office',
        action_UPDATE_DENTAL_OFFICE: 'Updated dental office',
        action_DELETE_DENTAL_OFFICE: 'Deleted dental office',
        action_CREATE_PROCEDURE: 'Created procedure',
        action_UPDATE_PROCEDURE: 'Updated procedure',
        action_DELETE_PROCEDURE: 'Deleted procedure',
        action_CREATE_TREATMENT: 'Created treatment',
        action_UPDATE_TREATMENT: 'Updated treatment',
        action_DELETE_TREATMENT: 'Deleted treatment',
        action_CREATE_APPOINTMENT: 'Created appointment',
        action_UPDATE_APPOINTMENT: 'Updated appointment',
        action_DELETE_APPOINTMENT: 'Deleted appointment',
        action_CREATE_CONDITION: 'Created condition',
        action_UPDATE_CONDITION: 'Updated condition',
        action_DELETE_CONDITION: 'Deleted condition',
        action_CREATE_PROCEDURE_TREATMENT: 'Created procedure treatment',
        action_UPDATE_PROCEDURE_TREATMENT: 'Updated procedure treatment',
        action_DELETE_PROCEDURE_TREATMENT: 'Deleted procedure treatment',
        action_CREATE_STATUS_TOOTH: 'Created tooth status',
        action_UPDATE_STATUS_TOOTH: 'Updated tooth status',
        action_DELETE_STATUS_TOOTH: 'Deleted tooth status',
        action_CREATE_TOOTH: 'Created tooth',
        action_UPDATE_TOOTH: 'Updated tooth',
        action_DELETE_TOOTH: 'Deleted tooth',
        action_CREATE_TREATMENT_TOOTH: 'Created tooth treatment',
        action_UPDATE_TREATMENT_TOOTH: 'Updated tooth treatment',
        action_DELETE_TREATMENT_TOOTH: 'Deleted tooth treatment',
        action_CREATE_INVOICE: 'Created invoice',
        action_UPDATE_INVOICE: 'Updated invoice',
        action_CREATE_PROFORMA_INVOICE: 'Created proforma invoice',
        action_UPDATE_PROFORMA_INVOICE: 'Updated proforma invoice',
        organization_settings: 'Organization',
        website: 'Website',
        clinics: 'Clinics',
        abbreviation: 'Аbbreviation',
        color: 'Color',
        invalid_vat_number: 'Invalid VAT number.',
        invalid_uic_number: 'Invalid UIC number.',
        invalid_rzi_practice_code: 'Invalid RHI practice code.',
        create: 'Create',
        update: 'Update',
        delete: 'Delete',
        before: 'Before',
        after: 'After',
        createdAt: 'Created on',
        updatedAt: 'Updated on',
        start: 'Start',
        end: 'End',
        id: 'Id',
        title: 'Title',
        userId: 'User Id',
        dentalClinic: 'Clinic',
        doctor: 'Doctor',
        difference: 'Difference',
        asc: 'Ascending',
        desc: 'Descending',
        addClinic: 'Add clinic',
        enterClinicName: 'Enter clinic name',
        editClinic: 'Edit clinic',
        editStatus: 'Edit status',
        enterStatusName: 'Enter status name',
        enterStatusAbbreviation: 'Enter status abbreviation ',
        enterStatusColor: 'Enter status color',
        statusDeleteConfirmation: 'Are you sure you want to delete this status?',
        deleteStatus: 'Delete status',
        deleteClinic: 'Delete clinic',
        clinic_deleted: 'Clinic deleted successfully',
        deleted_clinic: 'Deleted clinic',
        clinicDeleteConfirmation: 'Are you sure you want to delete this clinic?',
        clinicDeleteWarningTitle: 'This clinic will be hidden from all lists. Existing appointments linked to it will show "Deleted clinic" instead of the clinic name.',
        clinicDeleteWarningHint: 'To keep history readable, consider renaming the clinic to "(Archived) Clinic Name" instead of deleting.',
        clinicsInfoMessage: 'Here you can manage your physical clinic locations with their addresses. These locations can be selected when creating calendar appointments and will be displayed in patient booking notifications.',
        clinicTimezone: 'Timezone',
        clinicTimezoneHint: 'Used for reminders and quiet hours.',
        addStatus: 'Add status',
        enterTreatmentName: 'Enter treatment name',
        enterTreatmentPrice: 'Enter treatment price',
        editTreatment: 'Edit activity',
        tratmentDeleteConfirmation: "Are you sure you want to delete this activity?",
        deleteTreatment: 'Delete activity',
        addProcedure: 'Add procedure',
        enterProcedureName: 'Enter procedure name',
        enterProcedurePrice: 'Enter procedure price',
        editProcedure: 'Edit procedure',
        editProcedureName: 'Edit procedure name',
        editProcedurePrice: 'Edit procedure price',
        deleteProcedure: 'Delete procedure',
        procedureDeleteConfirmation: 'Are you sure you want to delete this procedure?',
        enterIllnessName: "Enter illness name",
        editIllness: 'Edit illness',
        addIllness: 'Add illness',
        illnessDeleteConfirmation: 'Are you sure you want to delete this Illness?',
        addAllergy: 'Add allergy',
        enterAllergyName: "Enter allergy name",
        editAllergy: 'Edit allergy',
        deleteAllergy: 'Delete allergy',
        deleteCalendarEvent: 'Delete event',
        allergyDeleteConfirmation: 'Are you sure you want to delete this allergy?',
        eventDeleteConfirmation: 'Are you sure you want to delete this event?',
        deleteMedication: 'Delete medication',
        medicationDeleteConfirmation: 'Are you sure you want to delete this medication?',
        addMedication: 'Add medication',
        enterMedicationName: "Enter medication name",
        editMedication: 'Edit medication',
        medication: 'Medication',
        illness: 'Illness',
        allergy: 'Allergy',
        deleteIllness: 'Delete illness',
        invalid_url: 'Page could not be found',
        link_expired: 'The link has expired.',
        successfully_registered: 'You have successfully registered',
        avatar_upload_error: 'There was a problem uploading your avatar',
        selectPatient: 'Select patient',
        selectPlaceholder: 'Select',
        selectPatientValidation: 'Please select a patient.',
        from: 'From',
        to: 'To',
        nzis_data_fail: 'There is a problem sending to NHIS.',
        nzis_data_success: 'The data was successfully sent to NHIS.',
        generalCalendar: 'General calendar',
        appointmentHour: 'Add an appointment',
        welcome: 'Hello',
        nextHours: 'Next appointments',
        statistics: 'Statistics',
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        saveNew: 'Sign new',
        toCalendar: 'To the calendar',
        dr: 'Dr.',
        proforma_create: 'Create proforma',
        invoice_create: 'Create invoice',
        paidFinance: 'Paid',
        unpaidFinance: 'Unpaid',
        totalPrice: 'Total',
        laboratory: 'Laboratory',
        due: 'Due',
        edit_patient: 'Edit patient',
        delete_appointment: 'Cancel  appointment',
        qr_description: 'Ask the patient to scan the QR code and complete the form. A personal device may be used',
        new_patient: 'New patient created successfully',
        patient_updated: 'The patient was updated successfully',
        medical_staff_created: 'Medical staff member created successfully',
        medical_staff_updated: 'Medical staff member updated successfully',
        deactivate: 'Deactivate',
        medical_staff_deactivated: 'Staff member deactivated successfully',
        medical_staff_already_deactivated: 'Staff member is already deactivated',
        remove_access: 'Remove access',
        access_removed: 'Access removed successfully',
        activate: 'Activate',
        medical_staff_activated: 'Staff member activated successfully',
        medical_staff_already_active: 'Staff member is already active',
        deactivate_medical_staff: 'Deactivate staff member',
        show_inactive: 'Show inactive',
        portal_access: 'Portal access',
        has_portal_access: 'Has portal access',
        no_portal_access: 'No portal access',
        grant_access: 'Grant access',
        revoke_access: 'Revoke access',
        access_granted: 'Portal access granted successfully',
        invite_sent_access: 'Invite sent — access will be active once the user registers',
        access_revoked: 'Portal access revoked successfully',
        grant_access_email_label: 'Email address for portal access',
        staff_already_has_access: 'Staff member already has portal access',
        staff_already_has_pending_invite: 'This email address already has a pending invitation in your organization',
        staff_linked_different_user: 'This staff member is linked to a different email address — revoke access first',
        staff_inactive_cannot_grant: 'Cannot grant access to an inactive staff member',
        staff_no_access_to_revoke: 'Staff member does not have portal access',
        invite_pending: 'Invite pending',
        resend_invite: 'Resend invite',
        invite_resent: 'Invite resent successfully',
        portal_access_description: 'Portal access lets this staff member log in to Dentobook to manage their schedule, patients, and appointments.',
        portal_access_info_none: "This staff member does not have portal access. Use 'Grant access' to send them an invitation email.",
        portal_access_info_pending: 'An invitation email has been sent. The staff member will gain access once they accept the invitation and complete registration.',
        portal_access_info_active: 'This staff member has full portal access. Revoking access will remove their login immediately.',
        needs_portal_access: 'Needs portal access',
        portal_access_invite_hint: "If enabled, we'll send an invitation email so this staff member can sign in.",
        email_required_for_portal_access: 'Email is required for portal access.',
        archived_treatment: 'Archived treatment',
        archived_condition: 'Archived condition',
        archived_doctor: 'Archived doctor (no longer in system)',
        inactive: 'inactive',
        email_invalid_format: 'Please enter a valid email address.',
        email_not_verified_title: 'Verify your email address',
        email_not_verified_subtitle: 'We sent a verification link to your email address. Please check your inbox and click the link to continue.',
        email_not_verified_resend: 'Resend verification email',
        email_not_verified_resend_success: 'Verification email sent. Please check your inbox.',
        email_not_verified_logout: 'Log out',
        verify_email_page_title: 'Email Verification',
        verify_email_success_title: 'Email verified!',
        verify_email_success_subtitle: 'Your email address has been successfully verified. You can now use your account.',
        verify_email_success_login: 'Go to login',
        verify_email_invalid_token: 'This verification link is invalid or has expired. Please request a new one.',
        verify_email_already_used: 'This verification link has already been used.',
        verify_email_check_inbox_subtitle: 'We sent a verification link to {email}. Please check your inbox.',
        verify_email_resend_countdown: 'Resend in {seconds}s',
        verify_email_wrong_email: 'Wrong email address?',
        verify_email_spam_hint: "If you don't see it, check your spam folder.",
        terms_not_accepted_title: 'Terms of Service',
        terms_not_accepted_subtitle: 'You must accept the Terms of Service to continue using Dentobook.',
        accept_invite_title: 'Accept Invitation',
        accept_invite_description: 'You have been invited to join',
        invite_expired: 'This invitation link has expired',
        invite_revoked: 'This invitation has been revoked',
        invite_already_accepted: 'This invitation has already been accepted',
        invite_invalid: 'Invalid or unrecognised invitation link',
        accepting_invite: 'Accepting invitation...',
        invite_accepted: 'Invitation accepted! Redirecting to login...',
        invite_switch_failed: 'Invitation accepted, but switching failed — go to the dashboard to continue',
        create_account_and_accept: 'Create account & accept',
        organization_updated: 'Organization updated successfully',
        here: 'here',
        show_all: 'Show all',
        notifications: 'Notifications',
        mark_all_read: 'Mark all as read',
        collapse: 'Collapse',
        profile: 'Profile',
        my_profile: 'My Profile',
        my_details: 'My details',
        memberships: 'Memberships',
        create_my_organization: 'Create my organization',
        profile_saved: 'Profile saved.',
        active_org: 'Active',
        create_another_organization: 'Create another organization',
        create_org_modal_hint: 'You\'ll become Organization Admin and can switch orgs from the top menu.',
        complete_profile_first: 'Please complete your first and last name before creating an organization.',
        invalid_image_format: 'The file format is invalid. Valid formats are: pdf, doc, docx, xls, xlsx, txt, csv, jpg, jpeg, png, gif, webp, bmp.',
        invalid_photo_format: 'The file format is invalid. Valid formats are: jpg, jpeg, png.',
        invalid_image_size: 'File size must not exceed 10 MB',
        invalid_photo_image_size: 'File size must not exceed 1 MB.',
        no_notifications: 'No new notifications',
        notif_appointment_confirmed: 'New appointment: {patient_name} on {date}',
        notif_appointment_rescheduled: 'Rescheduled: {patient_name} from {old_date} to {date}',
        notif_appointment_cancelled: 'Appointment cancelled: {patient_name} on {date}',
        notif_patient_deleted: 'Patient {patient_name} was deleted',
        notif_staff_deactivated: 'Staff member {staff_name} was deactivated',
        notif_staff_activated: 'Staff member {staff_name} was reactivated',
        freed_slot_flash: 'Time slot just freed up',
        endTime_error: 'End time must be after event start time.',
        event_select_alert: 'You cannot select a time in the past.',
        event_move_alert: 'You cannot schedule an event to a time in the past.',
        max_length_250: 'Maximum lenght is 250 characters.',
        max_length_150: 'Maximum lenght is 250 characters.',
        invalid_address: 'Invalid address.',
        invalid_town: 'Invalid city.',
        invalid_country: 'Invalid country.',
        close: 'Close',
        no_selected_appointment: 'Please select an appointment.',
        iban: 'IBAN',
        invoiceNumber: 'Starting invoice number',
        proformaInvoiceNumber: 'Starting proforma invoice number',
        duplicated_appointment: 'Appointment with the same name already exists.',
        nzis: 'NHIS',
        from_date: 'From date',
        unsent: 'Unsent',
        sent: 'Sent',
        send_to_nzis: 'Send to NHIS',
        all_data: 'Patients with unsent data',
        medical_prescriptions: 'Medical prescriptions',
        excuse_notes: 'Excuse notes',
        operations: 'Operations',
        operation: 'Operation',
        healthArea: 'Health area',
        healthRegion: 'Health region',
        ekkatte: 'EKATTE',
        specialization1: 'General dental practitioner',
        specialization2: 'Paediatric dentistry',
        specialization3: 'Oral Surgery',
        specialization4: 'Maxillofacial Surgery / Dental, Oral and Maxillofacial Surgery',
        rhif: 'RHIF',
        specialisation_code: 'Specialisation code',
        all: 'All',
        ambulatory_sheet: 'Ambulatory sheet',
        ambulatory_sheet_fail: 'There was a problem generating the ambulatory sheet.',
        nzis_unavailable: 'NHIS is temporarily unavailable. Please check your connection or try again later.',
        diagnose_label: 'Condition',
        tooth: 'Tooth',
        operation_code: 'Operation code',
        unsent_single: 'Unsent',
        sent_single: 'Sent',
        select_at_least_one_item: 'Please select at least one line.',

        ambulatory_list: 'Ambulatory list - form (Bulgaria)',
        organization_documents: 'Organization Documents',
        platform_forms: 'Platform Forms',
        informed_consent: 'Informed consent',
        nhis_consent: 'NHIS - Patient consent to access their EHR',
        documents: 'Documents',
        profession: 'Profession',
        national_id: 'National ID',
        no_diagnose: 'No condition',
        no_treatment: 'No treatment',
        cancellation_reason_placeholder: 'Enter cancellation reason here',
        cancellation_reason: 'Cancellation reason',
        cookies_policy: 'Cookies policy',
        usage_rules: 'Terms of use',
        terms_and_conditions: 'Terms and conditions',
        gdpr: 'GDPR',
        create_note: 'Create note',
        start_date: 'Start date',
        end_date: 'End date',
        serve_to: 'To serve to',
        english_letters_only_field: 'This field must contain Latin letters only',
        signature_client_not_found: 'The signature client is not found!',
        signature_client_start: 'Please run Dentobook eSign App or download it and install it from',
        here_msg: 'here',
        addCredentials: 'Set Google Credentials',
        googleWarning: 'Your Google Client ID is not configured. Please set it to re-authenticate.',
        reAuth: 'Your session has expired. Please re-authenticate with Google.',
        googleLogin: 'Sign in with Google.',
        clientId: 'Client Id',
        clientSecret: 'Client Secret',
        editCredentials: 'Edit Google Credentials',
        identifierAlert: ' Personal identification number does not match the birth date.',
        patientEmailAlert: 'Patient email is not available. Google Calendar event could not be created. Continue with creating/updating the regular calendar event',
        done_operations: ' Completed operations',
        done_operations_info: 'Only completed treatments with a total amount greater than zero that have not been invoiced yet are displayed here.',
        invoices: 'Invoices',
        proforma_invoices: 'Proforma invoices',
        maturity: 'Maturity',
        price_value: 'Value',
        paid_price_value: 'Paid',
        payment_type: 'Payment method',
        canceled_finance: 'Cancelled',
        paid_invoice: 'Paid',
        unpaid_invoice: 'Unpaid',
        canceled_invoice: 'Cancelled',
        cash_payment_type: 'Cash',
        card_payment_type: 'By card',
        paid_obligations: 'Paid',
        create_invoice: 'Create invoice',
        payment_deadline: 'Payment deadline',
        payment_method: 'Payment method',
        vat_label: 'VAT',
        bank_transfer: 'Bank transfer',
        create_proforma_invoice: 'Create proforma invoice',
        update_proforma_invoice: 'Proforma',
        tooth_status_delete_confirm: 'Are you sure you want to delete this tooth status?',
        tooth_treatment_delete_confirm: 'Are you sure you want to delete this treatment?',
        leave_page_title: 'Leaving page',
        leave_page: 'Leave page',
        leave_page_message: 'Leaving this page will delete all unsaved data. Please save your changes before leaving.',
        field_too_long_message: 'The value is too long.',
        proforma_void_message: 'Are you sure you want to cancel this proforma invoice?',
        void_message: 'Are you sure you want to cancel this invoice?',
        void_button: 'Cancel',
        invoice_generate_confirm: 'Are you sure you want to generate an invoice from a proforma invoice?',
        generate_btn: 'Generate',
        generate_invoice_tooltip: 'Generate invoice',
        edit_tooltip: 'Edit',
        print_tooltip: 'Print',
        nzis_mandatory_fields: 'Please complete the following fields in the patient profile: [FIELDS]. Once you have completed in the fields, you will be able to proceed.',
        invoice_numbering_title: 'Change invoice numbering',
        invoice_numbering_text: 'Dentobook generates an unique 10-digit sequential number for each issued invoice. If there are no invoices in the database, the first number will be 0000000001 and each next will be incremented by 1. If this is not your first invoice, change the from which the count starts',
        proforma_numbering_title: 'Change proforma invoices numbering',
        proforma_numbering_text: 'Dentobook generates an unique 10-digit sequential number for each issued proforma invoice. If there are no proforma invoices in the database, the first number will be 0000000001 and each next will be incremented by 1. If this is not your first proforma invoice, change the number from which the count starts.',
        invoice_config_setup_title: 'Invoice Configuration Setup',
        invoice_config_setup_description: 'Before you can create invoices, you need to configure how invoice numbers will be generated. This is a one-time setup.',
        invoice_configuration: 'Invoice Configuration',
        proforma_invoice_configuration: 'Proforma Invoice Configuration',
        proforma_config_setup_title: 'Proforma Invoice Configuration Setup',
        proforma_config_setup_description: 'Before you can create proforma invoices, you need to configure how proforma invoice numbers will be generated. This is a one-time setup.',
        invoice_config_prefix: 'Prefix (optional)',
        invoice_config_prefix_help: 'Text to appear before the number (e.g., INV, FACT)',
        invoice_config_prefix_placeholder: 'INV',
        invoice_config_starting_number: 'Starting Number',
        invoice_config_starting_number_min: 'Starting number must be at least 1',
        invoice_config_digits_count: 'Number of Digits',
        invoice_config_digits_count_help: 'Total digits for the numeric part (padded with zeros)',
        invoice_config_digits_count_range: 'Number of digits must be between 6 and 15',
        invoice_config_example: 'Example Invoice Number',
        invoice_config_example_text: 'Based on your settings, the first invoice number will be:',
        error_creating_invoice_config: 'Failed to create invoice configuration. Please try again.',
        reports_label: 'Reports',
        patients_all_label: 'Patient (All)',
        doctors_all_label: 'Doctor (All)',
        doctor_label: 'Doctor',
        day_label: 'Day',
        week_label: 'Week',
        month_label: 'Month',
        period_label: 'Period',
        debt_label: 'Debt',
        download_report: 'Download report',
        yesterday: 'Yesterday',
        this_week: 'This week',
        last_week: 'Last week',
        this_month: 'This month',
        last_month: 'Last month',
        period: 'Period',
        continue: 'Continue',
        continue_free_version: 'Continue with free plan',
        choose_plan: 'Choose plan',
        compare_plans: 'See and compare features',
        dentobook_start_one: 'Choosing Dentobook Start will give you access to',
        dentobook_start_two: 'all features of the Pro plan for a period of 6 months',
        dentobook_start_three: 'After this period, some features will be locked, leaving you the main tools of the Start plan.',
        dentobook_pro: 'Full access to all Dentobook features for efficient management of your dental practice',
        paymentMethod: 'Payment Method',
        choose_plan_msg: 'Please choose a plan.',
        logout_msg: 'The action requires logging out of your account. Are you sure you want to continue?',
        organization_conflict: 'An organization with the same name already exists.',
        clientIdRequired: 'Client ID is required.',
        clientIdMinLength: 'Client ID must be at least 10 characters.',
        clientSecretRequired: 'Client Secret is required.',
        clientSecretMinLength: 'Client Secret must be at least 16 characters.',
        missingFirstName: 'First name is missing.',
        missingLastName: 'Last name is missing.',
        missingBothNames: 'First name and last name are missing.',
        subscription: 'Subscription',
        active_subscription: 'Active subscription',
        subscription_description: 'Enjoy full access to all Dentobook Pro features by selecting the paid plan. For just €4.99/month, you’ll retain all the tools and functionality you’ve been using.',
        subscription_description_free_trial: 'Start with a 30-day free trial and enjoy full access to all Dentobook features to efficiently manage and optimize your dental practice. No credit card required*',
        subscription_description_free_trial_profile: '30-day free trial and enjoy full access to all Dentobook features to efficiently manage and optimize your dental practice. After the trial, the subscription continues at only €4.99/month.',
        subscription_description_start: 'Free plan',
        next_payment: 'Next payment',
        cancel_subscription: 'Cancel Subscription',
        subscribe: 'Subscribe',
        renew_subscription: 'Renew Subscription',
        cancel_subscription_text: 'Are you sure you want to cancel your subscription?',
        subscription_active_warning: 'Your free trial access to Dentobook Pro for 30 days expires in {days} {unit}. Please {a} to renew and activate your subscription.',
        subscription_expired_warning: 'Your free trial access to Dentobook Pro for 30 days has expired. Please {a} to renew and activate your subscription.',
        free_trial_title: '30 day free trial',
        dentobook_pro_title: 'Dentobook Pro - 4,99 €',
        payment_error: 'An error occurred during payment',
        missing_required_fields: 'Please fill out the required fields',
        payment_method_creation_error: 'An error occurred while creating the payment method',
        registration_successful: 'Registration completed successfully',
        payment_token_error: 'An error occurred during payment. Please check your payment method',
        subscription_payment_failed: 'Your payment details failed. Please update your payment method to proceed.',
        free_trial_plan_name: '30 day free trial',
        card_declined: 'Your card was declined.',
        expired_card: 'Your card has expired.',
        incorrect_cvc: 'Incorrect CVC.',
        processing_error: 'Your card could not be processed.',
        incorrect_number: 'Incorrect number.',
        expires_at: 'Expires at',
        credit_card_title: 'Credit/Debit Card',
        card_number_title: 'Card number',
        card_expiration_title: 'MM/YY',
        postal_code_title: 'Postal Code',
        subscription_expiration: 'Expires at',
        create_event_not_allowed: 'Creating calendar events and using Google integration is not allowed for your current plan.',
        doctors_statistics_label: 'Doctors',
        assistants_statistics_label: 'Assistants',
        receptionists_statistics_label: 'Receptionists',
        download: 'Download',
        report_problem: 'Report a problem',
        send_feedback: 'Suggest a feature',
        currency_label: 'Currency',
        billing: 'Billing',
        billing_details: 'Monthly Invoice Details',
        company_name: 'Company name',
        active_label: 'Active',
        trial_label: 'Trial',
        expired_label: 'Expired',
        last_login_label: 'Last login date',
        login_count_label: 'Number of logins',
        delete_organization: 'Delete organization',
        delete_action: 'Delete',
        delete_organization_confirmation_text: 'Are you sure you want to delete the organization along with all associated data (patients, doctors, appointments, etc.)?',
        invalid_vat_bg: 'Invalid VAT number. It must either start with \'BG\' followed by 9 or 10 digits, or consist of exactly 9 digits.',
        patients_count: 'Patients Count',
        calendar_appointments_count: 'Calendar Appointments Count',
        hosted_invoice_url: 'Hosted Invoice URL',
        invoice_pdf: 'Invoice PDF',
        amount_paid: 'Amount Paid',
        view_hosted_invoice: 'View Hosted Invoice',
        download_invoice_pdf: 'Download Invoice PDF',
        choose_file_dropbox: 'Drag and drop document',
        delete_document: 'Document was deleted successfully',
        document_delete_confirm: 'Are you sure you want to delete this document?',
        remember_me: 'Remember me',
        remember_me_tooltip: 'Keep me logged in for up to 2 weeks',
        password: 'Password',
        logging_in: 'Logging in...',
        login: 'Login',
        forgot_password: 'Forgot password?',
        no_account: "Don't have an account?",
        register_here: 'Register here',

        // ForgotPassword page
        forgot_password_title: 'Forgot Password?',
        forgot_password_description: "Enter your email address and we'll send you a link to reset your password.",
        email_required_error: 'Please enter your email.',
        email_placeholder: 'Enter your email address',
        sending: 'Sending...',
        send_reset_link: 'Send Reset Link',
        back_to_login: 'Back to Login',
        password_reset_link_sent: 'If an account exists with this email, a password reset link has been sent.',

        // ResetPassword page
        reset_password_title: 'Reset Password',
        reset_password_description: 'Create a new password for your account.',
        new_password: 'New Password',
        confirm_new_password: 'Confirm New Password',
        new_password_required: 'Please enter your new password.',
        password_min_length_error: 'Password must be at least 9 characters long.',
        confirm_password_required: 'Please confirm your password.',
        passwords_do_not_match: 'Passwords do not match.',
        new_password_placeholder: 'Enter your new password',
        confirm_password_placeholder: 'Confirm your new password',
        resetting: 'Resetting...',
        reset_password_button: 'Reset Password',
        password_reset_success: 'Your password has been successfully reset.',
        invalid_reset_token: 'Invalid or expired reset token.',
        reset_link_expired: 'The reset link has expired. Please request a new one.',
        reset_link_expired_title: 'Reset link expired',
        password_must_contain_number: 'Password must contain at least one number.',
        password_must_contain_special: 'Password must contain at least one special character.',
        password_must_contain_uppercase: 'Password must contain at least one uppercase letter.',
        password_must_contain_lowercase: 'Password must contain at least one lowercase letter.',
        password_requirements_hint: 'Password must be at least 9 characters long and contain numbers, special characters, uppercase and lowercase letters.',
        redirecting_to_login: 'Redirecting to login...',

        // Registration page
        register_organization_title: 'Register your organization',
        organization_registration_title: 'Organization Registration',
        account_registration_title: 'Account Registration',
        organization_name: 'Organization name',
        vat_number: 'VAT Number',
        business_address: 'Business Address',
        organization_name_required: 'Please enter organization name.',
        clinic_name_required: 'Please enter clinic name.',
        vat_number_required: 'Please enter VAT number.',
        password_required_error: 'Please enter password.',
        first_name_required: 'Please enter first name.',
        last_name_required: 'Please enter last name.',
        country_required: 'Please select country.',
        phone_required: 'Please enter phone number.',
        phone_format_hint: 'Use international format, e.g. +359888123456',
        phone_international_required: 'Phone must start with "+" and country code (e.g. +359888123456).',
        next: 'Next',
        previous: 'Previous',
        submit: 'Submit',
        already_have_account: 'Already have an account?',
        login_here: 'Login here',
        registration_successful: 'Registration successful!',
        check_email_verification: 'Please check your email to verify your account.',
        registration_failed: 'Registration failed. Please try again.',
        email_already_taken: 'Email is already taken.',
        email_already_taken_register: 'This email is already registered. If it\'s yours, log in and create your organization from {link}.',
        organization_already_exists: 'An organization with the same name already exists.',
        registration_success_message: 'You have successfully registered! You will be redirected to login page.',
        successful_registration_title: 'Successful registration',
        close: 'Close',
        phone_number: 'Phone number',
        invalid_phone_number_text: 'Invalid phone number.',
        first_name_letters_only: 'First name must contain letters only',
        last_name_letters_only: 'Last name must contain letters only',
        organization_name_max_length: 'Organization name must not exceed 250 characters.',
        clinic_name_max_length: 'Clinic name must not exceed 250 characters.',
        create_account: 'Create account',
        confirm_password: 'Confirm password',

        // RegisterUser page
        register_new_user_title: 'Register New User',
        user_details: 'User Details',
        create_user_account: 'Create user account',
        medical_staff_label: 'Medical Staff',
        user_role: 'User Role',
        medical_staff_required: 'Please select medical staff.',
        user_role_required: 'Please select user role.',
        select_medical_staff: 'Select medical staff',
        select_role: 'Select role',
        registering: 'Registering...',
        register_user_button: 'Register User',
        user_registered_success: 'User registered successfully!',
        user_registration_failed: 'Failed to register user.',
        organization: 'Organization',
        organization_required: 'Please select organization.',
        health_insurance_filter_info: 'Only health insurance companies from {country} are shown in the list.',
        switch_organization: 'Switch organization',
        help_nav: 'Help',
        help_legal: 'Contact & Legal',
        help_title: 'Help & Knowledge Base',
        help_search_placeholder: 'Search articles...',
        all_categories: 'All categories',
        help_not_found: 'Article not found',
        help_not_found_desc: 'This article does not exist or the link is incorrect.',
        back_to_help: 'Back to Help',
        help_category_organizations: 'Organizations',
        help_category_access: 'Access & Invitations',
        help_article_multi_org_title: 'Multi-Organization Support',
        help_article_multi_org_desc: 'Understand how Dentobook manages multiple clinics under one account and what changes when you switch.',
        help_article_multi_org_h1: 'What is multi-organization support?',
        help_article_multi_org_p1: 'Dentobook allows a single user account to belong to more than one organization. Each organization is an independent clinic or practice with its own staff, patients, appointments, and data.',
        help_article_multi_org_p2: 'The organization that is currently active is called the "current organization". It is shown in the top navigation bar. Everything you view or create in Dentobook — patient records, calendar entries, staff, reports — belongs to the current organization only.',
        help_article_multi_org_h2: 'What changes when you switch organizations?',
        help_article_multi_org_p3: 'When you switch to a different organization, Dentobook issues a new session and reloads the application. Your view — patients, calendar, staff, and reports — will immediately reflect the data of the newly selected organization.',
        help_article_multi_org_p4: 'Your user role may differ between organizations. For example, you may be a Clinic Admin in one and a Medical Doctor in another. The menu items and permissions you see depend on your role in the current organization.',
        help_article_multi_org_h3: 'Who sees the organization switcher?',
        help_article_multi_org_p5: 'The organization switcher is shown in the top navigation bar only when your account is an active member of more than one organization. If you belong to only one organization, no switcher is shown.',
        help_article_multi_org_h4: 'Creating your own organization while working at another clinic',
        help_article_multi_org_p6: 'If you are already a member of another organization — for example, you work as a dentist at a colleague\'s practice — you can still create and manage your own organization in Dentobook. Open My Profile from the top-right user menu and click "Create my organization". Your existing membership at the other clinic is not affected in any way. After creation you become the Organization Administrator of your new organization and can switch freely between all your organizations at any time.',
        help_article_multi_org_p7: 'If you do not yet have a Dentobook account, complete the registration first. Once logged in, open My Profile to create your organization. If you try to register with an email that is already in the system — because a clinic admin previously invited you — Dentobook will display a link directly to your Profile page so you can proceed from there.',
        help_article_switching_title: 'Switching Between Organizations',
        help_article_switching_desc: 'How to use the organization switcher to change your active organization.',
        help_article_switching_h1: 'How to switch organizations',
        help_article_switching_p1: "Click your organization's name or avatar in the top navigation bar. A dropdown appears listing all organizations you are an active member of, with a checkmark next to the current one.",
        help_article_switching_p2: 'Click any organization in the list to switch. A loading overlay appears briefly while Dentobook issues a new session token, then the page reloads in the context of the selected organization.',
        help_article_switching_h2: 'When the switcher is not visible',
        help_article_switching_p3: 'The switcher only appears when your account is an active member of more than one organization. If the switcher is missing, you may belong to only one organization, or your memberships in other organizations have been removed or suspended by an admin.',
        help_article_switching_h3: 'After switching',
        help_article_switching_p4: 'All data reloads fresh from the server after a switch. No information from the previous organization carries over. If you navigate back to a page, it will show data for the new current organization.',
        help_article_invitations_title: 'Invitations & Portal Access',
        help_article_invitations_desc: 'How to grant, manage, and accept portal access for staff members.',
        help_article_invitations_h1: 'Granting portal access',
        help_article_invitations_p1: 'A Clinic Admin can grant portal access to a staff member from the staff member\'s detail page. Enter the staff member\'s email address and click "Grant access". An invitation email is sent to that address.',
        help_article_invitations_p2: 'Until the invitation is accepted, the staff member\'s portal access status shows as "Invite pending". Clinic Admins can resend or revoke the invitation while it is in this state.',
        help_article_invitations_h2: 'Accepting an invitation — existing user',
        help_article_invitations_p3: 'If the invited email belongs to an existing Dentobook account, the recipient visits the link in the invitation email and clicks "Accept Invitation". Their existing account is linked to the organization and they are redirected to log in.',
        help_article_invitations_p4: 'If the user is already logged in when they visit the invitation link, Dentobook automatically switches them into the new organization. No re-login is needed.',
        help_article_invitations_h3: 'Accepting an invitation — new user',
        help_article_invitations_p5: 'If the invited email does not belong to an existing Dentobook account, a registration form is shown. The user provides their first name, last name, and a password meeting the security requirements. After submitting, their account is created, linked to the organization, and they are redirected to log in.',
        help_article_invitations_h4: 'Resending and revoking invitations',
        help_article_invitations_p6: 'Resending an invitation generates a new token and resets the expiry to 7 days. Revoking an invitation cancels it and resets the staff member\'s status to "No portal access". The staff member\'s existing user account — if already linked — is not deleted.',
        help_article_invitations_h5: 'Granting access when adding a new staff member',
        help_article_invitations_p7: 'The "Needs portal access" toggle appears on the create staff form. Enable it to send an invitation at the moment of creation. When the toggle is on, the email field becomes required. Leave the toggle off to create the staff record without any invitation — you can grant access later from the staff member\'s detail page.',
        help_article_invitations_p8: 'The system prevents duplicate invitations: if a pending invitation already exists for that email in your organization, the form will show an error — revoke the existing invitation first, then create the new record. If the email already belongs to an active member of your organization, no invitation is needed.',
        help_article_troubleshooting_title: 'Troubleshooting Access Issues',
        help_article_troubleshooting_desc: 'Common problems with organization switching and portal access invitations, and how to resolve them.',
        help_article_troubleshooting_h1: 'The organization switcher is not visible',
        help_article_troubleshooting_p1: 'The switcher only appears when your account is an active member of more than one organization. Accepting an invite does not update your current session — log out and log back in to refresh your session with the new membership.',
        help_article_troubleshooting_h2: 'Invitation says "expired"',
        help_article_troubleshooting_p2: 'Invitation links expire after 7 days. Ask your Clinic Admin to resend the invitation. Resending generates a fresh link valid for another 7 days.',
        help_article_troubleshooting_h3: 'Invitation says "revoked"',
        help_article_troubleshooting_p3: 'The invitation was cancelled by an admin. Contact your Clinic Admin to request a new invitation.',
        help_article_troubleshooting_h4: 'Invitation says "already accepted"',
        help_article_troubleshooting_p4: 'Each invitation link can only be used once. If you already accepted but the organization is not visible in your switcher, log out and log back in to reload your session with the updated membership.',
        help_article_troubleshooting_h5: '403 error when switching organizations',
        help_article_troubleshooting_p5: 'A 403 error during an organization switch means your membership in that organization has been removed or suspended since your last login. Contact the Clinic Admin of that organization for assistance.',
        help_article_troubleshooting_h6: 'Error when creating a staff member with portal access',
        help_article_troubleshooting_p6: 'If the form shows an error after enabling the "Needs portal access" toggle, a pending invitation already exists for that email in your organization. Find the existing staff record for that email, revoke the pending invitation, and then save the new record.',
        help_category_account: 'My Account',
        help_article_profile_title: 'My Profile',
        help_article_profile_desc: 'Manage your personal details, view your organization memberships, and create your own organization.',
        help_article_profile_h1: 'Viewing and editing your details',
        help_article_profile_p1: 'Open My Profile from the top-right user menu. The page shows your first name, last name, email address, and phone number. Email is read-only and cannot be changed here. Click Edit to update your name or phone number.',
        help_article_profile_h2: 'Your organization memberships',
        help_article_profile_p2: 'The Memberships section lists every organization your account belongs to. For each entry you can see the organization name, your role, and your membership status. The organization you are currently working in is marked as Active.',
        help_article_profile_h3: 'Creating your own organization',
        help_article_profile_p3: 'Click "Create my organization" to start a new organization. If you already own one, the button reads "Create another organization". Enter the organization name and confirm. After creation you automatically become the Organization Administrator, the organization becomes your active one, and Dentobook switches to it.',
        help_article_profile_h4: 'Profile completion requirement',
        help_article_profile_p4: 'Before creating an organization, your first name and last name must be filled in. If either field is empty, Dentobook blocks the action and shows a warning. Complete your profile first, then proceed with creating the organization.',
        help_category_notifications: 'Notifications & Messaging',
        help_article_notif_overview_title: 'Notifications Overview',
        help_article_notif_overview_desc: 'How Dentobook keeps clinic staff informed about important activity inside the application.',
        help_article_notif_overview_h1: 'What are notifications?',
        help_article_notif_overview_p1: 'Dentobook keeps clinic staff informed through notifications. They appear inside the app and may also be sent by email. Notifications are triggered by important events related to appointments, patients, and clinic activity.',
        help_article_notif_overview_h2: 'In-app notifications',
        help_article_notif_overview_p2: 'Notifications appear under the bell icon in the top navigation bar. The badge shows how many are unread. Click the bell to view recent activity. You can mark all notifications as read at once using the button at the bottom of the panel.',
        help_article_notif_overview_p3: 'Clicking a notification may open the relevant record, highlight a freed calendar slot, or simply mark it as read.',
        help_article_notif_overview_h3: 'Who receives which notifications?',
        help_article_notif_overview_p4: 'Different users may receive different notifications depending on their role and involvement in the activity. Clinic administrators may receive additional operational notifications. Other staff typically receive those related to appointments or patients they are directly involved with. Patients with portal access may also receive notifications about their own appointments.',
        help_article_messaging_title: 'Messaging & Twilio Setup',
        help_article_messaging_desc: 'How to connect your Twilio account and configure SMS and WhatsApp notifications for patients.',
        help_article_messaging_h1: 'What does messaging do?',
        help_article_messaging_p1: 'Dentobook can automatically send patient notifications including appointment confirmations, reminders, rescheduling notices, and cancellations. Supported channels are SMS and WhatsApp.',
        help_article_messaging_h2: 'How it works — Bring Your Own Twilio',
        help_article_messaging_p2: 'Dentobook integrates with Twilio to deliver messages but does not act as a messaging provider. Each clinic connects its own Twilio account and pays Twilio directly. Dentobook does not charge per message and does not resell messaging services.',
        help_article_messaging_h3: 'Where to find Messaging settings',
        help_article_messaging_p3: 'Go to Organization Settings, then open the Messaging tab. If Twilio is not yet configured, the Setup Wizard appears automatically. You can also re-run the wizard at any time from the Messaging page.',
        help_article_messaging_h4: 'Setup wizard steps',
        help_article_messaging_p4: 'The wizard walks you through six steps. Welcome introduces the setup. Account asks you to confirm you have a Twilio account. Credentials is where you enter your Twilio Account SID and Auth Token — both are found in the Twilio Console. Senders is where you configure your SMS phone number and optionally a WhatsApp sender. Test lets you send a test message to verify everything works. Finish lets you enable SMS and/or WhatsApp channels.',
        help_article_messaging_h5: 'SMS setup',
        help_article_messaging_p5: 'SMS is the easiest option. You need a Twilio account and a Twilio phone number. Once your number is configured in the wizard, SMS works immediately.',
        help_article_messaging_h6: 'WhatsApp setup',
        help_article_messaging_p6: 'WhatsApp requires additional registration beyond a Twilio account. You must join the Twilio WhatsApp Sandbox for testing, then register a WhatsApp sender for production use. Sender approval is handled by Twilio and Meta. You can start with SMS and add WhatsApp later.',
        help_article_messaging_h7: 'Security',
        help_article_messaging_p7: 'Your Twilio credentials are encrypted at rest. They are used only to send messages from your clinic\'s own Twilio account. Dentobook does not store credentials in plain text.',
        help_article_messaging_h8: 'Pricing',
        help_article_messaging_p8: 'Dentobook does not charge for messaging. All message costs are billed by Twilio directly to your clinic\'s Twilio account according to Twilio\'s standard pricing.',
        help_article_messaging_h9: 'Troubleshooting',
        help_article_messaging_p9: 'Common issues: Invalid credentials — verify your Account SID and Auth Token in the Twilio Console. Phone number not working — ensure the number is active and SMS-capable in your Twilio account. WhatsApp not sending — confirm your WhatsApp sender is approved and registered. Sandbox not joined — for WhatsApp testing, you must first join the Twilio Sandbox.',
        help_category_patients: 'Patients',
        help_article_patient_import_title: 'Importing patients',
        help_article_patient_import_desc: 'How to bring your existing patient list into Dentobook using Quick Entry or a file upload.',
        help_article_patient_import_h1: 'Overview',
        help_article_patient_import_p1: 'The Import Patients page lets you add multiple patients at once. You can type or paste up to 20 rows directly in the browser (Quick Entry), or upload a CSV or Excel file containing any number of rows.',
        help_article_patient_import_p2: 'Only Clinic Administrators can import patients. Navigate to Patients → Import Patients to get started.',
        help_article_patient_import_h2: 'Quick Entry',
        help_article_patient_import_p3: 'The Quick Entry grid is the fastest way to import a small batch of patients. Click any cell and start typing, or paste a table copied from Excel or another spreadsheet. Use Tab to move to the next column, Enter or the down arrow to move to the next row, and the "+ Add row" button to extend the grid.',
        help_article_patient_import_p4: 'Click Validate to check all rows before saving. Rows with errors are highlighted in red with a short description. Fix the errors and validate again. When all rows show green, click Import to save the patients.',
        help_article_patient_import_h3: 'File Import',
        help_article_patient_import_p5: 'For larger lists, download the CSV or Excel template from the top of the page. Fill it in using your preferred spreadsheet program and upload it with the File Import tab. Dentobook previews the rows before you commit them, so you can spot problems early.',
        help_article_patient_import_p6: 'Phone numbers and national ID values must be typed as text. In Excel, format those columns as Text before entering data, or prefix values with an apostrophe to prevent the program from converting them to numbers. The downloaded Excel template already has those columns pre-formatted.',
        help_article_patient_import_h4: 'Reviewing import results',
        help_article_patient_import_p7: 'After clicking Import, each row reports one of three outcomes: Imported (new patient created), Duplicate warning (a patient with the same name or contact details already exists — the row is still imported but flagged for review), or Failed (a required field is missing or invalid — the row is skipped).',
        help_article_patient_import_p8: 'The summary bar at the top shows the total counts of imported, skipped, and failed rows. You can review failed rows directly in the grid and correct them without starting over.',
        help_article_patient_import_h5: 'Import history',
        help_article_patient_import_p9: 'Every import session is recorded. Click View import history at the top of the page to see a list of past imports with timestamps, row counts, and the name of the administrator who ran them.',
        help_article_patient_import_p10: 'The history page does not allow you to undo an import. If you need to remove incorrectly imported patients, open each patient record and delete or archive it manually.',
        help_article_patient_import_h6: 'Need help with a custom format?',
        help_article_patient_import_p11: 'If your current software exports patient data in a format that does not match the Dentobook template, use the Need Help? tab on the Import Patients page. Describe your situation and attach a sample file. The Dentobook support team will review your file and help you map the columns correctly.',
        help_article_patient_import_p12: 'Sample files are kept for 30 days and then automatically deleted. Never include sensitive patient data in a sample — use anonymised or fictional records when possible.',
        org_switched_after_revoke: 'Your access was revoked. You have been switched to {orgName}.',
        messaging_settings: 'Messaging',
        messaging_settings_description: 'Configure when appointment reminders are sent. Select a channel to enable notifications, or keep it at None to disable them.',
        messaging_timezone_info: 'Reminder offsets and quiet hours are applied in the local timezone of the clinic linked to the appointment. If your organization has multiple clinics with different timezones, each clinic will send reminders at its own local time.',
        email_notifications_enabled: 'Enable email notifications',
        default_notification_channel: 'Default channel',
        channel_none: 'None (disabled)',
        channel_email: 'Email',
        channel_sms: 'SMS',
        channel_whatsapp: 'WhatsApp',
        reminder_offsets: 'Send reminders',
        reminder_24h: '24 hours before',
        reminder_2h: '2 hours before',
        quiet_hours: 'Quiet hours (no reminders sent)',
        quiet_hours_hint: 'Enter times in HH:MM format (24-hour clock). Leave blank to disable quiet hours.',
        messaging_quiet_hours_delay: 'If a reminder falls inside quiet hours, Dentobook will automatically send it at the next allowed time.',
        email_from_name: 'Sender display name',
        email_from_address: 'Sender email address',
        sms_enabled_label: 'Enable SMS notifications',
        whatsapp_enabled_label: 'Enable WhatsApp notifications',
        sms_whatsapp_status: 'SMS / WhatsApp channels',
        twilio_credentials_status: 'Twilio credentials',
        twilio_configured: 'Configured',
        twilio_not_configured: 'Not configured',
        twilio_credentials_note: 'Credentials are not displayed after saving. Leave fields blank to keep the current values.',
        twilio_account_sid_label: 'Twilio Account SID',
        twilio_auth_token_label: 'Twilio Auth Token',
        twilio_sms_from_label: 'SMS sender number',
        twilio_whatsapp_from_label: 'WhatsApp sender number',
        twilio_from_hint: 'E.164 format phone number from your Twilio account (e.g. +1234567890)',
        twilio_credentials_saved_placeholder: 'Saved (leave blank to keep current)',
        twilio_status_not_configured: 'Not configured',
        twilio_status_not_verified: 'Configured — not verified',
        twilio_status_verified: 'Verified',
        twilio_status_failed: 'Verification failed',
        twilio_verify_btn: 'Verify credentials',
        twilio_verify_success: 'Twilio credentials verified successfully.',
        twilio_verify_failed: 'Twilio credential verification failed.',
        twilio_not_verified_channel_warning: 'Verify your Twilio credentials before enabling this channel.',
        messaging_saved: 'Messaging settings saved.',
        messaging_save_error: 'Failed to save messaging settings.',
        messaging_section_email: 'Email & Reminders',
        messaging_section_sms: 'SMS',
        messaging_section_whatsapp: 'WhatsApp',
        messaging_section_twilio: 'Twilio Provider',
        messaging_section_status: 'Messaging Status',
        status_provider: 'Provider',
        status_sms: 'SMS',
        status_whatsapp: 'WhatsApp',
        status_ready: 'Ready',
        status_not_enabled: 'Not enabled',
        status_missing_sender: 'Missing sender',
        status_not_configured: 'Not configured',
        status_sandbox_only: 'Sandbox only',
        status_not_verified: 'Not verified',
        status_next_action: 'Next step',
        next_action_run_wizard: 'Run the setup wizard to connect Twilio',
        next_action_verify: 'Verify your Twilio credentials',
        next_action_add_sms_sender: 'Add an SMS sender number',
        next_action_add_whatsapp_sender: 'Add a WhatsApp sender',
        next_action_enable_channel: 'Enable at least one channel (SMS or WhatsApp)',
        messaging_setup_complete: 'Messaging setup',
        messaging_setup_percent: '{percent}% complete',
        twilio_info_box: 'SMS and WhatsApp messages are delivered through Twilio. You need a Twilio account with an active phone number to use these channels.',
        twilio_setup_guide: 'To set up Twilio, you need an Account SID and Auth Token from your Twilio Console, plus a phone number for sending messages.',
        twilio_link_console: 'Twilio Console (Account SID & Auth Token)',
        twilio_link_sms: 'SMS phone number setup',
        twilio_link_whatsapp: 'WhatsApp sender setup',
        twilio_credential_saved: 'Saved',
        twilio_credential_not_set: 'Not set',
        twilio_clear_credentials_btn: 'Clear credentials',
        twilio_clear_credentials_confirm: 'Are you sure you want to clear the saved Twilio credentials? SMS and WhatsApp will stop working.',
        twilio_sid_masked: 'AC••••••••',
        preferred_notification_channel: 'Preferred channel',
        patient_email_allowed: 'Email allowed',
        patient_phone_allowed: 'Phone messaging allowed',
        patient_channel_helper: 'Controls how appointment reminders and other notifications are delivered to this patient.',
        wizard_step_intro: 'Welcome',
        wizard_step_account: 'Account',
        wizard_step_credentials: 'Credentials',
        wizard_step_senders: 'Senders',
        wizard_step_test: 'Test',
        wizard_step_finish: 'Finish',
        wizard_intro_title: 'Set up messaging for appointment reminders',
        wizard_intro_p1: 'Dentobook uses Twilio to deliver SMS and WhatsApp messages to your patients. Your clinic creates its own Twilio account and pays Twilio directly — Dentobook does not charge per message.',
        wizard_intro_p2: 'This wizard will guide you through connecting your Twilio account, configuring sender numbers, and testing delivery.',
        wizard_intro_sms_easy: 'SMS is the easiest to set up — you only need a Twilio phone number.',
        wizard_intro_whatsapp_note: 'WhatsApp requires additional sender registration through Twilio and Meta. You can set it up later if needed.',
        wizard_start_setup: 'Start setup',
        wizard_skip_for_now: 'Skip for now',
        wizard_account_title: 'Create or access your Twilio account',
        wizard_account_p1: 'If you don\'t have a Twilio account yet, create one using the link below. Twilio offers a free trial for testing.',
        wizard_account_p2: 'Once your account is ready, you will need your Account SID and Auth Token from the Twilio Console dashboard.',
        wizard_create_twilio_account: 'Create Twilio account',
        wizard_open_twilio_console: 'Open Twilio Console',
        wizard_have_account: 'I have a Twilio account',
        wizard_back: 'Back',
        wizard_credentials_title: 'Connect your Twilio credentials',
        wizard_credentials_p1: 'Enter the Account SID and Auth Token from your Twilio Console. Credentials are stored securely and encrypted at rest.',
        wizard_credentials_find: 'You can find these on your',
        wizard_save_and_verify: 'Save & verify',
        wizard_continue: 'Continue',
        wizard_senders_title: 'Configure sender numbers',
        wizard_sms_sender_help: 'Enter the SMS-capable phone number from your Twilio account. This number will appear as the sender for SMS messages.',
        wizard_whatsapp_sender_help: 'WhatsApp requires a registered sender number. This requires additional setup in your Twilio account.',
        wizard_test_title: 'Send a test message',
        wizard_test_p1: 'Send a test message to verify that your setup is working. Enter a phone number you can check right now.',
        wizard_test_channel: 'Channel',
        wizard_test_phone: 'Destination phone number',
        wizard_send_test: 'Send test',
        wizard_test_success: 'Test message sent successfully! Check your phone.',
        wizard_test_failed: 'Test message could not be sent.',
        wizard_finish_title: 'Messaging setup complete!',
        wizard_finish_subtitle: 'Your Twilio account is connected. Choose which channels to enable for patient notifications.',
        wizard_enable_channels: 'Enable channels',
        wizard_no_sms_sender: 'No SMS sender configured — SMS cannot be enabled yet.',
        wizard_no_whatsapp_sender: 'No WhatsApp sender configured — WhatsApp cannot be enabled yet.',
        wizard_finish_btn: 'Finish setup',
        wizard_rerun_btn: 'Run setup wizard',
        // Patient import
        import_patients: 'Import Patients',
        import_patients_desc: 'Bulk-add patients via manual entry or file upload.',
        import_v1_scope_notice: 'Only demographic data is imported. Appointments, treatments, invoices, and medical history are not included.',
        import_tab_quick_entry: 'Quick Entry',
        import_tab_file: 'File Import',
        import_tab_support: 'Need Help?',
        import_quick_entry_hint: 'Paste from Excel or Google Sheets starting at any focused cell {ctrl}.{br}{tab} ({shiftTab} for previous field) and {enter} to navigate, or use the mouse freely.{br}Click {addRow} to add rows.{br}Tip: pasted data fills adjacent cells right and down from the focused cell.',
        import_add_row: 'Add row',
        import_row_count: '{count} / {max} rows',
        import_paste_hint: 'Tip: click a starting cell first, then paste from Excel or Google Sheets (Ctrl+V). The pasted range fills adjacent cells across and down.',
        import_validate_button: 'Check for issues',
        import_commit_button: 'Import {count} rows',
        import_commit_all_button: 'Import all rows',
        import_clear_all: 'Clear all',
        import_validate_error: 'Validation failed. Please try again.',
        import_commit_error: 'Import failed. Please try again.',
        import_upload_error: 'Failed to upload file. Please check the format and try again.',
        import_parsing_file: 'Parsing file…',
        import_file_upload_hint: 'Click or drag a file here to upload',
        import_file_upload_formats: 'Supports .csv and .xlsx — max 1,000 rows · max 5 MB',
        import_file_too_large: 'File exceeds the 5 MB size limit. Please split into smaller files.',
        import_file_too_many_rows: 'File contains more than 1,000 rows. Please split into smaller batches.',
        import_total_rows: '{count} rows',
        import_valid_rows: '{count} valid',
        import_warning_rows: '{count} ID warnings',
        import_conflict_rows: '{count} ID warnings',
        import_commit_result: 'Imported {committed} · Failed {failed} · Skipped {skipped}',
        import_download_template: 'Download template',
        import_download_template_csv: 'CSV Template',
        import_download_template_xlsx: 'Excel Template',
        import_view_history: 'View History',
        import_history_title: 'Import History',
        import_history_empty: 'No import sessions yet.',
        import_history_date: 'Date',
        import_history_source: 'Source',
        import_history_file: 'File',
        import_history_total: 'Total',
        import_history_committed: 'Imported',
        import_history_warnings: 'ID warnings',
        import_history_status: 'Status',
        import_history_created_by: 'Created by',
        import_history_back: 'Back to Import',
        import_history_load_error: 'Failed to load import history.',
        import_source_manual: 'Manual',
        import_source_csv: 'CSV',
        import_source_excel: 'Excel',
        import_status_validated: 'Validated',
        import_status_committed: 'Committed',
        import_status_partial: 'Partial',
        import_status_draft: 'Draft',
        import_duplicate_national_id_warning: 'National ID already exists in the database — review before importing.',
        import_upload_another: 'Upload another file',
        import_support_title: 'Different export format?',
        import_support_desc: 'Describe your data format and we\'ll help set up a proper import — free of charge. We\'ll respond to your account email.',
        import_support_message_label: 'Describe your format',
        import_support_message_placeholder: 'Describe the system you\'re exporting from and the columns in your file…',
        import_support_file_label: 'Sample file (optional)',
        import_support_file_hint: 'Drop a sample file here or click to select',
        import_support_submit: 'Send request',
        import_support_sent: 'Request sent!',
        import_support_sent_desc: 'We\'ll follow up within 1–2 business days via your account email.',
        import_support_error: 'Could not send the request. Please try again.',
        import_support_org_label: 'Import into organization',
        import_support_org_placeholder: 'Select organization',
        import_support_org_load_error: 'Could not load your organizations. Please refresh and try again.',
        import_support_org_not_specified: 'Not specified',
        import_row_status_draft: 'Draft',
        import_row_status_valid: 'Valid',
        import_row_status_invalid: 'Invalid',
        import_row_status_duplicate_warning: 'Duplicate?',
        import_row_status_conflict: 'Conflict',
        import_row_status_saving: 'Saving…',
        import_row_status_saved: 'Saved',
        import_row_status_failed: 'Failed',
        import_row_status_skipped: 'Skipped',
        import_fix_n_issues: 'Fix {count} issues',
        // Shared keys for import grid (some may already exist elsewhere)
        gender_other: 'Other',
        national_id_label: 'National ID',
        full_name: 'Full name',
        field_required: 'This field is required',
    },
    [LOCALES.BULGARIAN]: {
        home: 'Начало',
        user_content: 'Специфична за потребителя информация ще бъде показана тук',
        users: 'Потребители',
        user: 'Потребител',
        patients: 'Пациенти',
        first_name: 'Име',
        surname: 'Презиме',
        last_name: 'Фамилия',
        phone: 'Телефон',
        phone_label: 'Телефон (+359)',
        phone_label_two: 'Телефон',
        dashboard: 'Начална страница',
        settings: 'Настройки',
        logout: 'Изход',
        logoutConfirm: 'Сигурни ли сте, че искате да излезете от профила си?',
        register: 'Регистрация',
        components: 'Компоненти',
        name: 'Име',
        lastAppointment: 'Последен час',
        nextAppointment: 'Следващ час',
        search: 'Търсене',
        sortBy: 'Сортирай по',
        filterBy: 'Филтрирай по',
        order: 'Ред',
        ascending: 'Възходящ',
        descending: 'Низходящ',
        filter: 'Филтър',
        resetFilter: 'Нулиране на филтър',
        diagnose: 'Общо състояние',
        registeredOn: 'Регистриран на',
        email: 'Имейл',
        town: 'Град',
        country: 'Държава',
        addressOne: 'Адрес 1',
        addressTwo: 'Адрес 2',
        notes: 'Бележки',
        birth_date: 'Дата на раждане',
        gender: 'Пол',
        source: 'Източник',
        source_name: 'Име на източник',
        last_hour: 'Последен час',
        next_hour: 'Следващ час',
        doctors: 'Дентални лекари',
        personal_information: 'Лична информация',
        registration: 'Регистрация',
        contact: 'Контакт',
        cancel: 'Откажи',
        save: 'Запази',
        copied: 'Копирано',
        payments: 'Плащания',
        paid: 'Платени',
        obligations: 'Задължения',
        address: 'Адрес',
        edit: 'Редактирай',
        required_field: 'Полето е задължително.',
        clinic_name_min_length: 'Името на клиниката трябва да е поне 2 символа.',
        invalid_tooth_position: 'Невалидна позиция на зъб.',
        invalid_email: 'Невалиден имейл.',
        gender_male: 'Мъж',
        gender_female: 'Жена',
        main_information: 'Основна информация',
        medical_history: 'Диагноза и лечение',
        medicalHistoryLabel: 'Диагноза и лечение',
        treatment: 'Лечение',
        treatments: 'Лечения',
        finances: 'Финанси',
        upcoming_feature: 'Предстояща функционалност',
        photos: 'Снимки',
        back: 'Назад',
        add: 'Добави',
        add_patient: 'Добави пациент',
        unsaved_changes: 'Има незапазени промени. Сигурни ли сте, че искате да продължите без да запазите?',
        confirm: 'Потвърди',
        invalid_phone_number: 'Невалиден телефонен номер.',
        invalid_phone_e164: 'Телефонът трябва да бъде в E.164 формат (напр. +359888123456)',
        invalid_field: 'Невалидно поле.',
        years_old: 'години',
        year_old: 'година',
        levs: '€',
        success_message: 'Направените промени са успешно запазени.',
        not_available: 'Няма',
        nzis_confirm: 'Потвърди и изпрати към НЗИС',
        unexpected_error: 'Възникна неочаквана грешка.',
        complete_bot_verification: 'Моля, завършете проверката за ботове.',
        registration_completed: 'Регистрацията е успешно завършена.',
        x_ray_photos: 'Рентгенови снимки',
        patient_photos: 'Снимки пациент',
        choose_image_category: 'Избери категория снимки',
        category: 'Категория',
        choose: 'Избери',
        drag_or_choose: 'Изберете или провлачете снимки',
        delete_text: 'Изтрий',
        move_text: 'Премести',
        confirmation_text: 'Сигурен/на ли сте, че искате да извършите зададеното действие?',
        delete_patient: 'Изтрий пациент',
        medical_staff: 'Персонал',
        egn: 'ЕГН',
        add_medical_staff: 'Добави служител',
        update_medical_staff: 'Редактирай служител',
        registration_error: 'Неуспешна регистрация',
        specialisation: 'Специалност',
        uin: 'УИН',
        work_time: 'Работно време',
        dentist: 'Зъболекар',
        all_loaded: 'Всички данни са заредени.',
        loading: 'Зареждане...',
        no_data: 'Няма данни',
        upload_avatar: 'Качи профилна снимка',
        organizations: 'Организации',
        email_queue: 'Опашка за имейли',
        add_organization: 'Добави организация',
        naming: 'Наименование',
        parent_organization: 'Родителска организация',
        organization_conflict: 'Организацията вече съществува',
        organization_details: 'Детайли за организацията',
        edit_organization: 'Редактирай организация',
        create_organization: 'Създай организация',
        assistant: 'Асистент',
        duplicate_email: 'Въведеният имейл вече е използван',
        letters_only_field: 'Полето може да съдържа само букви.',
        letters_and_numbers_only: 'Полето може да съдържа само букви и цифри.',
        digits_only_field: 'Полето може да съдържа само цифри.',
        discount_too_large: 'Отстъпката не може да надвишава 100%',
        patient: 'Пациент',
        company: 'Компания',
        social_network: 'Социална мрежа',
        calendar: 'Календар',
        clinic: 'Клиника',
        all_clinics: 'Всички клиники',
        select_clinic: 'Изберете клиника',
        clinic_required: 'Моля, изберете клиника.',
        googleCredentials: 'Google Credentials',
        googleCalendar: 'Google Calendar',
        googleCalendarDescription: 'Свържете Google Calendar за синхронизация на срещи. Dentobook е единственият източник на информация - срещите създадени тук ще бъдат изпратени в Google Calendar. Промените в Google Calendar няма да се синхронизират обратно.',
        connectGoogleCalendar: 'Свържи Google Calendar',
        connected: 'Свързан',
        notConnected: 'Несвързан',
        googleAccount: 'Google акаунт',
        lastSync: 'Последна синхронизация',
        syncError: 'Грешка при синхронизация',
        syncNow: 'Синхронизирай сега',
        disconnect: 'Изключи',
        howToConnect: 'Как да се свържа',
        googleCalendarConnectInstructions: 'Натиснете бутона по-долу, за да свържете вашия Google Calendar акаунт',
        googleCalendarStep1: 'Натиснете "Свържи Google Calendar"',
        googleCalendarStep2: 'Влезте с вашия Google акаунт',
        googleCalendarStep3: 'Дайте разрешения за синхронизация на календара',
        confirmDisconnectGoogleCalendar: 'Сигурни ли сте, че искате да изключите Google Calendar? Това ще спре синхронизацията на срещите.',
        googleCalendarConnectedSuccess: 'Google Calendar е свързан успешно!',
        checkActivityLogForDetails: 'Проверете вашия дневник на активност за подробности',
        connectedAccount: 'Свързан акаунт',
        closingWindow: 'Затваряне на прозореца...',
        youCanCloseThisTab: 'Можете да затворите този раздел сега.',
        googleCalendarConnectionFailed: 'Свързването с Google Calendar не успя',
        pleaseCloseAndTryAgain: 'Моля, затворете прозореца и опитайте отново.',
        youCanCloseThisTabAndTryAgain: 'Можете да затворите този раздел и да опитате отново от настройките.',
        googleCalendarDisconnected: 'Google Calendar е изключен успешно',
        syncCompleted: 'Синхронизацията завърши',
        initialSyncCompleted: 'Първоначалното импортиране завърши',
        eventsSynced: 'събития синхронизирани',
        eventsImported: 'събития импортирани',
        eventsSkipped: 'събития прескочени',
        eventsFailed: 'събития неуспешни',
        general: 'Основни',
        appointments: 'Прегледи',
        choose_appointment: 'Избери преглед',
        milkTeeth: 'Млечни',
        permTeeth: 'Постоянни',
        description: 'Описание',
        date: 'Дата',
        fromDate: 'От дата',
        position: 'Позиция',
        condition: 'Състояние',
        nzis_condition: 'Състояние по НЗИС',
        nzis_treatment_label: 'Дейност по НЗИС',
        nzis_condition_label: 'Състояние по НЗИС',
        add_condition: 'Добави състояние',
        add_condition_title: 'Добавяне на състояние',
        quick_status: 'Бърз статус',
        quick_status_more: 'Още опции',
        quick_status_clear: 'Изчисти статус',
        quick_status_not_configured: 'Статусът не е конфигуриран',
        quick_status_save_failed: 'Зъбният статус не беше запазен. Моля, опитайте отново.',
        add_appointment: 'Добави преглед',
        edit_appointment: 'Редактирай преглед',
        tooth_status: 'Зъбен статус',
        tooth_status_quick_help: 'Съвет: докато посочвате зъб, натиснете буквен клавиш (C, P, G, R, O, E, K, X, F), за да зададете статус веднага, щракнете върху бутоните в палитрата над зъба или щракнете върху самия зъб, за да отворите пълния редактор за бележки и детайли.',
        treatment_plan: 'Лечение',
        procedure: 'Процедура',
        dental_doctor: 'Дентален лекар',
        sum: 'Сума',
        status: 'Статус',
        treatment_label: 'Дейност',
        overall_price: 'Цена',
        price: 'Цена',
        discount: 'Отстъпка (%)',
        discounts: 'Отстъпки',
        discount_label: 'Отстъпка',
        overall_laboratory_price: 'Разход лаборатория',
        procedures: 'Процедури',
        laboratory_price: 'Разход лаборатория',
        currency: 'Валута',
        vat_excluded: 'Всички суми са без ДДС',
        add_procedure: 'Добави процедура',
        add_plan_title: 'Добавяне на дейност',
        all_fields_required: 'Моля въведете всички задължителни полета.',
        fill_all_required_fields: 'Моля попълнете всички задължителни полета',
        treatment_of: 'Лечение на',
        in_progress: 'В процес',
        canceled: 'Отменено',
        done: 'Изпълнено',
        offered: 'Предложено',
        qr_code_generator: 'QR код генератор',
        manual_input: 'Ръчно въвеждане',
        qr_code_generator_description: 'Изберете тази опция ако искате пациента да въведе сам цялата информация',
        manual_input_description: 'Изберете тази опция ако искате ръчно да въведете цялата информация за пациента',
        general_medical_history: 'Общо медицинско досие',
        general_illness_suffering: 'Страдате ли от общо заболаване?',
        medications_taking: 'Приемате ли медикаменти?',
        medications: 'Медикаменти',
        allergy_having: 'Имате ли алергии (към храни, лекарства, прах и др.)',
        allergies: 'Алергии',
        pregnancy_planning: 'Към дамите: Планирате ли бременност?',
        yes_ans: 'Да',
        no_ans: 'Не',
        pregnant_ans: 'Бременна съм',
        nursing_question: 'Към дамите: Кърмите ли в момента?',
        anamensis_title: 'Орално досие и орално-хигиенни навици',
        anesthetic_question: 'Поставяна ли Ви е локална (местна) упойка по повод дентално лечение?',
        higiene_question: 'Почиствате ли редовно зьбен камък и плака при Вашия дентален лекар?',
        social_anamnezis: 'Социално досие',
        dentist_visit_question: 'Колко често посещавате дентален лекар?',
        dentist_last_visit_question: 'Кога беше последното посещение по повод дентално лечение?',
        fear_question: 'Изпитвате ли страх от дентално лечение?',
        fear_ans: 'Понякога (в зависимост от процедурата)',
        dentist_visit_ans1: 'Поне два пъти годишно',
        dentist_visit_ans2: 'Веднъж годишно с цел профилактика',
        dentist_visit_ans3: 'По-рядко от веднъж годишно',
        dentist_visit_ans4: 'Само, когато имам проблем',
        illnesses: 'Заболявания',
        medical_history_info: 'Заболяванията, алергиите и медикаментите се управляват на ниво организация. Можете да ги променяте, добавяте и изтривате. Ако изтриете всички, ще можете да добавяте собствени при създаване на пациент.',
        reason: 'Причина',
        total: 'Общо',
        procedure_calculated_in_treatment: 'Процедурата е калкулирана в лечението',
        procedure_not_calculated_in_treatment: 'Процедурата се заплаща допълнително',
        totalTwo: 'Тотал',
        treatmentPriceTooLow: 'Цената на лечението не може да бъде по-ниска от сбора на процедурите',
        anesthetic_question2: 'Поставяна ли е локална (местна) упойка по повод дентално лечение?',
        is_health_insured_question: 'Има ли пациента допълнително здравно осигуряване?',
        frequency_quesiton: 'Колко често пациента посещава дентален лекар?',
        last_visit_patient_quesiton: 'Кога е било последното посещение на пациента по повод дентално лечение?',
        is_patient_afraid_question: 'Изпитва ли страх от дентално лечение?',
        smoker_question: 'Пушач ли е пациента?',
        yes: 'Да',
        no: 'Не',
        sometimes: 'Понякога',
        twice_a_year: 'Два пъти в годината',
        once_a_year: 'Веднъж в годината',
        rarely: 'Рядко',
        only_when_necessary: 'Само при необходимост',
        insurance_question: 'Имате ли допълнително здравно осигуряване?',
        insurer: 'Застраховател',
        smoker_question2: 'Пушач ли сте?',
        activity_log: 'История на промените',
        action: 'Действие',
        details: 'Детайли',
        today: 'Днес',
        role: 'Роля',
        PLATFORM_ADMINISTRATOR: 'Администратор на платформа',
        CLINIC_ADMIN: 'Администратор на клиника',
        MEDICAL_DOCTOR: 'Лекар',
        DENTAL_TECHNICIAN: 'Зъботехник',
        MEDICAL_ASSISTANT: 'Асистент',
        RECEPTIONIST: 'Рецепционист',
        PATIENT: 'Пациент',
        company_data: 'Фирмени данни',
        logo: 'Лого',
        uic: 'ЕИК',
        vat: 'ДДС номер',
        rzi_practice_code: 'РЗИ код на практика',
        accountable_person: 'МОЛ',
        conditions: 'Състояния',
        action_LOGIN: 'Вход',
        action_LOGOUT: 'Изход',
        action_GOOGLE_CALENDAR_CONNECTED: 'Свързан Google Calendar',
        action_GOOGLE_CALENDAR_DISCONNECTED: 'Прекъснат Google Calendar',
        action_GOOGLE_CALENDAR_SYNCED: 'Синхронизиран Google Calendar',
        action_CREATE_PATIENT: 'Създаден пациент',
        action_UPDATE_PATIENT: 'Обновен пациент',
        action_DELETE_PATIENT: 'Изтрит пациент',
        action_CREATE_PATIENT_PHOTO: 'Създадена снимка на пациент',
        action_UPDATE_PATIENT_PHOTO: 'Обновена снимка на пациент',
        action_DELETE_PATIENT_PHOTO: 'Изтрита снимка на пациент',
        action_CREATE_PATIENT_MEDICAL_HISTORY: 'Създадено медицинско досие на пациента',
        action_UPDATE_PATIENT_MEDICAL_HISTORY: 'Обновено медицинско досие на пациента',
        action_DELETE_PATIENT_MEDICAL_HISTORY: 'Изтрито медицинско досие на пациента',
        action_CREATE_USER: 'Създаден потребител',
        action_UPDATE_USER: 'Обновен потребител',
        action_DELETE_USER: 'Изтрит потребител',
        action_CREATE_ORGANIZATION: 'Създадена организация',
        action_UPDATE_ORGANIZATION: 'Обновена организация',
        action_DELETE_ORGANIZATION: 'Изтрита организация',
        action_CREATE_CALENDAR_EVENT: 'Създадено събитие в календара',
        action_UPDATE_CALENDAR_EVENT: 'Обновено събитие в календара',
        action_DELETE_CALENDAR_EVENT: 'Изтрито събитие в календара',
        action_CREATE_MEDICAL_STAFF: 'Създаден медицински персонал',
        action_UPDATE_MEDICAL_STAFF: 'Обновен медицински персонал',
        action_DELETE_MEDICAL_STAFF: 'Изтрит медицински персонал',
        action_CREATE_DENTAL_OFFICE: 'Създаден стоматологичен кабинет',
        action_UPDATE_DENTAL_OFFICE: 'Обновен стоматологичен кабинет',
        action_DELETE_DENTAL_OFFICE: 'Изтрит стоматологичен кабинет',
        action_CREATE_PROCEDURE: 'Създадена процедура',
        action_UPDATE_PROCEDURE: 'Обновена процедура',
        action_DELETE_PROCEDURE: 'Изтрита процедура',
        action_CREATE_TREATMENT: 'Създадено лечение',
        action_UPDATE_TREATMENT: 'Обновено лечение',
        action_DELETE_TREATMENT: 'Изтрито лечение',
        action_CREATE_APPOINTMENT: 'Създаден час за прием',
        action_UPDATE_APPOINTMENT: 'Обновен час за прием',
        action_DELETE_APPOINTMENT: 'Изтрит час за прием',
        action_CREATE_CONDITION: 'Създадено състояние',
        action_UPDATE_CONDITION: 'Обновено състояние',
        action_DELETE_CONDITION: 'Изтрито състояние',
        action_CREATE_PROCEDURE_TREATMENT: 'Създаденo процедурно лечение',
        action_UPDATE_PROCEDURE_TREATMENT: 'Обновенo процедурно лечение',
        action_DELETE_PROCEDURE_TREATMENT: 'Изтритo процедурно лечение',
        action_CREATE_STATUS_TOOTH: 'Създадено състояние на зъб',
        action_UPDATE_STATUS_TOOTH: 'Обновено състояние на зъб',
        action_DELETE_STATUS_TOOTH: 'Изтрито състояние на зъб',
        action_CREATE_TOOTH: 'Създаден зъб',
        action_UPDATE_TOOTH: 'Обновен зъб',
        action_DELETE_TOOTH: 'Изтрит зъб',
        action_CREATE_TREATMENT_TOOTH: 'Създадено лечение на зъб',
        action_UPDATE_TREATMENT_TOOTH: 'Обновено лечение на зъб',
        action_DELETE_TREATMENT_TOOTH: 'Изтрито лечение на зъб',
        action_CREATE_INVOICE: 'Създадена фактура',
        action_UPDATE_INVOICE: 'Обновена фактура',
        action_CREATE_PROFORMA_INVOICE: 'Създадена проформа фактура',
        action_UPDATE_PROFORMA_INVOICE: 'Обновена проформа фактура',
        organization_settings: 'Организация',
        website: 'Уебсайт',
        clinics: 'Кабинети',
        abbreviation: 'Съкращение',
        color: 'Цвят',
        invalid_vat_number: 'Невалиден ДДС номер.',
        invalid_uic_number: 'Невалиден ЕИК номер.',
        create: 'Създаване',
        update: 'Обновяване',
        delete: 'Изтриване',
        before: 'Преди',
        after: 'След',
        createdAt: 'Създадено на',
        updatedAt: 'Обновено на',
        start: 'Начало',
        end: 'Край',
        id: 'ИД',
        title: 'Заглавие',
        userId: 'Потребителско ИД',
        dentalClinic: 'Клиника',
        doctor: 'Doctor',
        difference: 'Разлика',
        asc: ' възходящo',
        desc: ' низходящo',
        addClinic: 'Добавете клиника',
        enterClinicName: 'Въведете име на клиника',
        editClinic: 'Редактирайте клиника',
        editStatus: 'Редактирайте състояние',
        enterStatusName: 'Въведете име на състояние',
        enterStatusAbbreviation: 'Въведете съкращение на състояние',
        enterStatusColor: 'Въведете цвят на състояние',
        statusDeleteConfirmation: 'Сигурни ли сте, че искате да изтриете това състояние?',
        deleteStatus: 'Изтрийте състояние',
        deleteClinic: 'Изтрийте клиника',
        clinic_deleted: 'Клиниката е изтрита успешно',
        deleted_clinic: 'Изтрита клиника',
        clinicDeleteConfirmation: 'Сигурни ли сте, че искате да изтриете този кабинет?',
        clinicDeleteWarningTitle: 'Тази клиника ще бъде скрита от всички списъци. Съществуващите часове, свързани с нея, ще показват „Изтрита клиника" вместо името на клиниката.',
        clinicDeleteWarningHint: 'За да запазите историята четима, помислете дали да не преименувате клиниката на „(Архив) Име на клиника" вместо да я изтривате.',
        clinicsInfoMessage: 'Тук можете да управлявате физическите местоположения на вашите клиники с техните адреси. Тези локации могат да бъдат избрани при създаване на срещи в календара и ще се показват в известията до пациентите за резервации.',
        clinicTimezone: 'Часова зона',
        clinicTimezoneHint: 'Използва се за напомняния и тихи часове.',
        addStatus: 'Добавете състояние',
        enterTreatmentName: 'Въведете име на лечение',
        enterTreatmentPrice: 'Въведете цена на лечение',
        editTreatment: 'Редактирайте дейност',
        tratmentDeleteConfirmation: "Сигурни ли сте, че искате да изтриете тази дейност?",
        deleteTreatment: 'Изтрийте дейност',
        addProcedure: 'Добавете процедура',
        enterProcedureName: "Въведете име на процедура",
        enterProcedurePrice: 'Въведете цена на процедура',
        editProcedure: 'Редактирайте процедура',
        editProcedureName: 'Редактирайте процедура',
        editProcedurePrice: 'Редактирайте цена на процедура',
        deleteProcedure: 'Изтрийте процедура',
        procedureDeleteConfirmation: 'Сигурни ли сте, че искате да изтриете тази процедура?',
        enterIllnessName: "Въведете име на заболяване",
        editIllness: 'Редактирайте заболяване',
        addIllness: 'Добавете заболяване',
        illnessDeleteConfirmation: 'Сигурни ли сте, че искате да изтриете това заболяване?',
        addAllergy: 'Добавете алергия',
        enterAllergyName: "Въведете име на алергия",
        editAllergy: 'Редактирайте алергия',
        invalid_rzi_practice_code: 'Невалиден РЗИ код на практика.',
        deleteAllergy: 'Изтрийте алергия',
        deleteCalendarEvent: 'Изтрийте събитие',
        allergyDeleteConfirmation: 'Сигурни ли сте, че искате да изтриете тази алергия?',
        eventDeleteConfirmation: 'Сигурни ли сте, че искате да изтриете това събитие?',
        deleteMedication: 'Изтрийте медикамент',
        medicationDeleteConfirmation: 'Сигурни ли сте, че искате да изтриете този медикамент?',
        addMedication: 'Добавете медикамент',
        enterMedicationName: "Въведете име на медикамент",
        editMedication: 'Редактирайте медикамент',
        medication: 'Mедикамент',
        illness: 'Заболяване',
        allergy: 'Алергия',
        deleteIllness: 'Изтрийте заболяване',
        invalid_url: 'Няма такава страница',
        link_expired: 'Линкът е изтекъл',
        successfully_registered: 'Регистриран сте успешно',
        avatar_upload_error: 'Имаше проблем при запазването на Вашия аватар',
        selectPatient: 'Изберете пациент',
        selectPlaceholder: 'Избери',
        selectPatientValidation: 'Моля изберете пациент.',
        from: 'От',
        to: 'До',
        nzis_data_fail: 'Има проблем при изпращането към НЗИС.',
        nzis_data_success: 'Данните бяха изпратени успешно към НЗИС.',
        generalCalendar: 'Общ календар',
        appointmentHour: 'Добави час',
        welcome: 'Здравейте',
        nextHours: 'Следващи часове',
        statistics: 'Статистика',
        sunday: 'Неделя',
        monday: 'Понеделник',
        tuesday: 'Вторник',
        wednesday: 'Сряда',
        thursday: 'Четвъртък',
        friday: 'Петък',
        saturday: 'Събота',
        saveNew: 'Запиши нов',
        toCalendar: 'Към календар',
        dr: 'Д-р',
        proforma_create: 'Създай проформа',
        invoice_create: 'Създай фактура',
        create_button_text: 'Създай',
        paidFinance: 'Платено',
        unpaidFinance: 'Неплатено',
        totalPrice: 'Общо',
        laboratory: 'Лаборатория',
        due: 'Дължимо',
        edit_patient: 'Редактирай пациент',
        delete_appointment: 'Изтрий преглед',
        qr_description: 'Помолете пациента да сканира QR кода и да попълни формата. Възможно е изполването на лично устройство.',
        profile: 'Профил',
        my_profile: 'Моят профил',
        my_details: 'Моите данни',
        memberships: 'Членства',
        create_my_organization: 'Създай моя организация',
        profile_saved: 'Профилът е запазен.',
        active_org: 'Активна',
        create_another_organization: 'Създай друга организация',
        create_org_modal_hint: 'Ще станете Администратор на организацията и ще можете да превключвате организации от горното меню.',
        complete_profile_first: 'Моля, попълнете собственото и фамилното си име преди да създадете организация.',
        new_patient: 'Създаден е нов пациент',
        patient_updated: 'Пациентът беше обновен успешно',
        medical_staff_created: 'Медицинският персонал е създаден успешно',
        medical_staff_updated: 'Медицинският персонал е актуализиран успешно',
        deactivate: 'Деактивирай',
        medical_staff_deactivated: 'Служителят е деактивиран успешно',
        medical_staff_already_deactivated: 'Служителят вече е деактивиран',
        remove_access: 'Премахни достъп',
        access_removed: 'Достъпът е премахнат успешно',
        activate: 'Активирай',
        medical_staff_activated: 'Служителят е активиран успешно',
        medical_staff_already_active: 'Служителят вече е активен',
        deactivate_medical_staff: 'Деактивирай служителя',
        show_inactive: 'Покажи неактивни',
        portal_access: 'Достъп до портала',
        has_portal_access: 'Има достъп до портала',
        no_portal_access: 'Няма достъп до портала',
        grant_access: 'Дай достъп',
        revoke_access: 'Отнеми достъп',
        access_granted: 'Достъпът до портала е предоставен успешно',
        invite_sent_access: 'Поканата е изпратена — достъпът ще бъде активен след регистрация',
        access_revoked: 'Достъпът до портала е отнет успешно',
        grant_access_email_label: 'Имейл адрес за достъп до портала',
        staff_already_has_access: 'Служителят вече има достъп до портала',
        staff_already_has_pending_invite: 'Този имейл адрес вече има изчакваща покана в организацията',
        staff_linked_different_user: 'Служителят е свързан с друг имейл адрес — първо отнемете достъпа',
        staff_inactive_cannot_grant: 'Не може да се предостави достъп на неактивен служител',
        staff_no_access_to_revoke: 'Служителят няма достъп до портала',
        invite_pending: 'Поканата е изпратена',
        resend_invite: 'Изпрати поканата отново',
        invite_resent: 'Поканата е изпратена отново успешно',
        portal_access_description: 'Достъпът до портала позволява на служителя да влезе в Dentobook и да управлява своя график, пациенти и прегледи.',
        portal_access_info_none: "Служителят няма достъп до портала. Използвайте 'Дай достъп', за да изпратите покана.",
        portal_access_info_pending: 'Поканата е изпратена. Служителят ще получи достъп след като приеме поканата и завърши регистрацията.',
        portal_access_info_active: 'Служителят има пълен достъп до портала. Отнемането на достъп ще премахне незабавно влизането им.',
        needs_portal_access: 'Нужда от достъп до портала',
        portal_access_invite_hint: 'Ако е включено, ще изпратим покана по имейл, за да може служителят да влезе в системата.',
        email_required_for_portal_access: 'Имейлът е задължителен за достъп до портала.',
        archived_treatment: 'Архивирано лечение',
        archived_condition: 'Архивирано състояние',
        archived_doctor: 'Архивиран лекар (вече не е в системата)',
        inactive: 'неактивен',
        email_invalid_format: 'Моля, въведете валиден имейл адрес.',
        email_not_verified_title: 'Потвърдете имейл адреса си',
        email_not_verified_subtitle: 'Изпратихме линк за потвърждение на вашия имейл адрес. Проверете входящата поща и кликнете на линка за да продължите.',
        email_not_verified_resend: 'Изпрати отново',
        email_not_verified_resend_success: 'Имейлът за потвърждение е изпратен. Проверете входящата поща.',
        email_not_verified_logout: 'Изход',
        verify_email_page_title: 'Потвърждение на имейл',
        verify_email_success_title: 'Имейлът е потвърден!',
        verify_email_success_subtitle: 'Вашият имейл адрес беше успешно потвърден. Вече можете да използвате акаунта си.',
        verify_email_success_login: 'Към вход',
        verify_email_invalid_token: 'Този линк за потвърждение е невалиден или е изтекъл. Моля, заявете нов.',
        verify_email_already_used: 'Този линк за потвърждение вече е бил използван.',
        verify_email_check_inbox_subtitle: 'Изпратихме линк за потвърждение на {email}. Проверете входящата поща.',
        verify_email_resend_countdown: 'Изпрати отново след {seconds}с',
        verify_email_wrong_email: 'Грешен имейл адрес?',
        verify_email_spam_hint: 'Ако не го виждате, проверете папката за спам.',
        terms_not_accepted_title: 'Условия за ползване',
        terms_not_accepted_subtitle: 'Трябва да приемете Условията за ползване, за да продължите да използвате Dentobook.',
        accept_invite_title: 'Приеми покана',
        accept_invite_description: 'Поканен сте да се присъедините към',
        invite_expired: 'Връзката за покана е изтекла',
        invite_revoked: 'Тази покана е оттеглена',
        invite_already_accepted: 'Тази покана вече е приета',
        invite_invalid: 'Невалидна или непозната връзка за покана',
        accepting_invite: 'Приемане на поканата...',
        invite_accepted: 'Поканата е приета! Пренасочване към входа...',
        invite_switch_failed: 'Поканата е приета, но смяната на организация не успя — отидете на таблото',
        create_account_and_accept: 'Създай акаунт и приеми',
        organization_updated: 'Организацията е актуализирана успешно',
        here: 'тук',
        show_all: 'Покажете всички',
        notifications: 'известия',
        mark_all_read: 'Маркирай всички като прочетени',
        collapse: 'Свиване на менюто',
        invalid_image_format: 'Форматът на файла е невалиден. Валидните формати са: pdf, doc, docx, xls, xlsx, txt, csv, jpg, jpeg, png, gif, webp, bmp.',
        invalid_photo_format: 'Форматът на файла е невалиден. Валидните формати са: jpg, jpeg, png.',
        invalid_image_size: 'Размерът на файла не трябва да превишава 10 MB.',
        invalid_photo_image_size: 'Размерът на файла не трябва да превишава 1 MB.',
        no_notifications: 'Няма нови известия',
        notif_appointment_confirmed: 'Нов час: {patient_name} на {date}',
        notif_appointment_rescheduled: 'Пренасрочен: {patient_name} от {old_date} до {date}',
        notif_appointment_cancelled: 'Отменен час: {patient_name} на {date}',
        notif_patient_deleted: 'Пациент {patient_name} беше изтрит',
        notif_staff_deactivated: 'Служителят {staff_name} беше деактивиран',
        notif_staff_activated: 'Служителят {staff_name} беше активиран',
        freed_slot_flash: 'Часовият слот е освободен',
        endTime_error: 'Времето за край трябва да е след времето за начало на събитието.',
        event_select_alert: 'Не можете да избирате минал период от време.',
        event_move_alert: 'Не може да насрочвате събитие за минал период от време.',
        max_length_250: 'Максималната дължина е 250 символа.',
        max_length_150: 'Максималната дължина е 150 символа.',
        invalid_address: 'Невалиден адрес.',
        invalid_town: 'Невалиден град.',
        close: 'Затвори',
        invalid_country: 'Невалидна държава.',
        no_selected_appointment: 'Моля изберете преглед.',
        iban: 'IBAN',
        invoiceNumber: 'Начален номер за фактури',
        proformaInvoiceNumber: 'Начален номер за проформа фактури',
        duplicated_appointment: 'Преглед със същото име вече съществува.',
        nzis: 'НЗИС',
        from_date: 'От дата',
        unsent: 'Неизпратени',
        sent: 'Изпратени',
        send_to_nzis: 'Изпрати към НЗИС',
        all_data: 'Пациенти с неизпратени данни',
        medical_prescriptions: 'Медицински рецепти',
        excuse_notes: 'Извинителни бележки',
        operations: 'Дейности',
        operation: 'Дейност',
        healthArea: 'Здравна област',
        healthRegion: 'Здравен регион',
        ekkatte: 'ЕККАТТЕ',
        specialization1: 'Общопрактикуващ лекар по дентална медицина',
        specialization2: 'Детска дентална медицина',
        specialization3: 'Орална хирургия',
        specialization4: 'Лицево-челюстна хирургуя / Дентална, орална и лицево-челюстна хирургуя ',
        rhif: 'РЗОК',
        specialisation_code: 'Код на специалност',
        all: 'Всички',
        ambulatory_sheet: 'Амбулаторен лист',
        ambulatory_sheet_fail: 'Има проблем при генерирането на амбулаторния лист.',
        nzis_unavailable: 'НЗИС временно не е достъпна. Проверете интернет връзката или опитайте отново по-късно.',
        diagnose_label: 'Състояние',
        tooth: 'Зъб',
        operation_code: 'Код дейност',
        unsent_single: 'Неизпратено',
        sent_single: 'Изпратено',
        select_at_least_one_item: 'Моля изберете поне един ред.',
        ambulatory_list: 'Амбулаторен лист - бланка (България)',
        organization_documents: 'Документи на организацията',
        platform_forms: 'Платформени формуляри',
        informed_consent: 'Информирано съгласие',
        nhis_consent: 'НЗИС - Съгласие на пациента за достъп до неговото ЕЗД',
        documents: 'Документи',
        profession: 'Професия',
        national_id: 'Национален идентификатор',
        no_diagnose: 'Няма състояние',
        no_treatment: 'Няма дейност',
        cancellation_reason_placeholder: 'Въведете причина за анулирането тук',
        cancellation_reason: 'Причина за анулиране',
        cookies_policy: 'Политика за бисквитки',
        usage_rules: 'Правила за използване',
        terms_and_conditions: 'Общи условия',
        gdpr: 'GDPR',
        create_note: 'Създай бележка',
        start_date: 'Начална дата',
        end_date: 'Крайна дата',
        serve_to: 'Да послужи пред',
        english_letters_only_field: 'Това поле трябва да съдържа само латински букви',
        signature_client_not_found: 'Приложението за синхронизация на електронен подпис не е открито!',
        signature_client_start: 'Моля, стартирайте Dentobook eSign App или го свалете и инсталирайте от',
        here_msg: 'тук',
        addCredentials: 'Добавете Google Credentials',
        googleWarning: 'Вашият клиентски идентификатор в Google не е конфигуриран. Моля, настройте го за повторно удостоверяване.',
        reAuth: 'Сесията ви е изтекла. Моля, удостоверете се повторно с Google.',
        googleLogin: 'Влезте с Google.',
        clientId: 'Client Id',
        clientSecret: 'Client Secret',
        editCredentials: 'Редактирайте Google Credentials',
        identifierAlert: 'ЕГН не съвпада с дата на раждане моля коригирайте данните.',
        patientEmailAlert: 'Имейлът на пациента не е наличен. Събитието в Google Календар не може да бъде създадено. Продължава се със създаването/актуализирането на редовното събитие в календара.',
        done_operations: 'Изпълнени дейности',
        done_operations_info: 'Само приключените дейности със стойност по-голяма от нула, които все още не са фактурирани, се показват тук.',
        invoices: 'Фактури',
        proforma_invoices: 'Проформа фактури',
        maturity: 'Падеж',
        price_value: 'Стойност',
        paid_price_value: 'Платено',
        payment_type: 'Тип на плащане',
        canceled_finance: 'Анулирано',
        paid_invoice: 'Платена',
        unpaid_invoice: 'Неплатена',
        canceled_invoice: 'Анулирана',
        cash_payment_type: 'В брой',
        card_payment_type: 'С карта',
        paid_obligations: 'Платени',
        create_invoice: 'Създай фактура',
        payment_deadline: 'Срок на плащане',
        payment_method: 'Начин на плащане',
        vat_label: 'ДДС',
        bank_transfer: 'Банков превод',
        create_proforma_invoice: 'Създай проформа фактура',
        update_proforma_invoice: 'Проформа',
        tooth_status_delete_confirm: 'Сигурни ли сте, че искате да изтриете този зъбен статус?',
        tooth_treatment_delete_confirm: 'Сигурни ли сте, че искате да изтриете това лечение?',
        leave_page_title: 'Напускане на страница',
        leave_page: 'Напусни страница',
        leave_page_message: 'Напускането на тази страница ще изтрие всички незапазени данни. Моля, запазете промените преди да напуснете.',
        field_too_long_message: 'Стойността е прекалено дълга.',
        proforma_void_message: 'Сигурни ли сте, че искате да анулирате тази проформа фактура?',
        void_message: 'Сигурни ли сте, че искате да анулирате тази фактура?',
        void_button: 'Анулирай',
        invoice_generate_confirm: 'Сигурни ли сте, че искате да генерирате фактура от проформа фактура?',
        generate_btn: 'Генерирай',
        generate_invoice_tooltip: 'Генерирай фактура',
        edit_tooltip: 'Редактирай',
        print_tooltip: 'Принтирай',
        nzis_mandatory_fields: 'Попълнете следните полета в пациентския профил: [FIELDS]. След като попълните полетата, ще можете да продължите.',
        invoice_numbering_title: 'Промяна на номерацията на фактурите',
        invoice_numbering_text: 'Dentobook генерира уникален 10-разреден последователен номер за всяка издадена фактура. При липсата на фактури, съхранени в базата данни, първият номер ще бъде 0000000001, а всеки следващ - с единица по-голям. Ако това не е първата Ви фактура, променете номера, от който започва броенето.',
        proforma_numbering_title: 'Промяна на номерацията на проформа фактурите',
        proforma_numbering_text: 'Dentobook генерира уникален 10-разреден последователен номер за всяка издадена проформа фактура. При липсата на проформа фактури, съхранени в базата данни, първият номер ще бъде 0000000001, а всеки следващ - с единица по-голям. Ако това не е първата Ви проформа фактура, променете номера, от който започва броенето.',
        invoice_config_setup_title: 'Настройка на конфигурация за фактури',
        invoice_config_setup_description: 'Преди да можете да създавате фактури, трябва да конфигурирате как ще се генерират номерата на фактурите. Това е еднократна настройка.',
        invoice_configuration: 'Конфигурация на фактури',
        proforma_invoice_configuration: 'Конфигурация на проформа фактури',
        proforma_config_setup_title: 'Настройка на конфигурация за проформа фактури',
        proforma_config_setup_description: 'Преди да можете да създавате проформа фактури, трябва да конфигурирате как ще се генерират номерата на проформа фактурите. Това е еднократна настройка.',
        invoice_config_prefix: 'Префикс (незадължителен)',
        invoice_config_prefix_help: 'Текст преди номера (напр. INV, FACT)',
        invoice_config_prefix_placeholder: 'INV',
        invoice_config_starting_number: 'Начален номер',
        invoice_config_starting_number_min: 'Началният номер трябва да бъде поне 1',
        invoice_config_digits_count: 'Брой цифри',
        invoice_config_digits_count_help: 'Общ брой цифри за числовата част (допълнени с нули)',
        invoice_config_digits_count_range: 'Броят на цифрите трябва да бъде между 6 и 15',
        invoice_config_example: 'Примерен номер на фактура',
        invoice_config_example_text: 'Въз основа на вашите настройки, първият номер на фактура ще бъде:',
        error_creating_invoice_config: 'Неуспешно създаване на конфигурация за фактури. Моля, опитайте отново.',
        reports_label: 'Репорти',
        patients_all_label: 'Пациент (Всички)',
        doctors_all_label: 'Доктор (Всички)',
        doctor_label: 'Доктор',
        day_label: 'Ден',
        week_label: 'Седмица',
        month_label: 'Месец',
        period_label: 'Период',
        debt_label: 'Дълг',
        download_report: 'Изтегли репорт',
        yesterday: 'Вчера',
        this_week: 'Тази седмица',
        last_week: 'Миналата седмица',
        this_month: 'Този месец',
        last_month: 'Миналият месец',
        period: 'Период',
        continue: 'Продължи',
        continue_free_version: 'Продължи с безплатен план',
        choose_plan: 'Изберете план',
        compare_plans: 'Вижте и сравнете функционалностите',
        dentobook_start_one: 'При избор на Dentobook Start, получавате',
        dentobook_start_two: 'пълен достъп до всички функции на Pro за период от 6 месеца',
        dentobook_start_three: 'След изтичането на този период, част от функциите ще бъдат заключени, оставяйки само основните инструменти в Start.',
        dentobook_pro: 'Пълен достъп до всички функционалности на Dentobook за ефективно управление на вашата стоматологична практика.',
        paymentMethod: 'Метод на плащане',
        choose_plan_msg: 'Моля изберете план.',
        logout_msg: 'Действието изисква излизане от Вашия профил. Сигурни ли сте, че искате да продължите?',
        organization_conflict: 'Организация със зададеното име вече съществува.',
        clientIdRequired: 'ID на клиента е задължителен.',
        clientIdMinLength: 'ID на клиента трябва да бъде поне 10 символа.',
        clientSecretRequired: 'Client Secret е задължителен.',
        clientSecretMinLength: 'Client Secret трябва да бъде поне 16 символа.',
        missingFirstName: 'Липсва първо име.',
        missingLastName: 'Липсва фамилия.',
        missingBothNames: 'Липсват данни за име и фамилия.',
        subscription: 'Абонамент',
        active_subscription: 'Активен абонамент',
        subscription_description: 'Осигурете си пълен достъп до всички функции на Dentobook Pro, като изберете платения план. Само за 4,99 € на месец ще запазите всички инструменти и функционалности, които използвате.',
        subscription_description_free_trial: 'Започнете с 30-дневен безплатен пробен период с пълен достъп до всички функционалности на Dentobook за ефективното управление и оптимизиране на вашата практика. Без въвеждане на банкова карта*',
        subscription_description_free_trial_profile: '30-дневен безплатен пробен период с пълен достъп до всички функционалности на Dentobook за ефективното управление и оптимизиране на вашата практика. След пробния период можете да продължите абонамента само за 4,99 € на месец.',
        subscription_description_start: 'Безплатен план',
        next_payment: 'Следващо плащане',
        cancel_subscription: 'Прекрати',
        subscribe: 'Плати абонамент',
        renew_subscription: 'Поднови',
        cancel_subscription_text: 'Сигурни ли сте, че искате да прекратите абонамента си?',
        subscription_active_warning: 'Вашият пълен достъп до всички функции на Dentobook Pro за период от 30 дни изтича след {days} {unit}. Моля, {a}, за да подновите и активирате Dentobook Pro.',
        subscription_expired_warning: 'Вашият пълен достъп до всички функции на Dentobook Pro за период от 30 дни изтече. Моля, {a}, за да подновите и активирате Dentobook Pro.',
        free_trial_title: '30 дневен пробен период',
        dentobook_pro_title: 'Dentobook Pro - 4,99 €',
        payment_error: 'Възникна грешка при плащането',
        missing_required_fields: 'Моля, попълнете задължителните полета',
        payment_method_creation_error: 'Възникна грешка при създаване на метода за плащане',
        registration_successful: 'Регистрацията е успешно завършена',
        payment_token_error: 'Възникна грешка при плащането. Моля, проверете метода за плащане',
        subscription_payment_failed: 'Вашите данни за плащане са неуспешни. Моля, актуализирайте метода за плащане, за да продължите.',
        free_trial_plan_name: '30 дневен пробен период',
        card_declined: 'Вашето плащане беше отказано.',
        expired_card: 'Вашата карта е изтекла.',
        incorrect_cvc: 'Невалидно CVC.',
        processing_error: 'Вашата карта не може да бъде прочетена.',
        incorrect_number: 'Невалиден номер.',
        expires_at: 'Изтича на',
        credit_card_title: 'С кредитна/дебитна карта',
        card_number_title: 'Номер на карта',
        card_expiration_title: 'ММ/ГГ',
        postal_code_title: 'ПК',
        subscription_expiration: 'Вашият абонамент ще изтече на',
        create_event_not_allowed: 'Създаването на календарни събития и използването на интеграция с Google не са разрешени за вашия текущ план.',
        doctors_statistics_label: 'Лекари',
        assistants_statistics_label: 'Асистенти',
        receptionists_statistics_label: 'Рецепционисти',
        download: 'Изтегли',
        report_problem: 'Докладвай проблем',
        send_feedback: 'Предложи подобрение',
        currency_label: 'Валута',
        billing: 'Плащания',
        billing_details: 'Детайли за месечното фактуриране',
        company_name: 'Име на фирмата',
        account_status: 'Статус на акаунт',
        active_label: 'Активен',
        trial_label: 'Пробен',
        expired_label: 'Изтекъл',
        last_login_label: 'Последен вход',
        login_count_label: 'Брой на вход',
        delete_organization: 'Изтрий организация',
        delete_action: 'Изтрий',
        delete_organization_confirmation_text: 'Сигурни ли сте, че искате да изтриете организацията заедно с всички свързани данни (пациенти, лекари, срещи и други)?',
        invalid_vat_bg: 'Невалиден ДДС номер. Трябва или да започва с \'BG\', последван от 9 или 10 цифри, или да съдържа точно 9 цифри.',
        patients_count: 'Брой пациенти',
        calendar_appointments_count: 'Брой календарни срещи',
        hosted_invoice_url: 'URL на хоствана фактура',
        invoice_pdf: 'PDF фактура',
        amount_paid: 'Платена сума',
        view_hosted_invoice: 'Преглед на хоствана фактура',
        download_invoice_pdf: 'Изтегли PDF фактура',
        choose_file_dropbox: 'Изберете или провлачете документ',
        delete_document: 'Документът беше изтрит успешно',
        document_delete_confirm: 'Сигурни ли сте че искате да изтриете този документ?',
        remember_me: 'Запомни ме',
        remember_me_tooltip: 'Остани в акаунта до 2 седмици',
        password: 'Парола',
        logging_in: 'Влизане...',
        login: 'Вход',
        forgot_password: 'Забравена парола?',
        no_account: 'Нямате акаунт?',
        register_here: 'Регистрирайте се тук',

        // ForgotPassword page
        forgot_password_title: 'Забравена парола?',
        forgot_password_description: 'Въведете имейл адреса си и ще ви изпратим линк за нулиране на паролата.',
        email_required_error: 'Моля, въведете имейл адреса си.',
        email_placeholder: 'Въведете имейл адреса си',
        sending: 'Изпращане...',
        send_reset_link: 'Изпрати линк за нулиране',
        back_to_login: 'Обратно към вход',
        password_reset_link_sent: 'Ако съществува акаунт с този имейл, линк за нулиране на паролата е изпратен.',

        // ResetPassword page
        reset_password_title: 'Нулиране на парола',
        reset_password_description: 'Създайте нова парола за вашия акаунт.',
        new_password: 'Нова парола',
        confirm_new_password: 'Потвърдете новата парола',
        new_password_required: 'Моля, въведете новата си парола.',
        password_min_length_error: 'Паролата трябва да бъде поне 9 символа.',
        confirm_password_required: 'Моля, потвърдете паролата си.',
        passwords_do_not_match: 'Паролите не съвпадат.',
        new_password_placeholder: 'Въведете новата си парола',
        confirm_password_placeholder: 'Потвърдете новата си парола',
        resetting: 'Нулиране...',
        reset_password_button: 'Нулирай парола',
        password_reset_success: 'Паролата ви беше успешно нулирана.',
        invalid_reset_token: 'Невалиден или изтекъл токен за нулиране.',
        reset_link_expired: 'Линкът за нулиране е изтекъл. Моля, поискайте нов.',
        reset_link_expired_title: 'Линкът за нулиране е изтекъл',
        password_must_contain_number: 'Паролата трябва да съдържа поне една цифра.',
        password_must_contain_special: 'Паролата трябва да съдържа поне един специален символ.',
        password_must_contain_uppercase: 'Паролата трябва да съдържа поне една главна буква.',
        password_must_contain_lowercase: 'Паролата трябва да съдържа поне една малка буква.',
        password_requirements_hint: 'Паролата трябва да бъде поне 9 символа и да съдържа цифри, специални символи, главни и малки букви.',
        redirecting_to_login: 'Пренасочване към вход...',

        // Registration page
        register_organization_title: 'Регистрирайте вашата организация',
        organization_registration_title: 'Регистрация на организация',
        account_registration_title: 'Регистрация на акаунт',
        organization_name: 'Име на организацията',
        vat_number: 'ДДС номер',
        business_address: 'Бизнес адрес',
        organization_name_required: 'Моля, въведете име на организацията.',
        clinic_name_required: 'Моля, въведете име на клиниката.',
        vat_number_required: 'Моля, въведете ДДС номер.',
        password_required_error: 'Моля, въведете парола.',
        first_name_required: 'Моля, въведете собствено име.',
        last_name_required: 'Моля, въведете фамилия.',
        country_required: 'Моля, изберете държава.',
        phone_required: 'Моля, въведете телефонен номер.',
        phone_format_hint: 'Използвайте международен формат, напр. +359888123456',
        phone_international_required: 'Телефонът трябва да започва с "+" и код на държавата (напр. +359888123456).',
        next: 'Напред',
        previous: 'Назад',
        submit: 'Изпрати',
        already_have_account: 'Вече имате акаунт?',
        login_here: 'Влезте тук',
        registration_successful: 'Регистрацията е успешна!',
        check_email_verification: 'Моля, проверете имейла си, за да потвърдите акаунта си.',
        registration_failed: 'Регистрацията е неуспешна. Моля, опитайте отново.',
        email_already_taken: 'Имейлът вече е зает.',
        email_already_taken_register: 'Този имейл вече е регистриран. Ако е ваш, влезте в акаунта и създайте организацията от {link}.',
        organization_already_exists: 'Организация със същото име вече съществува.',
        registration_success_message: 'Успешно се регистрирахте! Ще бъдете пренасочени към страницата за вход.',
        successful_registration_title: 'Успешна регистрация',
        close: 'Затвори',
        phone_number: 'Телефонен номер',
        invalid_phone_number_text: 'Невалиден телефонен номер.',
        first_name_letters_only: 'Името трябва да съдържа само букви',
        last_name_letters_only: 'Фамилията трябва да съдържа само букви',
        organization_name_max_length: 'Името на организацията не трябва да надвишава 250 символа.',
        clinic_name_max_length: 'Името на клиниката не трябва да надвишава 250 символа.',
        create_account: 'Създай акаунт',
        confirm_password: 'Потвърди парола',

        // RegisterUser page
        register_new_user_title: 'Регистрирай нов потребител',
        user_details: 'Данни за потребителя',
        create_user_account: 'Създай потребителски акаунт',
        medical_staff_label: 'Медицински персонал',
        user_role: 'Роля на потребителя',
        medical_staff_required: 'Моля, изберете медицински персонал.',
        user_role_required: 'Моля, изберете роля на потребителя.',
        select_medical_staff: 'Изберете медицински персонал',
        select_role: 'Изберете роля',
        registering: 'Регистриране...',
        register_user_button: 'Регистрирай потребител',
        user_registered_success: 'Потребителят е успешно регистриран!',
        user_registration_failed: 'Неуспешна регистрация на потребител.',
        organization: 'Организация',
        organization_required: 'Моля, изберете организация.',
        health_insurance_filter_info: 'В списъка се показват само здравноосигурителни дружества от {country}.',
        switch_organization: 'Смяна на организация',
        help_nav: 'Помощ',
        help_legal: 'Контакти и правна информация',
        help_title: 'Помощ и база знания',
        help_search_placeholder: 'Търсене на статии...',
        all_categories: 'Всички категории',
        help_not_found: 'Статията не е намерена',
        help_not_found_desc: 'Тази статия не съществува или връзката е невалидна.',
        back_to_help: 'Обратно към помощта',
        help_category_organizations: 'Организации',
        help_category_access: 'Достъп и покани',
        help_article_multi_org_title: 'Поддръжка на множество организации',
        help_article_multi_org_desc: 'Разберете как Dentobook управлява няколко клиники в един акаунт и какво се променя при смяна.',
        help_article_multi_org_h1: 'Какво означава поддръжка на множество организации?',
        help_article_multi_org_p1: 'Dentobook позволява на един потребителски акаунт да принадлежи към повече от една организация. Всяка организация е независима клиника или практика със собствен персонал, пациенти, прегледи и данни.',
        help_article_multi_org_p2: 'Организацията, която в момента е активна, се нарича "текуща организация". Тя е показана в горната навигационна лента. Всичко, което преглеждате или създавате в Dentobook — пациентски записи, прегледи, персонал, отчети — принадлежи само на текущата организация.',
        help_article_multi_org_h2: 'Какво се променя при смяна на организацията?',
        help_article_multi_org_p3: 'При смяна на организацията Dentobook издава нова сесия и презарежда приложението. Вашият изглед — пациенти, календар, персонал и отчети — веднага ще отразява данните на новоизбраната организация.',
        help_article_multi_org_p4: 'Вашата роля може да се различава между организациите. Например, може да сте Администратор в едната и Дентален лекар в другата. Менюто и правата, които виждате, зависят от ролята ви в текущата организация.',
        help_article_multi_org_h3: 'Кой вижда превключвателя на организации?',
        help_article_multi_org_p5: 'Превключвателят на организации се показва в горната навигационна лента само когато акаунтът ви е активен член на повече от една организация. Ако принадлежите само към една организация, превключвателят не се показва.',
        help_article_multi_org_h4: 'Създаване на собствена организация, докато работите в друга клиника',
        help_article_multi_org_p6: 'Ако вече сте член на друга организация — например работите като стоматолог в практиката на колега — пак можете да създадете и управлявате собствена организация в Dentobook. Отворете Моят профил от менюто в горния десен ъгъл и кликнете "Създай моята организация". Съществуващото ви членство в другата клиника остава напълно непокътнато. След създаването ставате Администратор на новата организация и можете свободно да превключвате между всичките си организации по всяко време.',
        help_article_multi_org_p7: 'Ако все още нямате акаунт в Dentobook, завършете регистрацията първо. След влизане отворете Моят профил, за да създадете организацията си. Ако опитате да се регистрирате с имейл, който вече е в системата — защото администратор на клиника ви е поканил преди това — Dentobook ще покаже директна връзка към страницата Моят профил, откъдето можете да продължите.',
        help_article_switching_title: 'Смяна на организации',
        help_article_switching_desc: 'Как да използвате превключвателя на организации, за да смените активната организация.',
        help_article_switching_h1: 'Как да смените организацията',
        help_article_switching_p1: 'Кликнете върху името или аватара на организацията си в горната навигационна лента. Появява се падащо меню с всички организации, в които сте активен член, с отметка до текущата.',
        help_article_switching_p2: 'Кликнете върху желаната организация. Накратко се появява зареждащ екран, докато Dentobook издава нов токен за сесия, след което страницата се презарежда в контекста на избраната организация.',
        help_article_switching_h2: 'Когато превключвателят не се вижда',
        help_article_switching_p3: 'Превключвателят се показва само когато акаунтът ви е активен член на повече от една организация. Ако превключвателят липсва, може да принадлежите само към една организация или членствата ви в другите организации са премахнати или спрени от администратор.',
        help_article_switching_h3: 'След смяна на организацията',
        help_article_switching_p4: 'Всички данни се зареждат наново от сървъра след смяна. Никаква информация от предишната организация не се запазва. Ако навигирате обратно, страницата ще показва данни за новата текуща организация.',
        help_article_invitations_title: 'Покани и достъп до портала',
        help_article_invitations_desc: 'Как да предоставите, управлявате и приемете достъп до портала за членове на персонала.',
        help_article_invitations_h1: 'Предоставяне на достъп до портала',
        help_article_invitations_p1: 'Администраторът на клиниката може да предостави достъп до портала на член на персонала от страницата с детайли за съответния член. Въведете имейл адреса и кликнете "Предоставяне на достъп". Ще бъде изпратен имейл с покана.',
        help_article_invitations_p2: 'Докато поканата не бъде приета, статусът на достъпа до портала на члена на персонала се показва като "Покана в очакване". Администраторите могат да препратят или оттеглят поканата в това състояние.',
        help_article_invitations_h2: 'Приемане на покана — съществуващ потребител',
        help_article_invitations_p3: 'Ако поканеният имейл принадлежи на съществуващ акаунт в Dentobook, получателят посещава връзката в имейла с поканата и кликва "Приеми покана". Съществуващият акаунт се свързва с организацията и потребителят е пренасочен към вход.',
        help_article_invitations_p4: 'Ако потребителят вече е влязъл, когато посети връзката с поканата, Dentobook автоматично го превключва към новата организация без нужда от повторно влизане.',
        help_article_invitations_h3: 'Приемане на покана — нов потребител',
        help_article_invitations_p5: 'Ако поканеният имейл не принадлежи на съществуващ акаунт в Dentobook, се показва формуляр за регистрация. Потребителят въвежда своите имена и парола, отговаряща на изискванията за сигурност. След изпращане акаунтът е създаден, свързан с организацията и потребителят е пренасочен към вход.',
        help_article_invitations_h4: 'Препращане и оттегляне на покани',
        help_article_invitations_p6: 'Препращането на покана генерира нов токен и нулира срока на валидност до 7 дни. Оттеглянето на покана я анулира и нулира статуса на члена до "Без достъп до портала". Съществуващият потребителски акаунт на члена — ако вече е бил свързан — не се изтрива.',
        help_article_invitations_h5: 'Предоставяне на достъп при добавяне на нов член на персонала',
        help_article_invitations_p7: 'Превключвателят "Нужда от достъп до портала" се появява в създаваемия формуляр. Включете го, за да изпратите покана в момента на създаване. Когато превключвателят е включен, полето за имейл е задължително. Оставете го изключен, за да създадете записа без покана — можете да предоставите достъп по-късно от страницата с детайли на члена.',
        help_article_invitations_p8: 'Системата не позволява изпращане на дублирани покани: ако вече съществува покана в очакване за този имейл в организацията ви, формулярът ще покаже грешка — оттеглете съществуващата покана първо, след което създайте новия запис. Ако имейлът вече принадлежи на активен член на организацията, покана не е необходима.',
        help_article_troubleshooting_title: 'Отстраняване на проблеми с достъпа',
        help_article_troubleshooting_desc: 'Чести проблеми при смяна на организация и покани за достъп до портала и как да ги разрешите.',
        help_article_troubleshooting_h1: 'Превключвателят на организации не се вижда',
        help_article_troubleshooting_p1: 'Превключвателят се показва само когато акаунтът ви е активен член на повече от една организация. Приемането на покана не актуализира текущата ви сесия — излезте и влезте отново, за да опресните сесията с новото членство.',
        help_article_troubleshooting_h2: 'Поканата показва "изтекла"',
        help_article_troubleshooting_p2: 'Линковете с покани изтичат след 7 дни. Помолете администратора на вашата клиника да препрати поканата. Препращането генерира нов линк, валиден за още 7 дни.',
        help_article_troubleshooting_h3: 'Поканата показва "оттеглена"',
        help_article_troubleshooting_p3: 'Поканата е анулирана от администратор. Свържете се с администратора на вашата клиника, за да поискате нова покана.',
        help_article_troubleshooting_h4: 'Поканата показва "вече приета"',
        help_article_troubleshooting_p4: 'Всеки линк с покана може да се използва само веднъж. Ако вече сте приели поканата, но организацията не се вижда в превключвателя, излезте и влезте отново, за да опресните сесията с обновеното членство.',
        help_article_troubleshooting_h5: 'Грешка 403 при смяна на организация',
        help_article_troubleshooting_p5: 'Грешка 403 при смяна на организация означава, че членството ви в тази организация е премахнато или спряно след последното ви влизане. Свържете се с администратора на тази организация за помощ.',
        help_article_troubleshooting_h6: 'Грешка при създаване на член на персонала с достъп до портала',
        help_article_troubleshooting_p6: 'Ако формулярът показва грешка след включване на превключвателя "Нужда от достъп до портала", вече съществува покана в очакване за този имейл в организацията ви. Намерете съществуващия запис за този имейл, оттеглете поканата и след това запазете новия запис.',
        help_category_account: 'Моят акаунт',
        help_article_profile_title: 'Моят профил',
        help_article_profile_desc: 'Управлявайте личните си данни, преглеждайте членствата си в организации и създайте собствена организация.',
        help_article_profile_h1: 'Преглед и редактиране на вашите данни',
        help_article_profile_p1: 'Отворете Моят профил от менюто в горния десен ъгъл. Страницата показва вашите имена, имейл адрес и телефонен номер. Имейлът е само за четене и не може да се промени тук. Кликнете Редактиране, за да актуализирате имената или телефонния номер.',
        help_article_profile_h2: 'Вашите членства в организации',
        help_article_profile_p2: 'Разделът Членства изброява всички организации, към които принадлежи акаунтът ви. За всеки запис можете да видите името на организацията, вашата роля и статуса на членството. Организацията, в която работите в момента, е маркирана като Активна.',
        help_article_profile_h3: 'Създаване на собствена организация',
        help_article_profile_p3: 'Кликнете "Създай моята организация", за да стартирате нова организация. Ако вече притежавате такава, бутонът гласи "Създай друга организация". Въведете името на организацията и потвърдете. След създаването автоматично ставате Администратор на организацията, тя се превръща в активна и Dentobook превключва към нея.',
        help_article_profile_h4: 'Изискване за попълнен профил',
        help_article_profile_p4: 'Преди да създадете организация, вашето собствено и фамилно име трябва да бъдат попълнени. Ако някое от полетата е празно, Dentobook блокира действието и показва предупреждение. Попълнете профила си първо, след което продължете с създаването на организацията.',
        help_category_notifications: 'Известия и съобщения',
        help_article_notif_overview_title: 'Преглед на известията',
        help_article_notif_overview_desc: 'Как Dentobook информира служителите на клиниката за важна дейност в приложението.',
        help_article_notif_overview_h1: 'Какво са известията?',
        help_article_notif_overview_p1: 'Dentobook информира служителите на клиниката чрез известия. Те се появяват в приложението и могат да бъдат изпращани и по имейл. Известията се задействат от важни събития, свързани с часове, пациенти и дейността на клиниката.',
        help_article_notif_overview_h2: 'Известия в приложението',
        help_article_notif_overview_p2: 'Известията се появяват под иконата с камбанка в горната навигационна лента. Значката показва броя на непрочетените. Кликнете върху камбанката, за да видите последната активност. Можете да маркирате всички известия като прочетени наведнъж с бутона в долната част на панела.',
        help_article_notif_overview_p3: 'Кликването върху известие може да отвори съответния запис, да открои освободен часови слот в календара или просто да го маркира като прочетено.',
        help_article_notif_overview_h3: 'Кой получава кои известия?',
        help_article_notif_overview_p4: 'Различни потребители могат да получават различни известия в зависимост от тяхната роля и участие в дейността. Администраторите на клиниката могат да получават допълнителни оперативни известия. Останалите служители обикновено получават тези, свързани с часовете или пациентите, в които са пряко въвлечени. Пациентите с достъп до портала също могат да получават известия за собствените им часове.',
        help_article_messaging_title: 'Съобщения и настройка на Twilio',
        help_article_messaging_desc: 'Как да свържете вашия Twilio акаунт и да конфигурирате SMS и WhatsApp известия за пациенти.',
        help_article_messaging_h1: 'Какво прави системата за съобщения?',
        help_article_messaging_p1: 'Dentobook може автоматично да изпраща известия до пациенти, включително потвърждения за часове, напомняния, известия за промяна на графика и отмени. Поддържани канали са SMS и WhatsApp.',
        help_article_messaging_h2: 'Как работи — Bring Your Own Twilio',
        help_article_messaging_p2: 'Dentobook се интегрира с Twilio за изпращане на съобщения, но не действа като доставчик на съобщения. Всяка клиника свързва собствения си Twilio акаунт и плаща директно на Twilio. Dentobook не таксува за съобщение и не препродава услуги за съобщения.',
        help_article_messaging_h3: 'Къде да намерите настройките за съобщения',
        help_article_messaging_p3: 'Отидете в Настройки на организацията и отворете раздела Съобщения. Ако Twilio все още не е конфигуриран, Помощникът за настройка се появява автоматично. Можете също да стартирате помощника отново по всяко време от страницата Съобщения.',
        help_article_messaging_h4: 'Стъпки на помощника за настройка',
        help_article_messaging_p4: 'Помощникът ви води през шест стъпки. Добре дошли представя настройката. Акаунт ви моли да потвърдите, че имате Twilio акаунт. Данни за достъп е мястото, където въвеждате вашия Twilio Account SID и Auth Token — и двете се намират в Twilio конзолата. Податели е където конфигурирате SMS телефонния номер и по желание WhatsApp подател. Тест ви позволява да изпратите тестово съобщение, за да проверите дали всичко работи. Край ви позволява да активирате SMS и/или WhatsApp канали.',
        help_article_messaging_h5: 'Настройка на SMS',
        help_article_messaging_p5: 'SMS е най-лесният вариант. Нуждаете се от Twilio акаунт и Twilio телефонен номер. След като номерът ви е конфигуриран в помощника, SMS работи незабавно.',
        help_article_messaging_h6: 'Настройка на WhatsApp',
        help_article_messaging_p6: 'WhatsApp изисква допълнителна регистрация извън Twilio акаунт. Трябва да се присъедините към Twilio WhatsApp Sandbox за тестване, след което да регистрирате WhatsApp подател за продукционна употреба. Одобрението на подателя се обработва от Twilio и Meta. Можете да започнете с SMS и да добавите WhatsApp по-късно.',
        help_article_messaging_h7: 'Сигурност',
        help_article_messaging_p7: 'Вашите Twilio данни за достъп са криптирани в покой. Те се използват само за изпращане на съобщения от собствения Twilio акаунт на вашата клиника. Dentobook не съхранява данни за достъп в обикновен текст.',
        help_article_messaging_h8: 'Ценообразуване',
        help_article_messaging_p8: 'Dentobook не таксува за съобщения. Всички разходи за съобщения се фактурират от Twilio директно на Twilio акаунта на вашата клиника съгласно стандартното ценообразуване на Twilio.',
        help_article_messaging_h9: 'Отстраняване на проблеми',
        help_article_messaging_p9: 'Чести проблеми: Невалидни данни за достъп — проверете Account SID и Auth Token в Twilio конзолата. Телефонният номер не работи — уверете се, че номерът е активен и поддържа SMS във вашия Twilio акаунт. WhatsApp не изпраща — потвърдете, че вашият WhatsApp подател е одобрен и регистриран. Sandbox не е свързан — за WhatsApp тестване трябва първо да се присъедините към Twilio Sandbox.',
        help_category_patients: 'Пациенти',
        help_article_patient_import_title: 'Импортиране на пациенти',
        help_article_patient_import_desc: 'Как да прехвърлите съществуващия си списък с пациенти в Dentobook чрез бързо въвеждане или качване на файл.',
        help_article_patient_import_h1: 'Общ преглед',
        help_article_patient_import_p1: 'Страницата „Импортиране на пациенти" ви позволява да добавите няколко пациента наведнъж. Можете да въведете или поставите до 20 реда директно в браузъра (Бързо въвеждане) или да качите CSV или Excel файл с произволен брой редове.',
        help_article_patient_import_p2: 'Само Клинични администратори могат да импортират пациенти. Отидете на Пациенти → Импортиране на пациенти, за да започнете.',
        help_article_patient_import_h2: 'Бързо въвеждане',
        help_article_patient_import_p3: 'Решетката за бързо въвеждане е най-бързият начин за импортиране на малка група пациенти. Щракнете върху клетка и започнете да пишете или поставете таблица, копирана от Excel или друга електронна таблица. Използвайте Tab за преминаване към следващата колона, Enter или стрелка надолу за следващия ред, и бутона „+ Добави ред" за разширяване на решетката.',
        help_article_patient_import_p4: 'Щракнете върху „Валидиране", за да проверите всички редове преди запазване. Редовете с грешки са маркирани в червено с кратко описание. Коригирайте грешките и валидирайте отново. Когато всички редове показват зелено, щракнете върху „Импортиране".',
        help_article_patient_import_h3: 'Импортиране от файл',
        help_article_patient_import_p5: 'За по-големи списъци изтеглете CSV или Excel шаблона от горната част на страницата. Попълнете го с предпочитана от вас електронна таблица и го качете чрез раздела „Импортиране от файл". Dentobook показва преглед на редовете преди записването им.',
        help_article_patient_import_p6: 'Телефонните номера и националните идентификатори трябва да се въвеждат като текст. В Excel форматирайте тези колони като „Текст" преди въвеждане на данни или добавете апостроф пред стойностите. Изтегленият Excel шаблон вече има тези колони предварително форматирани.',
        help_article_patient_import_h4: 'Преглед на резултатите от импортирането',
        help_article_patient_import_p7: 'След щракване върху „Импортиране" всеки ред показва един от три резултата: Импортиран (нов пациент е създаден), Предупреждение за дубликат (пациент с подобни данни вече съществува — редът се импортира, но е маркиран за преглед) или Неуспешен (задължително поле липсва или е невалидно — редът се пропуска).',
        help_article_patient_import_p8: 'Лентата за обобщение показва общия брой импортирани, пропуснати и неуспешни редове. Можете да прегледате неуспешните редове директно в решетката и да ги коригирате, без да започвате отначало.',
        help_article_patient_import_h5: 'История на импортиранията',
        help_article_patient_import_p9: 'Всяка сесия за импортиране се записва. Щракнете върху „Виж историята на импортиранията" в горната част на страницата, за да видите списък с минали импортирания с времеви марки, брой редове и името на администратора, извършил операцията.',
        help_article_patient_import_p10: 'Страницата с история не ви позволява да отмените импортиране. Ако трябва да премахнете неправилно импортирани пациенти, отворете всеки запис на пациент и го изтрийте или архивирайте ръчно.',
        help_article_patient_import_h6: 'Нужна ви е помощ с персонализиран формат?',
        help_article_patient_import_p11: 'Ако текущият ви софтуер експортира данни за пациенти във формат, който не съответства на шаблона на Dentobook, използвайте раздела „Нужна ли е помощ?" на страницата за импортиране. Опишете ситуацията си и прикачете примерен файл. Екипът за поддръжка на Dentobook ще прегледа файла и ще ви помогне да съпоставите колоните правилно.',
        help_article_patient_import_p12: 'Примерните файлове се съхраняват 30 дни, след което автоматично се изтриват. Никога не включвайте чувствителни данни на пациенти в примерен файл — използвайте анонимизирани или фиктивни записи, когато е възможно.',
        org_switched_after_revoke: 'Достъпът ви беше отнет. Вие бяхте превключени към {orgName}.',
        messaging_settings: 'Съобщения',
        messaging_settings_description: 'Конфигурирайте кога се изпращат напомняния за срещи. Изберете канал, за да активирате известията, или оставете без канал, за да ги деактивирате.',
        messaging_timezone_info: 'Отстъпите за напомняния и тихите часове се прилагат в местното часово пространство на клиниката, свързана с часа. Ако организацията ви има клиники в различни часови зони, всяка клиника ще изпраща напомняния в собственото си местно време.',
        email_notifications_enabled: 'Активирайте имейл известия',
        default_notification_channel: 'Канал по подразбиране',
        channel_none: 'Без (изключено)',
        channel_email: 'Имейл',
        channel_sms: 'SMS',
        channel_whatsapp: 'WhatsApp',
        reminder_offsets: 'Изпращане на напомняния',
        reminder_24h: '24 часа преди',
        reminder_2h: '2 часа преди',
        quiet_hours: 'Тихи часове (без напомняния)',
        quiet_hours_hint: 'Въведете времена в HH:MM формат (24-часов часовник). Оставете празно за деактивиране.',
        messaging_quiet_hours_delay: 'Ако едно напомняне попадне в тихите часове, Dentobook автоматично ще го изпрати в следващия разрешен момент.',
        email_from_name: 'Показвано име на подателя',
        email_from_address: 'Имейл адрес на подателя',
        sms_enabled_label: 'Активиране на SMS известия',
        whatsapp_enabled_label: 'Активиране на WhatsApp известия',
        sms_whatsapp_status: 'SMS / WhatsApp канали',
        twilio_credentials_status: 'Twilio данни за достъп',
        twilio_configured: 'Конфигурирано',
        twilio_not_configured: 'Не е конфигурирано',
        twilio_credentials_note: 'Данните за достъп не се показват след запазване. Оставете полетата празни, за да запазите текущите стойности.',
        twilio_account_sid_label: 'Twilio Account SID',
        twilio_auth_token_label: 'Twilio Auth Token',
        twilio_sms_from_label: 'Телефонен номер за SMS',
        twilio_whatsapp_from_label: 'Телефонен номер за WhatsApp',
        twilio_from_hint: 'Телефонен номер в E.164 формат от вашия Twilio акаунт (напр. +359888123456)',
        twilio_credentials_saved_placeholder: 'Запазено (оставете празно за запазване на текущите)',
        twilio_status_not_configured: 'Не е конфигурирано',
        twilio_status_not_verified: 'Конфигурирано — не е проверено',
        twilio_status_verified: 'Проверено',
        twilio_status_failed: 'Проверката е неуспешна',
        twilio_verify_btn: 'Провери данните',
        twilio_verify_success: 'Twilio данните са проверени успешно.',
        twilio_verify_failed: 'Проверката на Twilio данните е неуспешна.',
        twilio_not_verified_channel_warning: 'Проверете Twilio данните си, преди да активирате този канал.',
        messaging_saved: 'Настройките за съобщения са запазени.',
        messaging_save_error: 'Неуспешно запазване на настройките за съобщения.',
        messaging_section_email: 'Имейл и напомняния',
        messaging_section_sms: 'SMS',
        messaging_section_whatsapp: 'WhatsApp',
        messaging_section_twilio: 'Twilio доставчик',
        messaging_section_status: 'Статус на съобщенията',
        status_provider: 'Доставчик',
        status_sms: 'SMS',
        status_whatsapp: 'WhatsApp',
        status_ready: 'Готов',
        status_not_enabled: 'Не е активиран',
        status_missing_sender: 'Липсва подател',
        status_not_configured: 'Не е конфигуриран',
        status_sandbox_only: 'Само Sandbox',
        status_not_verified: 'Не е проверен',
        status_next_action: 'Следваща стъпка',
        next_action_run_wizard: 'Стартирайте помощника за настройка, за да свържете Twilio',
        next_action_verify: 'Проверете вашите Twilio данни за достъп',
        next_action_add_sms_sender: 'Добавете SMS подател номер',
        next_action_add_whatsapp_sender: 'Добавете WhatsApp подател',
        next_action_enable_channel: 'Активирайте поне един канал (SMS или WhatsApp)',
        messaging_setup_complete: 'Настройка на съобщения',
        messaging_setup_percent: '{percent}% завършена',
        twilio_info_box: 'SMS и WhatsApp съобщенията се доставят чрез Twilio. Нужен ви е Twilio акаунт с активен телефонен номер, за да използвате тези канали.',
        twilio_setup_guide: 'За настройка на Twilio са нужни Account SID и Auth Token от Twilio Console, плюс телефонен номер за изпращане на съобщения.',
        twilio_link_console: 'Twilio Console (Account SID и Auth Token)',
        twilio_link_sms: 'Настройка на SMS номер',
        twilio_link_whatsapp: 'Настройка на WhatsApp изпращач',
        twilio_credential_saved: 'Запазено',
        twilio_credential_not_set: 'Не е зададено',
        twilio_clear_credentials_btn: 'Изтрий данните за достъп',
        twilio_clear_credentials_confirm: 'Сигурни ли сте, че искате да изтриете запазените Twilio данни? SMS и WhatsApp ще спрат да работят.',
        twilio_sid_masked: 'AC••••••••',
        preferred_notification_channel: 'Предпочитан канал',
        patient_email_allowed: 'Имейл разрешен',
        patient_phone_allowed: 'Телефонни съобщения разрешени',
        patient_channel_helper: 'Контролира как напомнянията за часове и други известия се доставят на този пациент.',
        wizard_step_intro: 'Добре дошли',
        wizard_step_account: 'Акаунт',
        wizard_step_credentials: 'Данни',
        wizard_step_senders: 'Изпращачи',
        wizard_step_test: 'Тест',
        wizard_step_finish: 'Край',
        wizard_intro_title: 'Настройте съобщения за напомняния',
        wizard_intro_p1: 'Dentobook използва Twilio за доставка на SMS и WhatsApp съобщения до пациентите. Вашата клиника създава собствен Twilio акаунт и плаща директно на Twilio — Dentobook не таксува за съобщения.',
        wizard_intro_p2: 'Този помощник ще ви преведе през свързването на Twilio акаунта, конфигуриране на изпращачи и тестване на доставката.',
        wizard_intro_sms_easy: 'SMS е най-лесен за настройка — нужен ви е само Twilio телефонен номер.',
        wizard_intro_whatsapp_note: 'WhatsApp изисква допълнителна регистрация на изпращач чрез Twilio и Meta. Можете да го настроите по-късно.',
        wizard_start_setup: 'Започни настройка',
        wizard_skip_for_now: 'Пропусни засега',
        wizard_account_title: 'Създайте или отворете вашия Twilio акаунт',
        wizard_account_p1: 'Ако все още нямате Twilio акаунт, създайте такъв чрез линка по-долу. Twilio предлага безплатен пробен период.',
        wizard_account_p2: 'След като акаунтът е готов, ще ви трябват Account SID и Auth Token от таблото на Twilio Console.',
        wizard_create_twilio_account: 'Създай Twilio акаунт',
        wizard_open_twilio_console: 'Отвори Twilio Console',
        wizard_have_account: 'Имам Twilio акаунт',
        wizard_back: 'Назад',
        wizard_credentials_title: 'Свържете вашите Twilio данни',
        wizard_credentials_p1: 'Въведете Account SID и Auth Token от вашия Twilio Console. Данните се съхраняват сигурно и са криптирани.',
        wizard_credentials_find: 'Можете да ги намерите в',
        wizard_save_and_verify: 'Запази и провери',
        wizard_continue: 'Продължи',
        wizard_senders_title: 'Конфигурирайте номерата за изпращане',
        wizard_sms_sender_help: 'Въведете SMS номера от вашия Twilio акаунт. Този номер ще се показва като подател на SMS съобщенията.',
        wizard_whatsapp_sender_help: 'WhatsApp изисква регистриран номер на изпращач. Това изисква допълнителна настройка в Twilio акаунта ви.',
        wizard_test_title: 'Изпратете тестово съобщение',
        wizard_test_p1: 'Изпратете тестово съобщение, за да проверите дали настройката работи. Въведете номер, който можете да проверите веднага.',
        wizard_test_channel: 'Канал',
        wizard_test_phone: 'Телефонен номер на получателя',
        wizard_send_test: 'Изпрати тест',
        wizard_test_success: 'Тестовото съобщение е изпратено успешно! Проверете телефона си.',
        wizard_test_failed: 'Тестовото съобщение не можа да бъде изпратено.',
        wizard_finish_title: 'Настройката на съобщенията е завършена!',
        wizard_finish_subtitle: 'Вашият Twilio акаунт е свързан. Изберете кои канали да активирате за известия.',
        wizard_enable_channels: 'Активиране на канали',
        wizard_no_sms_sender: 'Не е конфигуриран SMS изпращач — SMS не може да бъде активиран.',
        wizard_no_whatsapp_sender: 'Не е конфигуриран WhatsApp изпращач — WhatsApp не може да бъде активиран.',
        wizard_finish_btn: 'Завърши настройката',
        wizard_rerun_btn: 'Стартирай помощника',
        // Patient import
        import_patients: 'Импорт на пациенти',
        import_patients_desc: 'Добавяйте пациенти масово чрез ръчно въвеждане или качване на файл.',
        import_v1_scope_notice: 'Импортират се само демографски данни. Часове, лечения, фактури и медицинска история не се включват.',
        import_tab_quick_entry: 'Бързо въвеждане',
        import_tab_file: 'Файлов импорт',
        import_tab_support: 'Нужна помощ?',
        import_quick_entry_hint: 'Поставете от Excel или Google Sheets, започвайки от активната клетка {ctrl}.{br}{tab} ({shiftTab} за предишно поле) и {enter} за навигация, или използвайте мишката свободно.{br}Кликнете {addRow}, за да добавите редове.{br}Съвет: поставените данни запълват съседните клетки надясно и надолу от активната клетка.',
        import_add_row: 'Добави ред',
        import_row_count: '{count} / {max} реда',
        import_paste_hint: 'Съвет: кликнете първо върху начална клетка, след това поставете от Excel или Google Sheets (Ctrl+V). Поставеният диапазон запълва съседните клетки надясно и надолу.',
        import_validate_button: 'Провери за грешки',
        import_commit_button: 'Импортирай {count} реда',
        import_commit_all_button: 'Импортирай всички редове',
        import_clear_all: 'Изчисти всичко',
        import_validate_error: 'Валидацията се провали. Моля, опитайте отново.',
        import_commit_error: 'Импортирането се провали. Моля, опитайте отново.',
        import_upload_error: 'Качването на файла се провали. Проверете формата и опитайте отново.',
        import_parsing_file: 'Обработване на файл…',
        import_file_upload_hint: 'Кликнете или плъзнете файл тук за качване',
        import_file_upload_formats: 'Поддържа .csv и .xlsx — макс. 1 000 реда · макс. 5 MB',
        import_file_too_large: 'Файлът надвишава лимита от 5 MB. Моля, разделете го на по-малки файлове.',
        import_file_too_many_rows: 'Файлът съдържа повече от 1 000 реда. Моля, разделете на по-малки пакети.',
        import_total_rows: '{count} реда',
        import_valid_rows: '{count} валидни',
        import_warning_rows: '{count} предупреждения за ЕГН',
        import_conflict_rows: '{count} предупреждения за ЕГН',
        import_commit_result: 'Импортирани {committed} · Неуспешни {failed} · Пропуснати {skipped}',
        import_download_template: 'Изтегли шаблон',
        import_download_template_csv: 'CSV Шаблон',
        import_download_template_xlsx: 'Excel Шаблон',
        import_view_history: 'История',
        import_history_title: 'История на импорта',
        import_history_empty: 'Все още няма импортирани сесии.',
        import_history_date: 'Дата',
        import_history_source: 'Тип',
        import_history_file: 'Файл',
        import_history_total: 'Общо',
        import_history_committed: 'Импортирани',
        import_history_warnings: 'Предупреждения',
        import_history_status: 'Статус',
        import_history_created_by: 'Създадено от',
        import_history_back: 'Назад към импорта',
        import_history_load_error: 'Неуспешно зареждане на историята на импорта.',
        import_source_manual: 'Ръчно',
        import_source_csv: 'CSV',
        import_source_excel: 'Excel',
        import_status_validated: 'Валидирано',
        import_status_committed: 'Завършено',
        import_status_partial: 'Частично',
        import_status_draft: 'Чернова',
        import_duplicate_national_id_warning: 'Националният идентификатор вече съществува в базата данни — прегледайте преди импортиране.',
        import_upload_another: 'Качи друг файл',
        import_support_title: 'Различен формат на износ?',
        import_support_desc: 'Опишете формата на данните и ние ще ви помогнем да настроите правилен импорт — безплатно. Ще ви отговорим на имейл адреса от вашия акаунт.',
        import_support_message_label: 'Опишете формата си',
        import_support_message_placeholder: 'Опишете системата, от която износвате, и колоните в файла…',
        import_support_file_label: 'Примерен файл (по избор)',
        import_support_file_hint: 'Пуснете примерен файл тук или кликнете за избор',
        import_support_submit: 'Изпрати заявка',
        import_support_sent: 'Заявката е изпратена!',
        import_support_sent_desc: 'Ще се свържем в рамките на 1–2 работни дни на имейл адреса на вашия акаунт.',
        import_support_error: 'Заявката не можа да бъде изпратена. Моля, опитайте отново.',
        import_support_org_label: 'Импортиране в организация',
        import_support_org_placeholder: 'Изберете организация',
        import_support_org_load_error: 'Неуспешно зареждане на организациите. Моля, опреснете и опитайте отново.',
        import_support_org_not_specified: 'Не е посочена',
        import_row_status_draft: 'Чернова',
        import_row_status_valid: 'Валиден',
        import_row_status_invalid: 'Невалиден',
        import_row_status_duplicate_warning: 'Дубликат?',
        import_row_status_conflict: 'Конфликт',
        import_row_status_saving: 'Запазване…',
        import_row_status_saved: 'Запазен',
        import_row_status_failed: 'Неуспешен',
        import_row_status_skipped: 'Пропуснат',
        import_fix_n_issues: 'Поправи {count} грешки',
        gender_other: 'Друг',
        national_id_label: 'ЕГН / Национален ID',
        full_name: 'Пълно име',
        field_required: 'Това поле е задължително',
    },
    [LOCALES.TURKISH]: {
        home: 'Ana Sayfa',
        user_content: 'Kullanıcıya ait bilgiler burada gösterilecek',
        users: 'Kullanıcılar',
        user: 'Kullanıcı',
        patients: 'Hastalar',
        first_name: 'İsim',
        surname: 'İkinci ad',
        last_name: 'Soyadı',
        phone: 'Telefon',
        phone_label: 'Telefon (+359)',
        phone_label_two: 'Telefon',
        dashboard: 'Gösterge Paneli',
        logout: 'Oturumu Kapat',
        logoutConfirm: 'Oturumu kapatmak istediğinizden emin misiniz?',
        settings: 'Ayarlar',
        register: 'Kayıt Ol',
        components: 'Bileşenler',
        name: 'Ad',
        lastAppointment: 'Son Randevu',
        nextAppointment: 'Sonraki Randevu',
        search: 'Ara',
        sortBy: 'Sırala',
        filterBy: 'Filtrele',
        order: 'Sıralama',
        ascending: 'Artan',
        descending: 'Azalan',
        filter: 'Filtre',
        resetFilter: 'Filtreyi Sıfırla',
        diagnose: 'Durum',
        registeredOn: 'Kayıt Tarihi',
        email: 'E-posta',
        town: 'Şehir',
        country: 'Ülke',
        account_status: 'Hesap Durumu',
        addressOne: 'Adres 1',
        addressTwo: 'Adres 2',
        notes: 'Notlar',
        birth_date: 'Doğum Tarihi',
        gender: 'Cinsiyet',
        source: 'Kaynak',
        source_name: 'Kaynak Adı',
        last_hour: 'Son Randevu',
        next_hour: 'Sonraki Randevu',
        doctors: 'Diş Hekimleri',
        personal_information: 'Kişisel Bilgiler',
        registration: 'Kayıt',
        contact: 'İletişim Bilgileri',
        cancel: 'İptal',
        save: 'Kaydet',
        copied: 'Kopyalandı',
        payments: 'Ödemeler',
        paid: 'Ödendi',
        obligations: 'Yükümlülükler',
        address: 'Adres',
        edit: 'Düzenle',
        required_field: 'Bu alan zorunludur.',
        clinic_name_min_length: 'Klinik adı en az 2 karakter olmalıdır.',
        invalid_tooth_position: 'Geçersiz diş pozisyonu.',
        invalid_email: 'Geçersiz e-posta.',
        gender_male: 'Erkek',
        gender_female: 'Kadın',
        main_information: 'Ana Bilgiler',
        medical_history: 'Teşhis ve Tedavi',
        medicalHistoryLabel: 'Teşhis ve Tedavi',
        treatment: 'Tedavi',
        treatments: 'Tedaviler',
        finances: 'Finans',
        upcoming_feature: 'Yakında gelecek özellik',
        photos: 'Fotoğraflar',
        back: 'Geri',
        add: 'Ekle',
        add_patient: 'Hasta Ekle',
        unsaved_changes: 'Kaydedilmemiş değişiklikler var. Kaydetmeden devam etmek istediğinizden emin misiniz?',
        confirm: 'Onayla',
        invalid_phone_number: 'Geçersiz telefon numarası.',
        invalid_phone_e164: 'Telefon E.164 formatında olmalıdır (ör. +905551234567)',
        invalid_field: 'Geçersiz alan.',
        years_old: 'yaşında',
        year_old: 'yaşında',
        levs: 'EUR',
        success_message: 'Değişiklikleriniz başarıyla kaydedildi.',
        not_available: 'Yok',
        nzis_confirm: 'Onayla ve NHIS\'e veri gönder',
        unexpected_error: 'Bir hata oluştu.',
        complete_bot_verification: 'Lütfen bot doğrulamasını tamamlayın.',
        registration_completed: 'Kayıt başarıyla tamamlandı.',
        x_ray_photos: 'Röntgen Fotoğrafları',
        patient_photos: 'Hasta Fotoğrafları',
        choose_image_category: 'Resim kategorisi seçin',
        category: 'Kategori',
        choose: 'Seç',
        drag_or_choose: 'Fotoğrafları seçin ya da sürükleyin',
        delete_text: 'Sil',
        move_text: 'Taşı',
        confirmation_text: 'Bu işlemi yapmak istediğinizden emin misiniz?',
        delete_patient: 'Hastayı sil',
        medical_staff: 'Personel',
        egn: 'PIN',
        add_medical_staff: 'Personel ekle',
        update_medical_staff: 'Personeli düzenle',
        registration_error: 'Kayıt başarısız oldu',
        specialisation: 'Uzmanlık',
        uin: 'UIN',
        work_time: 'Çalışma saatleri',
        dentist: 'Diş hekimi',
        all_loaded: 'Tüm veriler yüklendi.',
        loading: 'Yükleniyor...',
        no_data: 'Veri yok',
        upload_avatar: 'Profil fotoğrafı yükle',
        organizations: 'Organizasyonlar',
        email_queue: 'E-posta Kuyruğu',
        add_organization: 'Organizasyon ekle',
        naming: 'Adlandırma',
        parent_organization: 'Üst organizasyon',
        organization_conflict: 'Organizasyon zaten mevcut',
        organization_details: 'Organizasyon detayları',
        edit_organization: 'Organizasyon düzenle',
        create_organization: 'Organizasyon oluştur',
        assistant: 'Asistan',
        duplicate_email: 'Bu e-posta zaten kullanılıyor',
        letters_only_field: 'Bu alan sadece harf içerebilir.',
        letters_and_numbers_only: 'Bu alan yalnızca harf ve rakam içerebilir.',
        digits_only_field: 'Bu alan sadece rakam içerebilir.',
        discount_too_large: 'İndirim %100\'den fazla olamaz',
        patient: 'Hasta',
        company: 'Şirket',
        social_network: 'Sosyal Ağ',
        calendar: 'Takvim',
        clinic: 'Klinik',
        all_clinics: 'Tüm klinikler',
        select_clinic: 'Klinik seçin',
        clinic_required: 'Lütfen bir klinik seçin.',
        googleCredentials: 'Google Bilgileri',
        googleCalendar: 'Google Calendar',
        googleCalendarDescription: 'Randevuları senkronize etmek için Google Calendar\'ınızı bağlayın. Dentobook tek doğruluk kaynağıdır - burada oluşturulan randevular Google Calendar\'a gönderilecektir. Google Calendar\'daki değişiklikler geri senkronize edilmeyecektir.',
        connectGoogleCalendar: 'Google Calendar Bağla',
        connected: 'Bağlı',
        notConnected: 'Bağlı Değil',
        googleAccount: 'Google Hesabı',
        lastSync: 'Son Senkronizasyon',
        syncError: 'Senkronizasyon Hatası',
        syncNow: 'Şimdi Senkronize Et',
        disconnect: 'Bağlantıyı Kes',
        howToConnect: 'Nasıl Bağlanılır',
        googleCalendarConnectInstructions: 'Google Calendar hesabınızı bağlamak için aşağıdaki butona tıklayın',
        googleCalendarStep1: '"Google Calendar Bağla" butonuna tıklayın',
        googleCalendarStep2: 'Google hesabınızla giriş yapın',
        googleCalendarStep3: 'Takviminizi senkronize etmek için izin verin',
        confirmDisconnectGoogleCalendar: 'Google Calendar bağlantısını kesmek istediğinizden emin misiniz? Bu, randevuların senkronizasyonunu durduracaktır.',
        googleCalendarConnectedSuccess: 'Google Calendar Başarıyla Bağlandı!',
        checkActivityLogForDetails: 'Ayrıntılar için Etkinlik Günlüğünüzü kontrol edin',
        connectedAccount: 'Bağlı hesap',
        closingWindow: 'Pencere kapatılıyor...',
        youCanCloseThisTab: 'Bu sekmeyi şimdi kapatabilirsiniz.',
        googleCalendarConnectionFailed: 'Google Calendar Bağlantısı Başarısız',
        pleaseCloseAndTryAgain: 'Lütfen bu pencereyi kapatın ve tekrar deneyin.',
        youCanCloseThisTabAndTryAgain: 'Bu sekmeyi kapatabilir ve ayarlar sayfasından tekrar deneyebilirsiniz.',
        googleCalendarDisconnected: 'Google Calendar başarıyla bağlantısı kesildi',
        syncCompleted: 'Senkronizasyon Tamamlandı',
        initialSyncCompleted: 'İlk İçe Aktarma Tamamlandı',
        eventsSynced: 'etkinlik senkronize edildi',
        eventsImported: 'etkinlik içe aktarıldı',
        eventsSkipped: 'etkinlik atlandı',
        eventsFailed: 'etkinlik başarısız',
        general: 'Genel',
        appointments: 'Randevular',
        choose_appointment: 'Randevu seç',
        milkTeeth: 'Süt dişleri',
        permTeeth: 'Kalıcı',
        description: 'Açıklama',
        date: 'Tarih',
        fromDate: 'Başlangıç tarihi',
        position: 'Pozisyon',
        condition: 'Durum',
        nzis_condition: 'NHIS adı',
        nzis_treatment_label: 'NHIS tedavisi',
        nzis_condition_label: 'NHIS durumu',
        add_condition: 'Durum ekle',
        add_condition_title: 'Durum ekle',
        quick_status: 'Hızlı durum',
        quick_status_more: 'Diğer seçenekler',
        quick_status_clear: 'Durumu temizle',
        quick_status_not_configured: 'Durum yapılandırılmamış',
        quick_status_save_failed: 'Diş durumu kaydedilemedi. Lütfen tekrar deneyin.',
        add_appointment: 'Randevu ekle',
        edit_appointment: 'Randevuyu düzenle',
        tooth_status: 'Diş durumu',
        tooth_status_quick_help: 'İpucu: Bir dişin üzerine geldiğinizde durumu anında uygulamak için bir harf kısayoluna (C, P, G, R, O, E, K, X, F) basın, dişin üstündeki paletteki hızlı düğmelere tıklayın veya notlar ve ayrıntılar için tam düzenleyiciyi açmak üzere dişin kendisine tıklayın.',
        treatment_plan: 'Tedavi',
        procedure: 'Prosedür',
        dental_doctor: 'Diş hekimi',
        sum: 'Fiyat',
        status: 'Durum',
        treatment_label: 'Tedavi',
        overall_price: 'Fiyat',
        price: 'Fiyat',
        discount: 'İndirim (%)',
        discounts: 'İndirim',
        discount_label: 'İndirim',
        overall_laboratory_price: 'Laboratuvar maliyeti',
        procedures: 'Prosedürler',
        laboratory_price: 'Laboratuvar maliyeti',
        currency: 'Para birimi',
        vat_excluded: 'Tüm tutarlar KDV hariçtir',
        add_procedure: 'Prosedür ekle',
        add_plan_title: 'Tedavi ekle',
        all_fields_required: 'Lütfen gerekli tüm alanları doldurun.',
        fill_all_required_fields: 'Lütfen gerekli tüm alanları doldurun.',
        treatment_of: 'Tedavisi',
        in_progress: 'Devam ediyor',
        canceled: 'İptal edildi',
        done: 'Tamamlandı',
        offered: 'Teklif edildi',
        qr_code_generator: 'QR kod oluşturucu',
        manual_input: 'Manuel giriş',
        qr_code_generator_description: 'Hastanın bilgileri kendisinin girmesini isterseniz bu seçeneği seçin',
        manual_input_description: 'Tüm hasta bilgilerini manuel olarak girmek isterseniz bu seçeneği seçin',
        general_medical_history: 'Genel tıbbi geçmiş',
        general_illness_suffering: 'Herhangi bir genel hastalıktan muzdarip misiniz?',
        medications_taking: 'Herhangi bir ilaç kullanıyor musunuz?',
        medications: 'İlaçlar',
        allergy_having: 'Alerjiniz var mı? (yiyecek, ilaç vb.)',
        allergies: 'Alerjiler',
        pregnancy_planning: 'Bayanlar için: Hamilelik planlıyor musunuz?',
        yes_ans: 'Evet',
        no_ans: 'Hayır',
        pregnant_ans: 'Hamileyim',
        nursing_question: 'Bayanlar için: Şu anda emziriyor musunuz?',
        anamensis_title: 'Ağız geçmişi ve ağız hijyen alışkanlıkları',
        anesthetic_question: 'Daha önce diş tedavisi için lokal anestezi aldınız mı?',
        higiene_question: 'Diş hekiminiz tarafından düzenli olarak diş taşı ve plak temizliği yaptırıyor musunuz?',
        social_anamnezis: 'Sosyal geçmiş',
        dentist_visit_question: 'Diş hekimine ne sıklıkla gidiyorsunuz?',
        dentist_last_visit_question: 'Son diş hekiminizi ne zaman ziyaret ettiniz?',
        fear_question: 'Diş tedavisinden korkuyor musunuz?',
        fear_ans: 'Bazen (işleme bağlı)',
        dentist_visit_ans1: 'Yılda en az iki kez',
        dentist_visit_ans2: 'Yılda bir kez önlem amaçlı',
        dentist_visit_ans3: 'Yılda bir kereden az',
        dentist_visit_ans4: 'Sadece bir sorun olduğunda',
        illnesses: 'Hastalıklar',
        medical_history_info: 'Hastalıklar, alerjiler ve ilaçlar organizasyon düzeyinde yönetilir. Bunları değiştirebilir, ekleyebilir ve silebilirsiniz. Hepsini silerseniz, hasta oluştururken kendinizinkini ekleyebilirsiniz.',
        create_button_text: 'Oluştur',
        reason: 'Sebep',
        total: 'Toplam',
        procedure_calculated_in_treatment: 'Prosedür tedaviye dahil edilmiştir',
        procedure_not_calculated_in_treatment: 'Prosedür ekstra ücretlidir',
        totalTwo: 'Toplam',
        treatmentPriceTooLow: 'Tedavi ücreti, prosedürlerin toplamından düşük olamaz',
        anesthetic_question2: 'Daha önce diş tedavisi için lokal anestezi aldınız mı?',
        is_health_insured_question: 'Hastanın ek sağlık sigortası var mı?',
        last_visit_patient_quesiton: 'Hastanın son diş muayenesi ne zamandı?',
        frequency_quesiton: 'Hasta diş hekimini ne sıklıkla ziyaret ediyor?',
        is_patient_afraid_question: 'Hasta diş tedavisinden korkuyor mu?',
        smoker_question: 'Hasta sigara kullanıyor mu?',
        yes: 'Evet',
        no: 'Hayır',
        sometimes: 'Bazen',
        twice_a_year: 'Yılda iki kez',
        once_a_year: 'Yılda bir kez',
        rarely: 'Nadiren',
        only_when_necessary: 'Yalnızca gerektiğinde',
        insurance_question: 'Ek sağlık sigortanız var mı?',
        insurer: 'Sigortacı',
        smoker_question2: 'Sigara kullanıyor musunuz?',
        activity_log: 'Etkinlik kaydı',
        action: 'İşlem',
        today: 'Bugün',
        details: 'Detaylar',
        role: 'Rol',
        PLATFORM_ADMINISTRATOR: 'Platform Yöneticisi',
        CLINIC_ADMIN: 'Klinik Yöneticisi',
        MEDICAL_DOCTOR: 'Doktor',
        DENTAL_TECHNICIAN: 'Diş Teknisyeni',
        MEDICAL_ASSISTANT: 'Asistan',
        RECEPTIONIST: 'Resepsiyonist',
        PATIENT: 'Hasta',
        company_data: 'Şirket verileri',
        logo: 'Logo',
        uic: 'UIC',
        vat: 'KDV numarası',
        rzi_practice_code: 'RHI uygulama kodu',
        accountable_person: 'Sorumlu kişi',
        conditions: 'Durumlar',
        action_LOGIN: 'Giriş',
        action_LOGOUT: 'Çıkış',
        action_GOOGLE_CALENDAR_CONNECTED: 'Google Calendar bağlandı',
        action_GOOGLE_CALENDAR_DISCONNECTED: 'Google Calendar bağlantısı kesildi',
        action_GOOGLE_CALENDAR_SYNCED: 'Google Calendar senkronize edildi',
        action_CREATE_PATIENT: 'Hasta oluşturuldu',
        action_UPDATE_PATIENT: 'Hasta güncellendi',
        action_DELETE_PATIENT: 'Hasta silindi',
        action_CREATE_PATIENT_PHOTO: 'Hasta fotoğrafı eklendi',
        action_UPDATE_PATIENT_PHOTO: 'Hasta fotoğrafı güncellendi',
        action_DELETE_PATIENT_PHOTO: 'Hasta fotoğrafı silindi',
        action_CREATE_PATIENT_MEDICAL_HISTORY: 'Hasta tıbbi geçmişi oluşturuldu',
        action_UPDATE_PATIENT_MEDICAL_HISTORY: 'Hasta tıbbi geçmişi güncellendi',
        action_DELETE_PATIENT_MEDICAL_HISTORY: 'Hasta tıbbi geçmişi silindi',
        action_CREATE_USER: 'Kullanıcı oluşturuldu',
        action_UPDATE_USER: 'Kullanıcı güncellendi',
        action_DELETE_USER: 'Kullanıcı silindi',
        action_CREATE_ORGANIZATION: 'Organizasyon oluşturuldu',
        action_UPDATE_ORGANIZATION: 'Organizasyon güncellendi',
        action_DELETE_ORGANIZATION: 'Organizasyon silindi',
        action_CREATE_CALENDAR_EVENT: 'Takvim etkinliği oluşturuldu',
        action_UPDATE_CALENDAR_EVENT: 'Takvim etkinliği güncellendi',
        action_DELETE_CALENDAR_EVENT: 'Takvim etkinliği silindi',
        action_CREATE_MEDICAL_STAFF: 'Tıbbi personel oluşturuldu',
        action_UPDATE_MEDICAL_STAFF: 'Tıbbi personel güncellendi',
        action_DELETE_MEDICAL_STAFF: 'Tıbbi personel silindi',
        action_CREATE_DENTAL_OFFICE: 'Diş kliniği oluşturuldu',
        action_UPDATE_DENTAL_OFFICE: 'Diş kliniği güncellendi',
        action_DELETE_DENTAL_OFFICE: 'Diş kliniği silindi',
        action_CREATE_PROCEDURE: 'Prosedür oluşturuldu',
        action_UPDATE_PROCEDURE: 'Prosedür güncellendi',
        action_DELETE_PROCEDURE: 'Prosedür silindi',
        action_CREATE_TREATMENT: 'Tedavi oluşturuldu',
        action_UPDATE_TREATMENT: 'Tedavi güncellendi',
        action_DELETE_TREATMENT: 'Tedavi silindi',
        action_CREATE_APPOINTMENT: 'Randevu oluşturuldu',
        action_UPDATE_APPOINTMENT: 'Randevu güncellendi',
        action_DELETE_APPOINTMENT: 'Randevu silindi',
        action_CREATE_CONDITION: 'Durum oluşturuldu',
        action_UPDATE_CONDITION: 'Durum güncellendi',
        action_DELETE_CONDITION: 'Durum silindi',
        action_CREATE_PROCEDURE_TREATMENT: 'Tedavi prosedürü oluşturuldu',
        action_UPDATE_PROCEDURE_TREATMENT: 'Tedavi prosedürü güncellendi',
        action_DELETE_PROCEDURE_TREATMENT: 'Tedavi prosedürü silindi',
        action_CREATE_STATUS_TOOTH: 'Diş durumu oluşturuldu',
        action_UPDATE_STATUS_TOOTH: 'Diş durumu güncellendi',
        action_DELETE_STATUS_TOOTH: 'Diş durumu silindi',
        action_CREATE_TOOTH: 'Diş oluşturuldu',
        action_UPDATE_TOOTH: 'Diş güncellendi',
        action_DELETE_TOOTH: 'Diş silindi',
        action_CREATE_TREATMENT_TOOTH: 'Diş tedavisi oluşturuldu',
        action_UPDATE_TREATMENT_TOOTH: 'Diş tedavisi güncellendi',
        action_DELETE_TREATMENT_TOOTH: 'Diş tedavisi silindi',
        action_CREATE_INVOICE: 'Fatura oluşturuldu',
        action_UPDATE_INVOICE: 'Fatura güncellendi',
        action_CREATE_PROFORMA_INVOICE: 'Proforma fatura oluşturuldu',
        action_UPDATE_PROFORMA_INVOICE: 'Proforma fatura güncellendi',
        organization_settings: 'Organizasyon',
        website: 'Web Sitesi',
        clinics: 'Odalar',
        abbreviation: 'Kısaltma',
        color: 'Renk',
        invalid_vat_number: 'Geçersiz KDV numarası.',
        invalid_uic_number: 'Geçersiz UIC numarası.',
        invalid_rzi_practice_code: 'Geçersiz RHI uygulama kodu.',
        create: 'Oluştur',
        update: 'Güncelle',
        delete: 'Sil',
        before: 'Önce',
        after: 'Sonra',
        createdAt: 'Oluşturulma tarihi',
        updatedAt: 'Güncelleme tarihi',
        start: 'Başlangıç',
        end: 'Bitiş',
        id: 'ID',
        title: 'Başlık',
        userId: 'Kullanıcı ID',
        dentalClinic: 'Klinik',
        doctor: 'Doktor',
        difference: 'Fark',
        asc: 'Artan',
        desc: 'Azalan',
        addClinic: 'Klinik ekle',
        enterClinicName: 'Klinik adı girin',
        editClinic: 'Kliniği düzenle',
        editStatus: 'Durumu düzenle',
        enterStatusName: 'Durum adını girin',
        enterStatusAbbreviation: 'Durum kısaltması girin',
        enterStatusColor: 'Durum rengi girin',
        statusDeleteConfirmation: 'Bu durumu silmek istediğinize emin misiniz?',
        deleteStatus: 'Durumu sil',
        deleteClinic: 'Kliniği sil',
        clinic_deleted: 'Klinik başarıyla silindi',
        deleted_clinic: 'Silinmiş klinik',
        clinicDeleteConfirmation: 'Bu odayı silmek istediğinize emin misiniz?',
        clinicDeleteWarningTitle: 'Bu klinik tüm listelerden gizlenecek. Buna bağlı mevcut randevular, klinik adı yerine "Silinmiş klinik" gösterecek.',
        clinicDeleteWarningHint: 'Geçmişin okunabilir kalması için kliniği silmek yerine "(Arşiv) Klinik Adı" şeklinde yeniden adlandırmayı düşünün.',
        clinicsInfoMessage: 'Buradan fiziksel klinik lokasyonlarınızı ve adreslerini yönetebilirsiniz. Bu lokasyonlar takvim randevusu oluştururken seçilebilir ve hasta rezervasyon bildirimlerinde görüntülenecektir.',
        clinicTimezone: 'Saat dilimi',
        clinicTimezoneHint: 'Hatırlatmalar ve sessiz saatler için kullanılır.',
        addStatus: 'Durum ekle',
        enterTreatmentName: 'Tedavi adını girin',
        enterTreatmentPrice: 'Tedavi fiyatını girin',
        editTreatment: 'Faaliyeti düzenle',
        tratmentDeleteConfirmation: 'Bu faaliyeti silmek istediğinize emin misiniz?',
        deleteTreatment: 'Faaliyeti sil',
        addProcedure: 'Prosedür ekle',
        enterProcedureName: 'Prosedür adını girin',
        enterProcedurePrice: 'Prosedür fiyatını girin',
        editProcedure: 'Prosedürü düzenle',
        editProcedureName: 'Prosedür adını düzenle',
        editProcedurePrice: 'Prosedür fiyatını düzenle',
        deleteProcedure: 'Prosedürü sil',
        procedureDeleteConfirmation: 'Bu prosedürü silmek istediğinize emin misiniz?',
        enterIllnessName: 'Hastalık adını girin',
        editIllness: 'Hastalığı düzenle',
        addIllness: 'Hastalık ekle',
        illnessDeleteConfirmation: 'Bu hastalığı silmek istediğinize emin misiniz?',
        addAllergy: 'Alerji ekle',
        enterAllergyName: 'Alerji adını girin',
        editAllergy: 'Alerjiyi düzenle',
        deleteAllergy: 'Alerjiyi sil',
        deleteCalendarEvent: 'Etkinliği sil',
        allergyDeleteConfirmation: 'Bu alerjiyi silmek istediğinize emin misiniz?',
        eventDeleteConfirmation: 'Bu etkinliği silmek istediğinize emin misiniz?',
        deleteMedication: 'İlacı sil',
        medicationDeleteConfirmation: 'Bu ilacı silmek istediğinize emin misiniz?',
        addMedication: 'İlaç ekle',
        enterMedicationName: 'İlaç adını girin',
        editMedication: 'İlacı düzenle',
        medication: 'İlaç',
        illness: 'Hastalık',
        allergy: 'Alerji',
        deleteIllness: 'Hastalığı sil',
        invalid_url: 'Sayfa bulunamadı',
        link_expired: 'Bağlantının süresi doldu.',
        successfully_registered: 'Başarıyla kayıt oldunuz',
        avatar_upload_error: 'Profil fotoğrafı yüklenirken bir sorun oluştu',
        selectPatient: 'Hasta seç',
        selectPlaceholder: 'Seç',
        selectPatientValidation: 'Lütfen bir hasta seçin.',
        from: 'Başlangıç',
        to: 'Bitiş',
        nzis_data_fail: 'NHIS\'e gönderilirken bir sorun oluştu.',
        nzis_data_success: 'Veriler NHIS\'e başarıyla gönderildi.',
        generalCalendar: 'Genel takvim',
        appointmentHour: 'Randevu ekle',
        welcome: 'Merhaba',
        nextHours: 'Yaklaşan randevular',
        statistics: 'İstatistikler',
        sunday: 'Pazar',
        monday: 'Pazartesi',
        tuesday: 'Salı',
        wednesday: 'Çarşamba',
        thursday: 'Perşembe',
        friday: 'Cuma',
        saturday: 'Cumartesi',
        saveNew: 'Yeni kayıt yap',
        toCalendar: 'Takvime git',
        dr: 'Dr.',
        proforma_create: 'Proforma oluştur',
        invoice_create: 'Fatura oluştur',
        paidFinance: 'Ödendi',
        unpaidFinance: 'Ödenmedi',
        totalPrice: 'Toplam',
        laboratory: 'Laboratuvar',
        due: 'Vade',
        edit_patient: 'Hastayı düzenle',
        delete_appointment: 'Randevuyu iptal et',
        qr_description: 'Hastadan QR kodu taramasını ve formu doldurmasını isteyin. Kişisel cihaz kullanılabilir',
        new_patient: 'Yeni hasta oluşturuldu',
        patient_updated: 'Hasta başarıyla güncellendi',
        medical_staff_created: 'Tıbbi personel başarıyla oluşturuldu',
        medical_staff_updated: 'Tıbbi personel başarıyla güncellendi',
        deactivate: 'Devre dışı bırak',
        medical_staff_deactivated: 'Personel başarıyla devre dışı bırakıldı',
        medical_staff_already_deactivated: 'Personel zaten devre dışı bırakılmış',
        remove_access: 'Erişimi kaldır',
        access_removed: 'Erişim başarıyla kaldırıldı',
        activate: 'Etkinleştir',
        medical_staff_activated: 'Personel başarıyla etkinleştirildi',
        medical_staff_already_active: 'Personel zaten aktif',
        deactivate_medical_staff: 'Personeli devre dışı bırak',
        show_inactive: 'Aktif olmayanları göster',
        portal_access: 'Portal erişimi',
        has_portal_access: 'Portal erişimi var',
        no_portal_access: 'Portal erişimi yok',
        grant_access: 'Erişim ver',
        revoke_access: 'Erişimi iptal et',
        access_granted: 'Portal erişimi başarıyla verildi',
        invite_sent_access: 'Davet gönderildi — kullanıcı kaydolduktan sonra erişim aktif olacak',
        access_revoked: 'Portal erişimi başarıyla iptal edildi',
        grant_access_email_label: 'Portal erişimi için e-posta adresi',
        staff_already_has_access: 'Personelin zaten portal erişimi var',
        staff_already_has_pending_invite: 'Bu e-posta adresi organizasyonunuzda zaten bekleyen bir davete sahip',
        staff_linked_different_user: 'Bu personel farklı bir e-posta adresine bağlı — önce erişimi iptal edin',
        staff_inactive_cannot_grant: 'Aktif olmayan personele erişim verilemez',
        staff_no_access_to_revoke: 'Personelin portal erişimi yok',
        invite_pending: 'Davet beklemede',
        resend_invite: 'Daveti yeniden gönder',
        invite_resent: 'Davet başarıyla yeniden gönderildi',
        portal_access_description: 'Portal erişimi, bu personelin Dentobook\'a giriş yaparak programını, hastalarını ve randevularını yönetmesine olanak tanır.',
        portal_access_info_none: "'Erişim ver' seçeneğini kullanarak bu personele bir davet e-postası gönderin.",
        portal_access_info_pending: 'Bir davet e-postası gönderildi. Personel, daveti kabul edip kaydı tamamladıktan sonra erişim kazanacak.',
        portal_access_info_active: 'Bu personelin tam portal erişimi vardır. Erişimi iptal etmek, oturumunu hemen sonlandıracaktır.',
        needs_portal_access: 'Portal erişimi gerekli',
        portal_access_invite_hint: 'Etkinleştirilirse, bu personele giriş yapabilmesi için e-posta daveti gönderilir.',
        email_required_for_portal_access: 'Portal erişimi için e-posta gereklidir.',
        archived_treatment: 'Arşivlenmiş tedavi',
        archived_condition: 'Arşivlenmiş durum',
        archived_doctor: 'Arşivlenmiş doktor (artık sistemde yok)',
        inactive: 'pasif',
        email_invalid_format: 'Lütfen geçerli bir e-posta adresi girin.',
        email_not_verified_title: 'E-posta adresinizi doğrulayın',
        email_not_verified_subtitle: 'E-posta adresinize bir doğrulama bağlantısı gönderdik. Devam etmek için gelen kutunuzu kontrol edin ve bağlantıya tıklayın.',
        email_not_verified_resend: 'Doğrulama e-postasını yeniden gönder',
        email_not_verified_resend_success: 'Doğrulama e-postası gönderildi. Gelen kutunuzu kontrol edin.',
        email_not_verified_logout: 'Çıkış yap',
        verify_email_page_title: 'E-posta Doğrulama',
        verify_email_success_title: 'E-posta doğrulandı!',
        verify_email_success_subtitle: 'E-posta adresiniz başarıyla doğrulandı. Artık hesabınızı kullanabilirsiniz.',
        verify_email_success_login: 'Giriş sayfasına git',
        verify_email_invalid_token: 'Bu doğrulama bağlantısı geçersiz veya süresi dolmuş. Lütfen yeni bir tane isteyin.',
        verify_email_already_used: 'Bu doğrulama bağlantısı zaten kullanılmış.',
        verify_email_check_inbox_subtitle: '{email} adresine bir doğrulama bağlantısı gönderdik. Gelen kutunuzu kontrol edin.',
        verify_email_resend_countdown: '{seconds}s sonra yeniden gönder',
        verify_email_wrong_email: 'Yanlış e-posta adresi mi?',
        verify_email_spam_hint: 'Görmüyorsanız spam klasörünüzü kontrol edin.',
        terms_not_accepted_title: 'Kullanım Koşulları',
        terms_not_accepted_subtitle: "Dentobook'u kullanmaya devam etmek için Kullanım Koşulları'nı kabul etmeniz gerekmektedir.",
        accept_invite_title: 'Daveti Kabul Et',
        accept_invite_description: 'Katılmaya davet edildiniz',
        invite_expired: 'Bu davet bağlantısının süresi doldu',
        invite_revoked: 'Bu davet iptal edildi',
        invite_already_accepted: 'Bu davet zaten kabul edildi',
        invite_invalid: 'Geçersiz veya tanınmayan davet bağlantısı',
        accepting_invite: 'Davet kabul ediliyor...',
        invite_accepted: 'Davet kabul edildi! Giriş sayfasına yönlendiriliyor...',
        invite_switch_failed: 'Davet kabul edildi, ancak geçiş başarısız — devam etmek için panele gidin',
        create_account_and_accept: 'Hesap oluştur ve kabul et',
        organization_updated: 'Organizasyon başarıyla güncellendi',
        here: 'burada',
        show_all: 'Tümünü göster',
        notifications: 'Bildirimler',
        mark_all_read: 'Tümünü okundu olarak işaretle',
        collapse: 'Daralt',
        profile: 'Profil',
        my_profile: 'Profilim',
        my_details: 'Bilgilerim',
        memberships: 'Üyelikler',
        create_my_organization: 'Organizasyonumu oluştur',
        profile_saved: 'Profil kaydedildi.',
        active_org: 'Aktif',
        create_another_organization: 'Başka bir organizasyon oluştur',
        create_org_modal_hint: 'Organizasyon Yöneticisi olacaksınız ve üst menüden organizasyonlar arasında geçiş yapabileceksiniz.',
        complete_profile_first: 'Organizasyon oluşturmadan önce lütfen adınızı ve soyadınızı tamamlayın.',
        invalid_image_format: 'Geçersiz dosya formatı. Geçerli formatlar: pdf, doc, docx, xls, xlsx, txt, csv, jpg, jpeg, png, gif, webp, bmp.',
        invalid_photo_format: 'Geçersiz dosya formatı. Geçerli formatlar: jpg, jpeg, png.',
        invalid_image_size: 'Dosya boyutu 10 MB\'ı geçmemelidir',
        invalid_photo_image_size: 'Fotoğraf boyutu 1 MB\'ı geçmemelidir.',
        no_notifications: 'Yeni bildirim yok',
        notif_appointment_confirmed: 'Yeni randevu: {patient_name} tarihinde {date}',
        notif_appointment_rescheduled: 'Randevu değişti: {patient_name} — {old_date} tarihinden {date} tarihine',
        notif_appointment_cancelled: 'Randevu iptal: {patient_name} tarihinde {date}',
        notif_patient_deleted: 'Hasta {patient_name} silindi',
        notif_staff_deactivated: '{staff_name} adlı personel deaktive edildi',
        notif_staff_activated: '{staff_name} adlı personel aktive edildi',
        freed_slot_flash: 'Zaman dilimi serbest kaldı',
        endTime_error: 'Bitiş saati, başlangıç saatinden sonra olmalıdır.',
        event_select_alert: 'Geçmiş bir saat seçemezsiniz.',
        event_move_alert: 'Etkinlik geçmişe taşınamaz.',
        max_length_250: 'Maksimum uzunluk 250 karakterdir.',
        max_length_150: 'Maksimum uzunluk 250 karakterdir.',
        invalid_address: 'Geçersiz adres.',
        invalid_town: 'Geçersiz şehir.',
        invalid_country: 'Geçersiz ülke.',
        close: 'Kapat',
        no_selected_appointment: 'Lütfen bir randevu seçin.',
        iban: 'IBAN',
        invoiceNumber: 'Başlangıç fatura numarası',
        proformaInvoiceNumber: 'Başlangıç proforma fatura numarası',
        duplicated_appointment: 'Aynı isme sahip bir randevu zaten var.',
        nzis: 'NHIS',
        from_date: 'Başlangıç tarihi',
        unsent: 'Gönderilmedi',
        sent: 'Gönderildi',
        send_to_nzis: 'NHIS\'e gönder',
        all_data: 'Gönderilmemiş veriye sahip hastalar',
        medical_prescriptions: 'Tıbbi reçeteler',
        excuse_notes: 'Mazeret belgeleri',
        operations: 'Operasyonlar',
        operation: 'Operasyon',
        healthArea: 'Sağlık bölgesi',
        healthRegion: 'Sağlık bölgesi',
        ekkatte: 'EKATTE',
        specialization1: 'Genel diş hekimi',
        specialization2: 'Pedodonti',
        specialization3: 'Ağız cerrahisi',
        specialization4: 'Maksillofasiyal Cerrahi / Diş, Ağız ve Maksillofasiyal Cerrahi',
        rhif: 'RHIF',
        specialisation_code: 'Uzmanlık kodu',
        all: 'Tümü',
        ambulatory_sheet: 'Ayakta Tedavi Formu',
        ambulatory_sheet_fail: 'Ayakta tedavi formu oluşturulurken bir sorun oluştu.',
        nzis_unavailable: 'NHIS geçici olarak kullanılamıyor. Lütfen bağlantınızı kontrol edin veya daha sonra tekrar deneyin.',
        diagnose_label: 'Durum',
        tooth: 'Diş',
        operation_code: 'Operasyon kodu',
        unsent_single: 'Gönderilmedi',
        sent_single: 'Gönderildi',
        select_at_least_one_item: 'Lütfen en az bir satır seçin.',
        ambulatory_list: 'Ayakta Tedavi Listesi - Form (Bulgaristan)',
        organization_documents: 'Kuruluş Belgeleri',
        platform_forms: 'Platform Formları',
        informed_consent: 'Bilgilendirilmiş onam',
        nhis_consent: 'NHIS - Hastanın EHR verilerine erişim izni',
        documents: 'Belgeler',
        profession: 'Meslek',
        national_id: 'Ulusal Kimlik',
        no_diagnose: 'Durum yok',
        no_treatment: 'Tedavi yok',
        cancellation_reason_placeholder: 'İptal nedenini buraya girin',
        cancellation_reason: 'İptal nedeni',
        cookies_policy: 'Çerez politikası',
        usage_rules: 'Kullanım kuralları',
        terms_and_conditions: 'Şartlar ve koşullar',
        gdpr: 'KVKK',
        create_note: 'Not oluştur',
        start_date: 'Başlangıç tarihi',
        end_date: 'Bitiş tarihi',
        serve_to: 'Verileceği kişi',
        english_letters_only_field: 'Bu alan yalnızca Latin harfleri içermelidir',
        signature_client_not_found: 'İmza uygulaması bulunamadı!',
        signature_client_start: 'Lütfen Dentobook eSign uygulamasını çalıştırın veya şuradan indirin ve yükleyin:',
        here_msg: 'buradan',
        addCredentials: 'Google bilgilerini ayarla',
        googleWarning: 'Google Müşteri Kimliğiniz yapılandırılmamış. Kimlik doğrulama için lütfen ayarlayın.',
        reAuth: 'Oturumunuz sona erdi. Lütfen Google ile tekrar kimlik doğrulaması yapın.',
        googleLogin: 'Google ile giriş yapın.',
        clientId: 'Müşteri Kimliği',
        clientSecret: 'Müşteri Gizli Anahtarı',
        editCredentials: 'Google bilgilerini düzenle',
        identifierAlert: 'Kişisel kimlik numarası doğum tarihiyle uyuşmuyor.',
        patientEmailAlert: 'Hastanın e-postası mevcut değil. Google Takvim etkinliği oluşturulamadı. Normal takvim etkinliği oluşturulacak.',
        done_operations: 'Tamamlanan operasyonlar',
        done_operations_info: 'Sadece henüz faturalandırılmamış ve toplam tutarı sıfırdan büyük olan tamamlanmış işlemler burada gösterilir.',
        invoices: 'Faturalar',
        proforma_invoices: 'Proforma faturalar',
        maturity: 'Vade',
        price_value: 'Değer',
        paid_price_value: 'Ödenen',
        payment_type: 'Ödeme yöntemi',
        canceled_finance: 'İptal edildi',
        paid_invoice: 'Ödendi',
        unpaid_invoice: 'Ödenmedi',
        canceled_invoice: 'İptal edildi',
        cash_payment_type: 'Nakit',
        card_payment_type: 'Kart ile',
        paid_obligations: 'Ödenen',
        create_invoice: 'Fatura oluştur',
        payment_deadline: 'Ödeme son tarihi',
        payment_method: 'Ödeme yöntemi',
        vat_label: 'KDV',
        bank_transfer: 'Banka transferi',
        create_proforma_invoice: 'Proforma fatura oluştur',
        update_proforma_invoice: 'Proforma',
        tooth_status_delete_confirm: 'Bu diş durumunu silmek istediğinize emin misiniz?',
        tooth_treatment_delete_confirm: 'Bu tedaviyi silmek istediğinize emin misiniz?',
        leave_page_title: 'Sayfadan çıkılıyor',
        leave_page: 'Sayfadan çık',
        leave_page_message: 'Bu sayfadan çıkmak kaydedilmemiş verileri silecektir. Lütfen çıkmadan önce değişikliklerinizi kaydedin.',
        field_too_long_message: 'Değer çok uzun.',
        proforma_void_message: 'Bu proforma faturayı iptal etmek istediğinize emin misiniz?',
        void_message: 'Bu faturayı iptal etmek istediğinize emin misiniz?',
        void_button: 'İptal Et',
        invoice_generate_confirm: 'Bu proforma faturadan fatura oluşturmak istediğinize emin misiniz?',
        generate_btn: 'Oluştur',
        generate_invoice_tooltip: 'Fatura oluştur',
        edit_tooltip: 'Düzenle',
        print_tooltip: 'Yazdır',
        nzis_mandatory_fields: 'Lütfen hasta profilindeki şu alanları tamamlayın: [FIELDS]. Tamamladıktan sonra devam edebilirsiniz.',
        invoice_numbering_title: 'Fatura numaralandırmasını değiştir',
        invoice_numbering_text: 'Dentobook her fatura için benzersiz 10 haneli artan bir numara üretir. İlk fatura 0000000001 ile başlar ve her yenisi bir artar. Bu ilk faturanız değilse, başlayacağı numarayı değiştirin.',
        proforma_numbering_title: 'Proforma fatura numaralandırmasını değiştir',
        proforma_numbering_text: 'Dentobook her proforma fatura için benzersiz 10 haneli artan bir numara üretir. İlk proforma fatura 0000000001 ile başlar. Bu ilk değilse, başlayacağı numarayı değiştirin.',
        invoice_config_setup_title: 'Fatura Yapılandırma Kurulumu',
        invoice_config_setup_description: 'Fatura oluşturabilmeniz için fatura numaralarının nasıl oluşturulacağını yapılandırmanız gerekir. Bu tek seferlik bir kurulmumdur.',
        invoice_configuration: 'Fatura Yapılandırması',
        proforma_invoice_configuration: 'Proforma Fatura Yapılandırması',
        proforma_config_setup_title: 'Proforma Fatura Yapılandırma Kurulumu',
        proforma_config_setup_description: 'Proforma fatura oluşturabilmeniz için proforma fatura numaralarının nasıl oluşturulacağını yapılandırmanız gerekir. Bu tek seferlik bir kurulumdur.',
        invoice_config_prefix: 'Önek (isteğe bağlı)',
        invoice_config_prefix_help: 'Numaradan önce görünecek metin (ör. INV, FACT)',
        invoice_config_prefix_placeholder: 'INV',
        invoice_config_starting_number: 'Başlangıç Numarası',
        invoice_config_starting_number_min: 'Başlangıç numarası en az 1 olmalıdır',
        invoice_config_digits_count: 'Rakam Sayısı',
        invoice_config_digits_count_help: 'Sayısal kısım için toplam basamak sayısı (sıfırlarla doldurulur)',
        invoice_config_digits_count_range: 'Rakam sayısı 6 ile 15 arasında olmalıdır',
        invoice_config_example: 'Örnek Fatura Numarası',
        invoice_config_example_text: 'Ayarlarınıza göre ilk fatura numarası şöyle olacak:',
        error_creating_invoice_config: 'Fatura yapılandırması oluşturulamadı. Lütfen tekrar deneyin.',
        reports_label: 'Raporlar',
        patients_all_label: 'Hasta (Tümü)',
        doctors_all_label: 'Doktor (Tümü)',
        doctor_label: 'Doktor',
        day_label: 'Gün',
        week_label: 'Hafta',
        month_label: 'Ay',
        period_label: 'Dönem',
        debt_label: 'Borç',
        download_report: 'Raporu indir',
        yesterday: 'Dün',
        this_week: 'Bu hafta',
        last_week: 'Geçen hafta',
        this_month: 'Bu ay',
        last_month: 'Geçen ay',
        period: 'Dönem',
        continue: 'Devam',
        continue_free_version: 'Ücretsiz planla devam et',
        choose_plan: 'Plan seç',
        compare_plans: 'Özellikleri gör ve karşılaştır',
        dentobook_start_one: 'Dentobook Start planı seçerek şunlara erişebilirsiniz:',
        dentobook_start_two: 'Pro planın tüm özellikleri 6 ay boyunca',
        dentobook_start_three: 'Bu süreden sonra bazı özellikler kilitlenecek, Start planının ana araçları kalacak.',
        dentobook_pro: 'Diş kliniğinizin verimli yönetimi için Dentobook\'un tüm özelliklerine tam erişim',
        paymentMethod: 'Ödeme yöntemi',
        choose_plan_msg: 'Lütfen bir plan seçin.',
        logout_msg: 'Bu işlem hesabınızdan çıkış yapılmasını gerektirir. Devam etmek istediğinize emin misiniz?',
        organization_conflict: 'Aynı isme sahip bir organizasyon zaten mevcut.',
        clientIdRequired: 'Müşteri Kimliği gereklidir.',
        clientIdMinLength: 'Müşteri Kimliği en az 10 karakter olmalıdır.',
        clientSecretRequired: 'Müşteri Gizli Anahtarı gereklidir.',
        clientSecretMinLength: 'Gizli Anahtar en az 16 karakter olmalıdır.',
        missingFirstName: 'İsim eksik.',
        missingLastName: 'Soyisim eksik.',
        missingBothNames: 'İsim ve soyisim eksik.',
        subscription: 'Abonelik',
        active_subscription: 'Aktif abonelik',
        subscription_description: 'Dentobook Pro planının tüm özelliklerine tam erişim. Sadece aylık 4,99 €.',
        subscription_description_free_trial: '30 günlük ücretsiz deneme ile Dentobook\'un tüm özelliklerini kullanın. Kredi kartı gerekmez*',
        subscription_description_free_trial_profile: '30 günlük ücretsiz deneme ile Dentobook\'un tüm özelliklerine erişim. Süre sonunda abonelik aylık 4,99 € olarak devam eder.',
        subscription_description_start: 'Ücretsiz plan',
        next_payment: 'Sonraki ödeme',
        cancel_subscription: 'Aboneliği iptal et',
        subscribe: 'Abone ol',
        renew_subscription: 'Aboneliği yenile',
        cancel_subscription_text: 'Aboneliğinizi iptal etmek istediğinize emin misiniz?',
        subscription_active_warning: 'Dentobook Pro planının 30 günlük ücretsiz deneme süresi {days} {unit} içinde sona eriyor. Lütfen {a} ile yenileyin.',
        subscription_expired_warning: 'Dentobook Pro planının 30 günlük ücretsiz deneme süresi sona erdi. Lütfen {a} ile yenileyin.',
        free_trial_title: '30 Günlük Ücretsiz Deneme',
        dentobook_pro_title: 'Dentobook Pro - 4,99 €',
        payment_error: 'Ödeme sırasında bir hata oluştu',
        missing_required_fields: 'Lütfen gerekli alanları doldurun',
        payment_method_creation_error: 'Ödeme yöntemi oluşturulurken bir hata oluştu',
        registration_successful: 'Kayıt başarıyla tamamlandı',
        payment_token_error: 'Ödeme sırasında bir hata oluştu. Lütfen ödeme yönteminizi kontrol edin',
        subscription_payment_failed: 'Ödeme bilgileriniz başarısız oldu. Devam etmek için lütfen ödeme yöntemini güncelleyin.',
        free_trial_plan_name: '30 günlük ücretsiz deneme',
        card_declined: 'Kartınız reddedildi.',
        expired_card: 'Kartınızın süresi dolmuş.',
        incorrect_cvc: 'Geçersiz CVC.',
        processing_error: 'Kartınız işlenemedi.',
        incorrect_number: 'Geçersiz numara.',
        expires_at: 'Bitiş tarihi',
        credit_card_title: 'Kredi/Banka Kartı',
        card_number_title: 'Kart numarası',
        card_expiration_title: 'AA/YY',
        postal_code_title: 'Posta Kodu',
        subscription_expiration: 'Bitiş tarihi',
        create_event_not_allowed: 'Takvim etkinliği oluşturmak ve Google entegrasyonunu kullanmak mevcut planınızda mümkün değildir.',
        doctors_statistics_label: 'Doktorlar',
        assistants_statistics_label: 'Asistanlar',
        receptionists_statistics_label: 'Resepsiyonistler',
        download: 'İndir',
        report_problem: 'Sorun bildir',
        send_feedback: 'Özellik öner',
        currency_label: 'Para birimi',
        billing: 'Ödemeler',
        billing_details: 'Aylık fatura bilgileri',
        company_name: 'Şirket adı',
        active_label: 'Aktif',
        trial_label: 'Deneme',
        expired_label: 'Süresi dolmuş',
        last_login_label: 'Son giriş tarihi',
        login_count_label: 'Giriş sayısı',
        delete_organization: 'Organizasyonu sil',
        delete_action: 'Sil',
        delete_organization_confirmation_text: 'Organizasyon ve tüm ilişkili veriler (hastalar, doktorlar, randevular vb.) silinecek. Devam etmek istediğinizden emin misiniz?',
        invalid_vat_bg: 'Geçersiz KDV numarası. "BG" ile başlayıp 9 veya 10 haneli olmalı ya da tam olarak 9 haneli olmalıdır.',
        patients_count: 'Hasta Sayısı',
        calendar_appointments_count: 'Takvim Randevu Sayısı',
        hosted_invoice_url: 'Barındırılan Fatura URL\'si',
        invoice_pdf: 'Fatura PDF',
        amount_paid: 'Ödenen Tutar',
        view_hosted_invoice: 'Barındırılan faturayı görüntüle',
        download_invoice_pdf: 'Fatura PDF indir',
        choose_file_dropbox: 'Belgeyi sürükleyip bırakın',
        delete_document: 'Belge başarıyla silindi',
        document_delete_confirm: 'Bu belgeyi silmek istediğinize emin misiniz?',
        remember_me: 'Beni hatırla',
        remember_me_tooltip: '2 haftaya kadar oturum açık kalsın',
        password: 'Şifre',
        logging_in: 'Giriş yapılıyor...',
        login: 'Giriş yap',
        forgot_password: 'Şifrenizi mi unuttunuz?',
        no_account: 'Hesabınız yok mu?',
        register_here: 'Buradan kayıt olun',

        // ForgotPassword page
        forgot_password_title: 'Şifrenizi mi unuttunuz?',
        forgot_password_description: 'E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.',
        email_required_error: 'Lütfen e-posta adresinizi girin.',
        email_placeholder: 'E-posta adresinizi girin',
        sending: 'Gönderiliyor...',
        send_reset_link: 'Sıfırlama bağlantısı gönder',
        back_to_login: 'Giriş sayfasına dön',
        password_reset_link_sent: 'Bu e-posta ile bir hesap varsa, şifre sıfırlama bağlantısı gönderildi.',

        // ResetPassword page
        reset_password_title: 'Şifreyi sıfırla',
        reset_password_description: 'Hesabınız için yeni bir şifre oluşturun.',
        new_password: 'Yeni şifre',
        confirm_new_password: 'Yeni şifreyi onayla',
        new_password_required: 'Lütfen yeni şifrenizi girin.',
        password_min_length_error: 'Şifre en az 9 karakter olmalıdır.',
        confirm_password_required: 'Lütfen şifrenizi onaylayın.',
        passwords_do_not_match: 'Şifreler eşleşmiyor.',
        new_password_placeholder: 'Yeni şifrenizi girin',
        confirm_password_placeholder: 'Yeni şifrenizi onaylayın',
        resetting: 'Sıfırlanıyor...',
        reset_password_button: 'Şifreyi sıfırla',
        password_reset_success: 'Şifreniz başarıyla sıfırlandı.',
        invalid_reset_token: 'Geçersiz veya süresi dolmuş sıfırlama anahtarı.',
        reset_link_expired: 'Sıfırlama bağlantısının süresi doldu. Lütfen yeni bir tane isteyin.',
        reset_link_expired_title: 'Sıfırlama bağlantısının süresi doldu',
        password_must_contain_number: 'Şifre en az bir rakam içermelidir.',
        password_must_contain_special: 'Şifre en az bir özel karakter içermelidir.',
        password_must_contain_uppercase: 'Şifre en az bir büyük harf içermelidir.',
        password_must_contain_lowercase: 'Şifre en az bir küçük harf içermelidir.',
        password_requirements_hint: 'Şifre en az 9 karakter uzunluğunda olmalı ve rakamlar, özel karakterler, büyük ve küçük harfler içermelidir.',
        redirecting_to_login: 'Giriş sayfasına yönlendiriliyor...',

        // Registration page
        register_organization_title: 'Organizasyonunuzu kaydedin',
        organization_registration_title: 'Organizasyon kaydı',
        account_registration_title: 'Hesap kaydı',
        organization_name: 'Organizasyon adı',
        vat_number: 'KDV numarası',
        business_address: 'İş adresi',
        organization_name_required: 'Lütfen organizasyon adını girin.',
        clinic_name_required: 'Lütfen klinik adını girin.',
        vat_number_required: 'Lütfen KDV numarasını girin.',
        password_required_error: 'Lütfen şifre girin.',
        first_name_required: 'Lütfen adınızı girin.',
        last_name_required: 'Lütfen soyadınızı girin.',
        country_required: 'Lütfen ülke seçin.',
        phone_required: 'Lütfen telefon numarası girin.',
        phone_format_hint: 'Uluslararası format kullanın, örn. +905551234567',
        phone_international_required: 'Telefon "+" ile başlamalı ve ülke kodu içermelidir (örn. +905551234567).',
        next: 'İleri',
        previous: 'Geri',
        submit: 'Gönder',
        already_have_account: 'Zaten hesabınız var mı?',
        login_here: 'Buradan giriş yapın',
        registration_successful: 'Kayıt başarılı!',
        check_email_verification: 'Hesabınızı doğrulamak için lütfen e-postanızı kontrol edin.',
        registration_failed: 'Kayıt başarısız oldu. Lütfen tekrar deneyin.',
        email_already_taken: 'E-posta zaten kullanılıyor.',
        email_already_taken_register: 'Bu e-posta zaten kayıtlı. Size aitse giriş yapın ve {link} üzerinden organizasyonunuzu oluşturun.',
        organization_already_exists: 'Aynı isimde bir organizasyon zaten mevcut.',
        registration_success_message: 'Başarıyla kaydoldunuz! Giriş sayfasına yönlendirileceksiniz.',
        successful_registration_title: 'Başarılı kayıt',
        close: 'Kapat',
        phone_number: 'Telefon numarası',
        invalid_phone_number_text: 'Geçersiz telefon numarası.',
        first_name_letters_only: 'Ad yalnızca harf içermelidir',
        last_name_letters_only: 'Soyad yalnızca harf içermelidir',
        organization_name_max_length: 'Organizasyon adı 250 karakteri geçmemelidir.',
        clinic_name_max_length: 'Klinik adı 250 karakteri geçmemelidir.',
        create_account: 'Hesap oluştur',
        confirm_password: 'Şifreyi onayla',

        // RegisterUser page
        register_new_user_title: 'Yeni kullanıcı kaydet',
        user_details: 'Kullanıcı bilgileri',
        create_user_account: 'Kullanıcı hesabı oluştur',
        medical_staff_label: 'Tıbbi personel',
        user_role: 'Kullanıcı rolü',
        medical_staff_required: 'Lütfen tıbbi personel seçin.',
        user_role_required: 'Lütfen kullanıcı rolü seçin.',
        select_medical_staff: 'Tıbbi personel seçin',
        select_role: 'Rol seçin',
        registering: 'Kaydediliyor...',
        register_user_button: 'Kullanıcıyı kaydet',
        user_registered_success: 'Kullanıcı başarıyla kaydedildi!',
        user_registration_failed: 'Kullanıcı kaydedilemedi.',
        organization: 'Organizasyon',
        organization_required: 'Lütfen organizasyon seçin.',
        health_insurance_filter_info: 'Listede yalnızca {country} ülkesinden sağlık sigortası şirketleri gösterilmektedir.',
        switch_organization: 'Organizasyon değiştir',
        help_nav: 'Yardım',
        help_legal: 'İletişim ve Yasal',
        help_title: 'Yardım ve Bilgi Tabanı',
        help_search_placeholder: 'Makale ara...',
        all_categories: 'Tüm kategoriler',
        help_not_found: 'Makale bulunamadı',
        help_not_found_desc: 'Bu makale mevcut değil veya bağlantı yanlış.',
        back_to_help: 'Yardıma Geri Dön',
        help_category_organizations: 'Organizasyonlar',
        help_category_access: 'Erişim ve Davetler',
        help_article_multi_org_title: 'Çoklu Organizasyon Desteği',
        help_article_multi_org_desc: "Dentobook'un tek bir hesap altında birden fazla kliniği nasıl yönettiğini ve geçiş yaptığınızda ne değiştiğini anlayın.",
        help_article_multi_org_h1: 'Çoklu organizasyon desteği nedir?',
        help_article_multi_org_p1: "Dentobook, tek bir kullanıcı hesabının birden fazla organizasyona üye olmasına olanak tanır. Her organizasyon, kendi personeli, hastaları, randevuları ve verileriyle bağımsız bir klinik veya uygulamadır.",
        help_article_multi_org_p2: "Şu anda aktif olan organizasyon 'mevcut organizasyon' olarak adlandırılır ve üst gezinme çubuğunda gösterilir. Dentobook'ta görüntülediğiniz veya oluşturduğunuz her şey — hasta kayıtları, takvim girişleri, personel, raporlar — yalnızca mevcut organizasyona aittir.",
        help_article_multi_org_h2: 'Organizasyon değiştirdiğinizde ne değişir?',
        help_article_multi_org_p3: 'Farklı bir organizasyona geçtiğinizde Dentobook yeni bir oturum başlatır ve uygulamayı yeniden yükler. Görünümünüz — hastalar, takvim, personel ve raporlar — hemen seçilen organizasyonun verilerini yansıtır.',
        help_article_multi_org_p4: 'Kullanıcı rolünüz organizasyonlar arasında farklılık gösterebilir. Örneğin, birinde Klinik Yöneticisi, diğerinde ise Tıp Doktoru olabilirsiniz. Gördüğünüz menü öğeleri ve izinler, mevcut organizasyondaki rolünüze bağlıdır.',
        help_article_multi_org_h3: 'Organizasyon değiştiriciyi kim görür?',
        help_article_multi_org_p5: 'Organizasyon değiştirici, yalnızca hesabınız birden fazla organizasyonun aktif üyesi olduğunda üst gezinme çubuğunda görünür. Yalnızca bir organizasyona üyeyseniz değiştirici gösterilmez.',
        help_article_multi_org_h4: 'Başka bir klinikte çalışırken kendi organizasyonunuzu oluşturma',
        help_article_multi_org_p6: 'Zaten başka bir organizasyonun üyesiyseniz — örneğin bir meslektaşınızın muayenehanesinde diş hekimi olarak çalışıyorsanız — Dentobook\'ta kendi organizasyonunuzu oluşturabilir ve yönetebilirsiniz. Sağ üstteki kullanıcı menüsünden Profilim\'i açın ve "Organizasyonumu oluştur"a tıklayın. Diğer kliniğinizdeki mevcut üyeliğiniz hiçbir şekilde etkilenmez. Oluşturma sonrasında yeni organizasyonunuzun Organizasyon Yöneticisi olursunuz ve tüm organizasyonlarınız arasında istediğiniz zaman serbestçe geçiş yapabilirsiniz.',
        help_article_multi_org_p7: 'Henüz bir Dentobook hesabınız yoksa önce kaydınızı tamamlayın. Giriş yaptıktan sonra organizasyonunuzu oluşturmak için Profilim\'i açın. Sistemde zaten kayıtlı bir e-posta ile kayıt olmaya çalışırsanız — bir klinik yöneticisi sizi daha önce davet etmiş olabilir — Dentobook, doğrudan Profilim sayfasına bir bağlantı gösterir ve oradan devam edebilirsiniz.',
        help_article_switching_title: 'Organizasyonlar Arasında Geçiş',
        help_article_switching_desc: 'Aktif organizasyonunuzu değiştirmek için organizasyon değiştiriciyi nasıl kullanacağınızı öğrenin.',
        help_article_switching_h1: 'Organizasyonlar nasıl değiştirilir',
        help_article_switching_p1: 'Üst gezinme çubuğundaki organizasyon adınıza veya avatarınıza tıklayın. Aktif üyesi olduğunuz tüm organizasyonları listeleyen ve mevcut olanın yanında onay işareti bulunan bir açılır menü görünür.',
        help_article_switching_p2: 'Listeden herhangi bir organizasyona tıklayarak geçiş yapın. Dentobook yeni bir oturum tokeni oluştururken kısa bir yükleme ekranı görünür, ardından sayfa seçilen organizasyonun bağlamında yeniden yüklenir.',
        help_article_switching_h2: 'Değiştirici görünmediğinde',
        help_article_switching_p3: 'Değiştirici yalnızca hesabınız birden fazla organizasyonun aktif üyesi olduğunda görünür. Değiştirici eksikse, yalnızca bir organizasyona üye olabilirsiniz veya diğer organizasyonlardaki üyelikleriniz bir yönetici tarafından kaldırılmış ya da askıya alınmış olabilir.',
        help_article_switching_h3: 'Geçişten sonra',
        help_article_switching_p4: 'Geçişten sonra tüm veriler sunucudan yeniden yüklenir. Önceki organizasyondan hiçbir bilgi aktarılmaz. Bir sayfaya geri dönerseniz, yeni mevcut organizasyonun verilerini gösterir.',
        help_article_invitations_title: 'Davetler ve Portal Erişimi',
        help_article_invitations_desc: 'Personel üyeleri için portal erişimini nasıl vereceğinizi, yöneteceğinizi ve kabul edeceğinizi öğrenin.',
        help_article_invitations_h1: 'Portal erişimi verme',
        help_article_invitations_p1: "Klinik Yöneticisi, ilgili üyenin ayrıntılar sayfasından bir personel üyesine portal erişimi verebilir. E-posta adresini girin ve 'Erişim ver'e tıklayın. O adrese bir davet e-postası gönderilir.",
        help_article_invitations_p2: "Davet kabul edilene kadar personel üyesinin portal erişim durumu 'Davet beklemede' olarak gösterilir. Klinik Yöneticileri, bu durumdayken daveti yeniden gönderebilir veya iptal edebilir.",
        help_article_invitations_h2: 'Daveti kabul etme — mevcut kullanıcı',
        help_article_invitations_p3: "Davet edilen e-posta adresi mevcut bir Dentobook hesabına aitse, alıcı davet e-postasındaki bağlantıyı ziyaret eder ve 'Daveti Kabul Et'e tıklar. Mevcut hesap organizasyonla ilişkilendirilir ve kullanıcı giriş sayfasına yönlendirilir.",
        help_article_invitations_p4: 'Kullanıcı davet bağlantısını ziyaret ettiğinde zaten giriş yapmışsa Dentobook, onu otomatik olarak yeni organizasyona geçirir. Yeniden giriş yapmasına gerek kalmaz.',
        help_article_invitations_h3: 'Daveti kabul etme — yeni kullanıcı',
        help_article_invitations_p5: 'Davet edilen e-posta adresi mevcut bir Dentobook hesabına ait değilse, bir kayıt formu görüntülenir. Kullanıcı adını, soyadını ve güvenlik gereksinimlerini karşılayan bir şifreyi girer. Gönderdikten sonra hesabı oluşturulur, organizasyonla ilişkilendirilir ve giriş sayfasına yönlendirilir.',
        help_article_invitations_h4: 'Davetleri yeniden gönderme ve iptal etme',
        help_article_invitations_p6: "Bir daveti yeniden göndermek, yeni bir token oluşturur ve son kullanma tarihini 7 güne sıfırlar. Daveti iptal etmek, daveti geçersiz kılar ve personel üyesinin durumunu 'Portal erişimi yok' olarak sıfırlar. Personel üyesinin mevcut kullanıcı hesabı — zaten bağlantılıysa — silinmez.",
        help_article_invitations_h5: 'Yeni personel eklerken erişim verme',
        help_article_invitations_p7: '"Portal erişimi gerekli" düğmesi, personel oluşturma formunda görünür. Oluşturma anında davet göndermek için etkinleştirin. Düğme açıkken e-posta alanı zorunlu hale gelir. Davetsiz bir personel kaydı oluşturmak için düğmeyi kapalı bırakın — erişimi daha sonra personelin ayrıntılar sayfasından verebilirsiniz.',
        help_article_invitations_p8: 'Sistem yinelenen davet gönderimini engeller: organizasyonunuzda o e-posta için bekleyen bir davet zaten varsa form bir hata gösterir — önce mevcut daveti iptal edin, ardından yeni kaydı oluşturun. E-posta organizasyonunuzun zaten aktif bir üyesine aitse davet gerekmez.',
        help_article_troubleshooting_title: 'Erişim Sorunlarını Giderme',
        help_article_troubleshooting_desc: 'Organizasyon değiştirme ve portal erişim davetleriyle ilgili yaygın sorunlar ve çözümleri.',
        help_article_troubleshooting_h1: 'Organizasyon değiştirici görünmüyor',
        help_article_troubleshooting_p1: 'Değiştirici yalnızca hesabınız birden fazla organizasyonun aktif üyesi olduğunda görünür. Bir daveti kabul etmek mevcut oturumunuzu güncellemez — oturumunuzu yeni üyelikle yenilemek için çıkış yapıp tekrar giriş yapın.',
        help_article_troubleshooting_h2: 'Davet "süresi dolmuş" gösteriyor',
        help_article_troubleshooting_p2: 'Davet bağlantıları 7 gün sonra sona erer. Klinik Yöneticinizden daveti yeniden göndermesini isteyin. Yeniden gönderme, 7 gün daha geçerli yeni bir bağlantı oluşturur.',
        help_article_troubleshooting_h3: 'Davet "iptal edilmiş" gösteriyor',
        help_article_troubleshooting_p3: 'Davet bir yönetici tarafından iptal edildi. Yeni bir davet talep etmek için Klinik Yöneticinizle iletişime geçin.',
        help_article_troubleshooting_h4: 'Davet "zaten kabul edilmiş" gösteriyor',
        help_article_troubleshooting_p4: 'Her davet bağlantısı yalnızca bir kez kullanılabilir. Zaten kabul ettiyseniz ancak organizasyon değiştiricinde görünmüyorsa, oturumunuzu güncellenmiş üyelikle yenilemek için çıkış yapıp tekrar giriş yapın.',
        help_article_troubleshooting_h5: 'Organizasyon değiştirirken 403 hatası',
        help_article_troubleshooting_p5: '403 hatası, son girişinizden bu yana o organizasyondaki üyeliğinizin kaldırıldığı veya askıya alındığı anlamına gelir. Yardım için o organizasyonun Klinik Yöneticisiyle iletişime geçin.',
        help_article_troubleshooting_h6: 'Portal erişimiyle personel oluştururken hata',
        help_article_troubleshooting_p6: '"Portal erişimi gerekli" düğmesini etkinleştirdikten sonra form bir hata gösterirse, organizasyonunuzda o e-posta için bekleyen bir davet zaten var demektir. O e-postaya ait mevcut personel kaydını bulun, bekleyen daveti iptal edin ve ardından yeni kaydı kaydedin.',
        help_category_account: 'Hesabım',
        help_article_profile_title: 'Profilim',
        help_article_profile_desc: 'Kişisel bilgilerinizi yönetin, organizasyon üyeliklerinizi görüntüleyin ve kendi organizasyonunuzu oluşturun.',
        help_article_profile_h1: 'Bilgilerinizi görüntüleme ve düzenleme',
        help_article_profile_p1: "Profilim sayfasını sağ üstteki kullanıcı menüsünden açın. Sayfa adınızı, soyadınızı, e-posta adresinizi ve telefon numaranızı gösterir. E-posta salt okunurdur ve burada değiştirilemez. Adınızı veya telefon numaranızı güncellemek için Düzenle'ye tıklayın.",
        help_article_profile_h2: 'Organizasyon üyelikleriniz',
        help_article_profile_p2: 'Üyelikler bölümü, hesabınızın ait olduğu tüm organizasyonları listeler. Her giriş için organizasyon adını, rolünüzü ve üyelik durumunuzu görebilirsiniz. Şu anda çalıştığınız organizasyon Aktif olarak işaretlenir.',
        help_article_profile_h3: 'Kendi organizasyonunuzu oluşturma',
        help_article_profile_p3: '"Organizasyonumu oluştur"a tıklayarak yeni bir organizasyon başlatın. Zaten bir organizasyona sahipseniz düğme "Başka bir organizasyon oluştur" olarak görünür. Organizasyon adını girin ve onaylayın. Oluşturma sonrasında otomatik olarak Organizasyon Yöneticisi olursunuz, organizasyon aktif hale gelir ve Dentobook otomatik olarak ona geçer.',
        help_article_profile_h4: 'Profil tamamlama gereksinimi',
        help_article_profile_p4: 'Bir organizasyon oluşturmadan önce adınızın ve soyadınızın doldurulmuş olması gerekir. Bu alanlardan herhangi biri boşsa Dentobook işlemi engeller ve bir uyarı gösterir. Önce profilinizi tamamlayın, ardından organizasyon oluşturmaya devam edin.',
        help_category_notifications: 'Bildirimler ve Mesajlaşma',
        help_article_notif_overview_title: 'Bildirimlere Genel Bakış',
        help_article_notif_overview_desc: "Dentobook'un klinik personelini uygulama içindeki önemli etkinlikler hakkında nasıl bilgilendirdiği.",
        help_article_notif_overview_h1: 'Bildirimler nedir?',
        help_article_notif_overview_p1: "Dentobook, klinik personelini bildirimler aracılığıyla bilgilendirir. Bildirimler uygulama içinde görünür ve e-posta ile de gönderilebilir. Bildirimler; randevular, hastalar ve klinik faaliyetleriyle ilgili önemli olaylar tarafından tetiklenir.",
        help_article_notif_overview_h2: 'Uygulama içi bildirimler',
        help_article_notif_overview_p2: 'Bildirimler, üst gezinme çubuğundaki zil simgesi altında görünür. Rozet, okunmamış bildirim sayısını gösterir. Son etkinliği görmek için zile tıklayın. Panelin alt kısmındaki düğmeyi kullanarak tüm bildirimleri bir kerede okundu olarak işaretleyebilirsiniz.',
        help_article_notif_overview_p3: "Bir bildirimi tıklamak, ilgili kaydı açabilir, takvimdeki serbest kalan bir slotu vurgulayabilir ya da yalnızca bildirimi okundu olarak işaretleyebilir.",
        help_article_notif_overview_h3: 'Kim hangi bildirimleri alır?',
        help_article_notif_overview_p4: "Farklı kullanıcılar, rollerine ve faaliyete katılımlarına bağlı olarak farklı bildirimler alabilir. Klinik yöneticileri ek operasyonel bildirimler alabilir. Diğer personel genellikle doğrudan dahil oldukları randevular veya hastalarla ilgili bildirimleri alır. Portal erişimi olan hastalar da kendi randevularıyla ilgili bildirimler alabilir.",
        help_article_messaging_title: 'Mesajlaşma ve Twilio Kurulumu',
        help_article_messaging_desc: 'Twilio hesabınızı nasıl bağlayacağınızı ve hastalar için SMS ve WhatsApp bildirimlerini nasıl yapılandıracağınızı öğrenin.',
        help_article_messaging_h1: 'Mesajlaşma ne işe yarar?',
        help_article_messaging_p1: 'Dentobook, randevu onayları, hatırlatıcılar, yeniden planlama bildirimleri ve iptaller dahil olmak üzere hastalara otomatik bildirimler gönderebilir. Desteklenen kanallar SMS ve WhatsApp\'tır.',
        help_article_messaging_h2: 'Nasıl çalışır — Kendi Twilio Hesabınız',
        help_article_messaging_p2: 'Dentobook, mesaj göndermek için Twilio ile entegre olur ancak bir mesajlaşma sağlayıcısı olarak hareket etmez. Her klinik kendi Twilio hesabını bağlar ve Twilio\'ya doğrudan ödeme yapar. Dentobook mesaj başına ücret almaz ve mesajlaşma hizmetlerini yeniden satmaz.',
        help_article_messaging_h3: 'Mesajlaşma ayarları nerede?',
        help_article_messaging_p3: 'Organizasyon Ayarları\'na gidin ve Mesajlaşma sekmesini açın. Twilio henüz yapılandırılmamışsa, Kurulum Sihirbazı otomatik olarak görünür. Sihirbazı istediğiniz zaman Mesajlaşma sayfasından yeniden çalıştırabilirsiniz.',
        help_article_messaging_h4: 'Kurulum sihirbazı adımları',
        help_article_messaging_p4: 'Sihirbaz sizi altı adımda yönlendirir. Hoş geldiniz kurulumu tanıtır. Hesap, bir Twilio hesabınız olduğunu onaylamanızı ister. Kimlik bilgileri, Twilio Account SID ve Auth Token\'ınızı girdiğiniz yerdir — her ikisi de Twilio Konsolunda bulunur. Gönderenler, SMS telefon numaranızı ve isteğe bağlı olarak bir WhatsApp göndereni yapılandırdığınız yerdir. Test, her şeyin çalıştığını doğrulamak için bir test mesajı göndermenizi sağlar. Bitiş, SMS ve/veya WhatsApp kanallarını etkinleştirmenizi sağlar.',
        help_article_messaging_h5: 'SMS kurulumu',
        help_article_messaging_p5: 'SMS en kolay seçenektir. Bir Twilio hesabına ve bir Twilio telefon numarasına ihtiyacınız var. Numaranız sihirbazda yapılandırıldıktan sonra SMS hemen çalışır.',
        help_article_messaging_h6: 'WhatsApp kurulumu',
        help_article_messaging_p6: 'WhatsApp, bir Twilio hesabının ötesinde ek kayıt gerektirir. Test için Twilio WhatsApp Sandbox\'a katılmanız, ardından üretim kullanımı için bir WhatsApp göndereni kaydetmeniz gerekir. Gönderen onayı Twilio ve Meta tarafından yönetilir. SMS ile başlayıp daha sonra WhatsApp ekleyebilirsiniz.',
        help_article_messaging_h7: 'Güvenlik',
        help_article_messaging_p7: 'Twilio kimlik bilgileriniz depolama sırasında şifrelenir. Yalnızca kliniğinizin kendi Twilio hesabından mesaj göndermek için kullanılırlar. Dentobook kimlik bilgilerini düz metin olarak saklamaz.',
        help_article_messaging_h8: 'Fiyatlandırma',
        help_article_messaging_p8: 'Dentobook mesajlaşma için ücret almaz. Tüm mesaj maliyetleri, Twilio\'nun standart fiyatlandırmasına göre Twilio tarafından doğrudan kliniğinizin Twilio hesabına faturalandırılır.',
        help_article_messaging_h9: 'Sorun giderme',
        help_article_messaging_p9: 'Yaygın sorunlar: Geçersiz kimlik bilgileri — Twilio Konsolunda Account SID ve Auth Token\'ınızı doğrulayın. Telefon numarası çalışmıyor — numaranın Twilio hesabınızda aktif ve SMS özellikli olduğundan emin olun. WhatsApp göndermiyor — WhatsApp göndereninizin onaylanmış ve kayıtlı olduğunu doğrulayın. Sandbox\'a katılmamış — WhatsApp testi için önce Twilio Sandbox\'a katılmanız gerekir.',
        help_category_patients: 'Hastalar',
        help_article_patient_import_title: 'Hasta içe aktarma',
        help_article_patient_import_desc: 'Mevcut hasta listenizi Hızlı Giriş veya dosya yükleme ile Dentobook\'a nasıl aktaracağınız.',
        help_article_patient_import_h1: 'Genel bakış',
        help_article_patient_import_p1: 'Hastaları İçe Aktar sayfası birden fazla hastayı aynı anda eklemenizi sağlar. Tarayıcıda doğrudan en fazla 20 satır yazabilir veya yapıştırabilirsiniz (Hızlı Giriş) ya da istediğiniz sayıda satır içeren bir CSV veya Excel dosyası yükleyebilirsiniz.',
        help_article_patient_import_p2: 'Yalnızca Klinik Yöneticileri hasta içe aktarabilir. Başlamak için Hastalar → Hastaları İçe Aktar yolunu izleyin.',
        help_article_patient_import_h2: 'Hızlı Giriş',
        help_article_patient_import_p3: 'Hızlı Giriş ızgarası, küçük bir hasta grubunu içe aktarmanın en hızlı yoludur. Herhangi bir hücreye tıklayın ve yazmaya başlayın ya da Excel\'den veya başka bir elektronik tablodan kopyalanmış bir tablo yapıştırın. Sonraki sütuna geçmek için Tab, sonraki satıra geçmek için Enter veya aşağı ok tuşunu, ızgarayı genişletmek için "+ Satır ekle" düğmesini kullanın.',
        help_article_patient_import_p4: 'Kaydetmeden önce tüm satırları kontrol etmek için Doğrula\'ya tıklayın. Hata içeren satırlar kısa bir açıklamayla kırmızı renkte vurgulanır. Hataları düzeltin ve tekrar doğrulayın. Tüm satırlar yeşil gösterildiğinde İçe Aktar\'a tıklayın.',
        help_article_patient_import_h3: 'Dosyadan İçe Aktarma',
        help_article_patient_import_p5: 'Daha büyük listeler için sayfanın üst kısmından CSV veya Excel şablonunu indirin. Tercih ettiğiniz elektronik tablo programıyla doldurun ve Dosyadan İçe Aktarma sekmesiyle yükleyin. Dentobook, satırları kaydetmeden önce bir önizleme gösterir.',
        help_article_patient_import_p6: 'Telefon numaraları ve ulusal kimlik değerleri metin olarak girilmelidir. Excel\'de, veri girmeden önce bu sütunları Metin olarak biçimlendirin veya değerlerin önüne kesme işareti ekleyin. İndirilen Excel şablonunda bu sütunlar önceden biçimlendirilmiş durumdadır.',
        help_article_patient_import_h4: 'İçe aktarma sonuçlarını inceleme',
        help_article_patient_import_p7: 'İçe Aktar\'a tıkladıktan sonra her satır üç sonuçtan birini gösterir: İçe Aktarıldı (yeni hasta oluşturuldu), Kopya uyarısı (benzer bilgilere sahip bir hasta zaten mevcut — satır yine de içe aktarılır ancak inceleme için işaretlenir) veya Başarısız (zorunlu alan eksik veya geçersiz — satır atlanır).',
        help_article_patient_import_p8: 'Üstteki özet çubuğu içe aktarılan, atlanan ve başarısız olan satırların toplam sayısını gösterir. Başarısız satırları doğrudan ızgarada inceleyebilir ve baştan başlamadan düzeltebilirsiniz.',
        help_article_patient_import_h5: 'İçe aktarma geçmişi',
        help_article_patient_import_p9: 'Her içe aktarma oturumu kayıt altına alınır. Geçmiş içe aktarmaların zaman damgaları, satır sayıları ve işlemi yapan yöneticinin adıyla birlikte listesini görmek için sayfanın üst kısmındaki İçe aktarma geçmişini görüntüle\'ye tıklayın.',
        help_article_patient_import_p10: 'Geçmiş sayfası bir içe aktarma işlemini geri almanıza izin vermez. Yanlış içe aktarılan hastaları kaldırmanız gerekiyorsa her hasta kaydını açın ve manuel olarak silin ya da arşivleyin.',
        help_article_patient_import_h6: 'Özel bir format için yardıma mı ihtiyacınız var?',
        help_article_patient_import_p11: 'Mevcut yazılımınız hasta verilerini Dentobook şablonuyla eşleşmeyen bir formatta dışa aktarıyorsa, İçe Aktarma Hastaları sayfasındaki Yardıma mı ihtiyacınız var? sekmesini kullanın. Durumunuzu açıklayın ve örnek bir dosya ekleyin. Dentobook destek ekibi dosyanızı inceleyecek ve sütunları doğru şekilde eşlemenize yardımcı olacaktır.',
        help_article_patient_import_p12: 'Örnek dosyalar 30 gün boyunca saklanır ve ardından otomatik olarak silinir. Örnek dosyada asla gerçek hasta verisi bulundurmayın — mümkün olduğunda anonimleştirilmiş veya kurgusal kayıtlar kullanın.',
        org_switched_after_revoke: 'Erişiminiz iptal edildi. {orgName} organizasyonuna geçiş yapıldı.',
        messaging_settings: 'Mesajlaşma',
        messaging_settings_description: 'Randevu hatırlatıcılarının ne zaman gönderileceğini yapılandırın. Bildirimleri etkinleştirmek için kanal seçin ya da devre dışı bırakmak için Hiçbiri olarak bırakın.',
        messaging_timezone_info: 'Hatırlatıcı ofsetleri ve sessiz saatler, randevuya bağlı kliniğin yerel saat dilimiyle uygulanır. Organizasyonunuzda farklı saat dilimlerine sahip klinikler varsa, her klinik hatırlatıcıları kendi yerel saatinde gönderir.',
        email_notifications_enabled: 'E-posta bildirimlerini etkinleştir',
        default_notification_channel: 'Varsayılan kanal',
        channel_none: 'Hiçbiri (devre dışı)',
        channel_email: 'E-posta',
        channel_sms: 'SMS',
        channel_whatsapp: 'WhatsApp',
        reminder_offsets: 'Hatırlatıcı gönder',
        reminder_24h: '24 saat önce',
        reminder_2h: '2 saat önce',
        quiet_hours: 'Sessiz saatler (hatırlatıcı gönderilmez)',
        quiet_hours_hint: 'HH:MM formatında zaman girin (24 saatlik). Sessiz saatleri devre dışı bırakmak için boş bırakın.',
        messaging_quiet_hours_delay: 'Bir hatırlatıcı sessiz saatlere denk gelirse, Dentobook onu bir sonraki izin verilen zamanda otomatik olarak gönderir.',
        email_from_name: 'Gönderici görünen adı',
        email_from_address: 'Gönderici e-posta adresi',
        sms_enabled_label: 'SMS bildirimlerini etkinleştir',
        whatsapp_enabled_label: 'WhatsApp bildirimlerini etkinleştir',
        sms_whatsapp_status: 'SMS / WhatsApp kanalları',
        twilio_credentials_status: 'Twilio kimlik bilgileri',
        twilio_configured: 'Yapılandırıldı',
        twilio_not_configured: 'Yapılandırılmadı',
        twilio_credentials_note: 'Kimlik bilgileri kaydettikten sonra görüntülenmez. Mevcut değerleri korumak için alanları boş bırakın.',
        twilio_account_sid_label: 'Twilio Account SID',
        twilio_auth_token_label: 'Twilio Auth Token',
        twilio_sms_from_label: 'SMS gönderici numarası',
        twilio_whatsapp_from_label: 'WhatsApp gönderici numarası',
        twilio_from_hint: 'Twilio hesabınızdaki E.164 formatlı telefon numarası (ör. +905551234567)',
        twilio_credentials_saved_placeholder: 'Kaydedildi (mevcut değeri korumak için boş bırakın)',
        twilio_status_not_configured: 'Yapılandırılmadı',
        twilio_status_not_verified: 'Yapılandırıldı — doğrulanmadı',
        twilio_status_verified: 'Doğrulandı',
        twilio_status_failed: 'Doğrulama başarısız',
        twilio_verify_btn: 'Kimlik bilgilerini doğrula',
        twilio_verify_success: 'Twilio kimlik bilgileri başarıyla doğrulandı.',
        twilio_verify_failed: 'Twilio kimlik bilgisi doğrulaması başarısız oldu.',
        twilio_not_verified_channel_warning: 'Bu kanalı etkinleştirmeden önce Twilio kimlik bilgilerinizi doğrulayın.',
        messaging_saved: 'Mesajlaşma ayarları kaydedildi.',
        messaging_save_error: 'Mesajlaşma ayarları kaydedilemedi.',
        messaging_section_email: 'E-posta ve Hatırlatıcılar',
        messaging_section_sms: 'SMS',
        messaging_section_whatsapp: 'WhatsApp',
        messaging_section_twilio: 'Twilio Sağlayıcı',
        messaging_section_status: 'Mesajlaşma Durumu',
        status_provider: 'Sağlayıcı',
        status_sms: 'SMS',
        status_whatsapp: 'WhatsApp',
        status_ready: 'Hazır',
        status_not_enabled: 'Etkin değil',
        status_missing_sender: 'Gönderici eksik',
        status_not_configured: 'Yapılandırılmadı',
        status_sandbox_only: 'Yalnızca Sandbox',
        status_not_verified: 'Doğrulanmadı',
        status_next_action: 'Sonraki adım',
        next_action_run_wizard: 'Twilio\'yu bağlamak için kurulum sihirbazını çalıştırın',
        next_action_verify: 'Twilio kimlik bilgilerinizi doğrulayın',
        next_action_add_sms_sender: 'Bir SMS gönderici numarası ekleyin',
        next_action_add_whatsapp_sender: 'Bir WhatsApp gönderici ekleyin',
        next_action_enable_channel: 'En az bir kanalı etkinleştirin (SMS veya WhatsApp)',
        messaging_setup_complete: 'Mesajlaşma kurulumu',
        messaging_setup_percent: '{percent}% tamamlandı',
        twilio_info_box: 'SMS ve WhatsApp mesajları Twilio üzerinden gönderilir. Bu kanalları kullanmak için aktif bir telefon numarasına sahip bir Twilio hesabına ihtiyacınız var.',
        twilio_setup_guide: 'Twilio kurulumu için Twilio Console\'dan Account SID ve Auth Token\'a, ayrıca mesaj göndermek için bir telefon numarasına ihtiyacınız var.',
        twilio_link_console: 'Twilio Console (Account SID ve Auth Token)',
        twilio_link_sms: 'SMS telefon numarası kurulumu',
        twilio_link_whatsapp: 'WhatsApp gönderici kurulumu',
        twilio_credential_saved: 'Kaydedildi',
        twilio_credential_not_set: 'Ayarlanmadı',
        twilio_clear_credentials_btn: 'Kimlik bilgilerini temizle',
        twilio_clear_credentials_confirm: 'Kayıtlı Twilio kimlik bilgilerini temizlemek istediğinizden emin misiniz? SMS ve WhatsApp çalışmayı durduracak.',
        twilio_sid_masked: 'AC••••••••',
        preferred_notification_channel: 'Tercih edilen kanal',
        patient_email_allowed: 'E-posta izinli',
        patient_phone_allowed: 'Telefon mesajları izinli',
        patient_channel_helper: 'Randevu hatırlatmalarının ve diğer bildirimlerin bu hastaya nasıl iletileceğini kontrol eder.',
        wizard_step_intro: 'Hoş geldiniz',
        wizard_step_account: 'Hesap',
        wizard_step_credentials: 'Kimlik bilgileri',
        wizard_step_senders: 'Gönderenler',
        wizard_step_test: 'Test',
        wizard_step_finish: 'Bitir',
        wizard_intro_title: 'Randevu hatırlatmaları için mesajlaşmayı ayarlayın',
        wizard_intro_p1: 'Dentobook, hastalarınıza SMS ve WhatsApp mesajları göndermek için Twilio kullanır. Kliniğiniz kendi Twilio hesabını oluşturur ve doğrudan Twilio\'ya öder — Dentobook mesaj başına ücret almaz.',
        wizard_intro_p2: 'Bu sihirbaz, Twilio hesabınızı bağlama, gönderici numaralarını yapılandırma ve teslimatı test etme konusunda size rehberlik edecek.',
        wizard_intro_sms_easy: 'SMS kurulumu en kolaydır — sadece bir Twilio telefon numarasına ihtiyacınız var.',
        wizard_intro_whatsapp_note: 'WhatsApp, Twilio ve Meta aracılığıyla ek gönderici kaydı gerektirir. Gerekirse daha sonra ayarlayabilirsiniz.',
        wizard_start_setup: 'Kurulumu başlat',
        wizard_skip_for_now: 'Şimdilik atla',
        wizard_account_title: 'Twilio hesabınızı oluşturun veya açın',
        wizard_account_p1: 'Henüz bir Twilio hesabınız yoksa, aşağıdaki bağlantıyı kullanarak oluşturun. Twilio, test için ücretsiz deneme sunuyor.',
        wizard_account_p2: 'Hesabınız hazır olduğunda, Twilio Console panosundan Account SID ve Auth Token\'ınıza ihtiyacınız olacak.',
        wizard_create_twilio_account: 'Twilio hesabı oluştur',
        wizard_open_twilio_console: 'Twilio Console\'u aç',
        wizard_have_account: 'Twilio hesabım var',
        wizard_back: 'Geri',
        wizard_credentials_title: 'Twilio kimlik bilgilerinizi bağlayın',
        wizard_credentials_p1: 'Twilio Console\'dan Account SID ve Auth Token\'ı girin. Kimlik bilgileri güvenli bir şekilde saklanır ve şifrelenir.',
        wizard_credentials_find: 'Bunları şurada bulabilirsiniz:',
        wizard_save_and_verify: 'Kaydet ve doğrula',
        wizard_continue: 'Devam',
        wizard_senders_title: 'Gönderici numaralarını yapılandırın',
        wizard_sms_sender_help: 'Twilio hesabınızdaki SMS özellikli telefon numarasını girin. Bu numara SMS mesajlarında gönderici olarak görünecek.',
        wizard_whatsapp_sender_help: 'WhatsApp, kayıtlı bir gönderici numarası gerektirir. Bu, Twilio hesabınızda ek kurulum gerektirir.',
        wizard_test_title: 'Test mesajı gönderin',
        wizard_test_p1: 'Kurulumunuzun çalıştığını doğrulamak için bir test mesajı gönderin. Şu anda kontrol edebileceğiniz bir telefon numarası girin.',
        wizard_test_channel: 'Kanal',
        wizard_test_phone: 'Hedef telefon numarası',
        wizard_send_test: 'Test gönder',
        wizard_test_success: 'Test mesajı başarıyla gönderildi! Telefonunuzu kontrol edin.',
        wizard_test_failed: 'Test mesajı gönderilemedi.',
        wizard_finish_title: 'Mesajlaşma kurulumu tamamlandı!',
        wizard_finish_subtitle: 'Twilio hesabınız bağlandı. Hasta bildirimleri için hangi kanalları etkinleştireceğinizi seçin.',
        wizard_enable_channels: 'Kanalları etkinleştir',
        wizard_no_sms_sender: 'SMS gönderici yapılandırılmadı — SMS henüz etkinleştirilemez.',
        wizard_no_whatsapp_sender: 'WhatsApp gönderici yapılandırılmadı — WhatsApp henüz etkinleştirilemez.',
        wizard_finish_btn: 'Kurulumu bitir',
        wizard_rerun_btn: 'Kurulum sihirbazını çalıştır',
        // Patient import
        import_patients: 'Hasta İçe Aktarma',
        import_patients_desc: 'Manuel giriş veya dosya yükleme ile toplu hasta ekleyin.',
        import_v1_scope_notice: 'Yalnızca demografik veriler içe aktarılır. Randevular, tedaviler, faturalar ve tıbbi geçmiş dahil edilmez.',
        import_tab_quick_entry: 'Hızlı Giriş',
        import_tab_file: 'Dosya İçe Aktarma',
        import_tab_support: 'Yardım mı lazım?',
        import_quick_entry_hint: 'Herhangi bir hücreye odaklanıp Excel veya Google Sheets\'ten yapıştırın {ctrl}.{br}{tab} (önceki alan için {shiftTab}) ve {enter} ile gezinin veya fareyi dilediğiniz gibi kullanın.{br}Satır eklemek için {addRow}\'u tıklayın.{br}İpucu: yapıştırılan veriler odaklanılan hücreden sağa ve aşağıya doğru doldurulur.',
        import_add_row: 'Satır ekle',
        import_row_count: '{count} / {max} satır',
        import_paste_hint: 'İpucu: önce bir başlangıç hücresi seçin, ardından Excel veya Google Sheets\'ten yapıştırın (Ctrl+V). Yapıştırılan aralık sağa ve aşağıya doğru bitişik hücreleri doldurur.',
        import_validate_button: 'Sorunları kontrol et',
        import_commit_button: '{count} satırı içe aktar',
        import_commit_all_button: 'Tüm satırları içe aktar',
        import_clear_all: 'Tümünü temizle',
        import_validate_error: 'Doğrulama başarısız oldu. Lütfen tekrar deneyin.',
        import_commit_error: 'İçe aktarma başarısız oldu. Lütfen tekrar deneyin.',
        import_upload_error: 'Dosya yükleme başarısız oldu. Formatı kontrol edip tekrar deneyin.',
        import_parsing_file: 'Dosya işleniyor…',
        import_file_upload_hint: 'Dosyayı buraya tıklayın veya sürükleyin',
        import_file_upload_formats: '.csv ve .xlsx desteklenir — maks. 1.000 satır · maks. 5 MB',
        import_file_too_large: 'Dosya 5 MB sınırını aşıyor. Lütfen daha küçük dosyalara bölün.',
        import_file_too_many_rows: 'Dosya 1.000\'den fazla satır içeriyor. Lütfen daha küçük gruplara bölün.',
        import_total_rows: '{count} satır',
        import_valid_rows: '{count} geçerli',
        import_warning_rows: '{count} kimlik uyarısı',
        import_conflict_rows: '{count} kimlik uyarısı',
        import_commit_result: 'İçe aktarıldı {committed} · Başarısız {failed} · Atlandı {skipped}',
        import_download_template: 'Şablon indir',
        import_download_template_csv: 'CSV Şablonu',
        import_download_template_xlsx: 'Excel Şablonu',
        import_view_history: 'Geçmiş',
        import_history_title: 'İçe Aktarma Geçmişi',
        import_history_empty: 'Henüz içe aktarma oturumu yok.',
        import_history_date: 'Tarih',
        import_history_source: 'Kaynak',
        import_history_file: 'Dosya',
        import_history_total: 'Toplam',
        import_history_committed: 'İçe aktarıldı',
        import_history_warnings: 'Kimlik uyarıları',
        import_history_status: 'Durum',
        import_history_created_by: 'Oluşturan',
        import_history_back: 'İçe aktarmaya dön',
        import_history_load_error: 'İçe aktarma geçmişi yüklenemedi.',
        import_source_manual: 'Manuel',
        import_source_csv: 'CSV',
        import_source_excel: 'Excel',
        import_status_validated: 'Doğrulandı',
        import_status_committed: 'Tamamlandı',
        import_status_partial: 'Kısmi',
        import_status_draft: 'Taslak',
        import_duplicate_national_id_warning: 'Kimlik numarası veritabanında zaten mevcut — içe aktarmadan önce inceleyin.',
        import_upload_another: 'Başka bir dosya yükle',
        import_support_title: 'Farklı bir dışa aktarma formatı mı?',
        import_support_desc: 'Veri formatınızı açıklayın, uygun içe aktarma kurulumunu ücretsiz yapmanıza yardımcı olalım. Hesabınızın e-posta adresine yanıt vereceğiz.',
        import_support_message_label: 'Formatınızı açıklayın',
        import_support_message_placeholder: 'Dışa aktardığınız sistemi ve dosyanızdaki sütunları açıklayın…',
        import_support_file_label: 'Örnek dosya (isteğe bağlı)',
        import_support_file_hint: 'Örnek dosyayı buraya bırakın veya seçmek için tıklayın',
        import_support_submit: 'Talep gönder',
        import_support_sent: 'Talep gönderildi!',
        import_support_sent_desc: '1–2 iş günü içinde hesabınızın e-posta adresine geri döneceğiz.',
        import_support_error: 'Talep gönderilemedi. Lütfen tekrar deneyin.',
        import_support_org_label: 'Kuruluşa içe aktar',
        import_support_org_placeholder: 'Kuruluş seçin',
        import_support_org_load_error: 'Kuruluşlarınız yüklenemedi. Lütfen sayfayı yenileyip tekrar deneyin.',
        import_support_org_not_specified: 'Belirtilmemiş',
        import_row_status_draft: 'Taslak',
        import_row_status_valid: 'Geçerli',
        import_row_status_invalid: 'Geçersiz',
        import_row_status_duplicate_warning: 'Kopya?',
        import_row_status_conflict: 'Çakışma',
        import_row_status_saving: 'Kaydediliyor…',
        import_row_status_saved: 'Kaydedildi',
        import_row_status_failed: 'Başarısız',
        import_row_status_skipped: 'Atlandı',
        import_fix_n_issues: '{count} sorunu düzeltin',
        gender_other: 'Diğer',
        national_id_label: 'Ulusal Kimlik',
        full_name: 'Ad soyad',
        field_required: 'Bu alan zorunludur',
    }
}
